export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Define a Relay Cursor type:
   * https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  Cursor: { input: any; output: any; }
  DateOnly: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
  NullString: { input: any; output: any; }
  /** The builtin Time type */
  Time: { input: any; output: any; }
  TimeOnly: { input: any; output: any; }
};

export type ApiUser = Node & {
  __typename?: 'APIUser';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type ApiUserConnection = {
  __typename?: 'APIUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApiUserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApiUserEdge = {
  __typename?: 'APIUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ApiUser>;
};

export enum ApiUserField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Key = 'key',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for APIUser connections */
export type ApiUserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order APIUsers. */
  field: ApiUserOrderField;
};

/** Properties by which APIUser connections can be ordered. */
export enum ApiUserOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * APIUserWhereInput is used for filtering APIUser objects.
 * Input was generated by ent.
 */
export type ApiUserWhereInput = {
  and?: InputMaybe<Array<ApiUserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ApiUserWhereInput>;
  or?: InputMaybe<Array<ApiUserWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BaseAddon = Node & {
  __typename?: 'BaseAddon';
  baselicenseplanaddon?: Maybe<Array<BaseLicensePlanAddon>>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseAddonConnection = {
  __typename?: 'BaseAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseAddonEdge = {
  __typename?: 'BaseAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseAddon>;
};

export enum BaseAddonField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Icon = 'icon',
  IntegrationCode = 'integrationCode',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseAddon connections */
export type BaseAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseAddons. */
  field: BaseAddonOrderField;
};

/** Properties by which BaseAddon connections can be ordered. */
export enum BaseAddonOrderField {
  Description = 'DESCRIPTION',
  Icon = 'ICON',
  IntegrationCode = 'INTEGRATION_CODE',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseAddonWhereInput is used for filtering BaseAddon objects.
 * Input was generated by ent.
 */
export type BaseAddonWhereInput = {
  and?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** baselicenseplanaddon edge predicates */
  hasBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** icon field predicates */
  icon?: InputMaybe<Scalars['String']['input']>;
  iconContains?: InputMaybe<Scalars['String']['input']>;
  iconContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconGT?: InputMaybe<Scalars['String']['input']>;
  iconGTE?: InputMaybe<Scalars['String']['input']>;
  iconHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconLT?: InputMaybe<Scalars['String']['input']>;
  iconLTE?: InputMaybe<Scalars['String']['input']>;
  iconNEQ?: InputMaybe<Scalars['String']['input']>;
  iconNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_code field predicates */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContains?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCodeLT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeLTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<BaseAddonWhereInput>;
  or?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type BaseLicensePlan = Node & {
  __typename?: 'BaseLicensePlan';
  baselicenseplanaddon?: Maybe<Array<BaseLicensePlanAddon>>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  licenseOrders?: Maybe<Array<SubscriptionLicenseOrder>>;
  module: BaseLicensePlanModule;
  name: Scalars['String']['output'];
  organisations?: Maybe<Array<Organisation>>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  tenureUnit: BaseLicensePlanTenureUnit;
  updatedAt: Scalars['Time']['output'];
};

export type BaseLicensePlanAddon = Node & {
  __typename?: 'BaseLicensePlanAddon';
  addonID: Scalars['ID']['output'];
  baseLicensePlanID: Scalars['ID']['output'];
  baseaddon: BaseAddon;
  baselicenseplan: BaseLicensePlan;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  licenseorderaddons?: Maybe<Array<LicenseOrderAddon>>;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseLicensePlanAddonConnection = {
  __typename?: 'BaseLicensePlanAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseLicensePlanAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseLicensePlanAddonEdge = {
  __typename?: 'BaseLicensePlanAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseLicensePlanAddon>;
};

export enum BaseLicensePlanAddonField {
  AddonId = 'addonID',
  BaseLicensePlanId = 'baseLicensePlanID',
  CreatedAt = 'createdAt',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseLicensePlanAddon connections */
export type BaseLicensePlanAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseLicensePlanAddons. */
  field: BaseLicensePlanAddonOrderField;
};

/** Properties by which BaseLicensePlanAddon connections can be ordered. */
export enum BaseLicensePlanAddonOrderField {
  Price = 'PRICE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseLicensePlanAddonWhereInput is used for filtering BaseLicensePlanAddon objects.
 * Input was generated by ent.
 */
export type BaseLicensePlanAddonWhereInput = {
  /** addon_id field predicates */
  addonID?: InputMaybe<Scalars['ID']['input']>;
  addonIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  addonIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** base_license_plan_id field predicates */
  baseLicensePlanID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** baseaddon edge predicates */
  hasBaseaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaseaddonWith?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** licenseorderaddons edge predicates */
  hasLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderaddonsWith?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BaseLicensePlanAddonWhereInput>;
  or?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type BaseLicensePlanConnection = {
  __typename?: 'BaseLicensePlanConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseLicensePlanEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseLicensePlanEdge = {
  __typename?: 'BaseLicensePlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseLicensePlan>;
};

export enum BaseLicensePlanField {
  CreatedAt = 'createdAt',
  Description = 'description',
  GracePeriodDays = 'gracePeriodDays',
  IsActive = 'isActive',
  Module = 'module',
  Name = 'name',
  Price = 'price',
  Tenure = 'tenure',
  TenureUnit = 'tenureUnit',
  UpdatedAt = 'updatedAt'
}

/** BaseLicensePlanModule is enum for the field module */
export enum BaseLicensePlanModule {
  Bolt = 'Bolt',
  Eta = 'Eta',
  Yard = 'Yard'
}

/** Ordering options for BaseLicensePlan connections */
export type BaseLicensePlanOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseLicensePlans. */
  field: BaseLicensePlanOrderField;
};

/** Properties by which BaseLicensePlan connections can be ordered. */
export enum BaseLicensePlanOrderField {
  Description = 'DESCRIPTION',
  Module = 'MODULE',
  Name = 'NAME',
  Price = 'PRICE',
  Tenure = 'TENURE',
  TenureUnit = 'TENURE_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** BaseLicensePlanTenureUnit is enum for the field tenure_unit */
export enum BaseLicensePlanTenureUnit {
  Month = 'Month',
  Year = 'Year'
}

/**
 * BaseLicensePlanWhereInput is used for filtering BaseLicensePlan objects.
 * Input was generated by ent.
 */
export type BaseLicensePlanWhereInput = {
  and?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** grace_period_days field predicates */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  gracePeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** baselicenseplanaddon edge predicates */
  hasBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** license_orders edge predicates */
  hasLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrdersWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisations edge predicates */
  hasOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** module field predicates */
  module?: InputMaybe<BaseLicensePlanModule>;
  moduleIn?: InputMaybe<Array<BaseLicensePlanModule>>;
  moduleNEQ?: InputMaybe<BaseLicensePlanModule>;
  moduleNotIn?: InputMaybe<Array<BaseLicensePlanModule>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<BaseLicensePlanWhereInput>;
  or?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** tenure field predicates */
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureGT?: InputMaybe<Scalars['Int']['input']>;
  tenureGTE?: InputMaybe<Scalars['Int']['input']>;
  tenureIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenureLT?: InputMaybe<Scalars['Int']['input']>;
  tenureLTE?: InputMaybe<Scalars['Int']['input']>;
  tenureNEQ?: InputMaybe<Scalars['Int']['input']>;
  tenureNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** tenure_unit field predicates */
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  tenureUnitIn?: InputMaybe<Array<BaseLicensePlanTenureUnit>>;
  tenureUnitNEQ?: InputMaybe<BaseLicensePlanTenureUnit>;
  tenureUnitNotIn?: InputMaybe<Array<BaseLicensePlanTenureUnit>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type BaseReport = Node & {
  __typename?: 'BaseReport';
  chartConfig: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  currentDateReport: Scalars['Boolean']['output'];
  derivedReports?: Maybe<Array<DerivedReport>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputConfig: Scalars['JSON']['output'];
  mapConfig: Scalars['JSON']['output'];
  multiDateMultiRequest: Scalars['Boolean']['output'];
  multiDevice: Scalars['Boolean']['output'];
  multiDeviceMultiRequest: Scalars['Boolean']['output'];
  resolver: Scalars['String']['output'];
  tableConfig: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseReportConnection = {
  __typename?: 'BaseReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseReportEdge = {
  __typename?: 'BaseReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseReport>;
};

export enum BaseReportField {
  ChartConfig = 'chartConfig',
  CreatedAt = 'createdAt',
  CurrentDateReport = 'currentDateReport',
  Description = 'description',
  InputConfig = 'inputConfig',
  MapConfig = 'mapConfig',
  MultiDateMultiRequest = 'multiDateMultiRequest',
  MultiDevice = 'multiDevice',
  MultiDeviceMultiRequest = 'multiDeviceMultiRequest',
  Resolver = 'resolver',
  TableConfig = 'tableConfig',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseReport connections */
export type BaseReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseReports. */
  field: BaseReportOrderField;
};

/** Properties by which BaseReport connections can be ordered. */
export enum BaseReportOrderField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Resolver = 'resolver',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseReportWhereInput is used for filtering BaseReport objects.
 * Input was generated by ent.
 */
export type BaseReportWhereInput = {
  and?: InputMaybe<Array<BaseReportWhereInput>>;
  /** chart_config field predicates */
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  chartConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_date_report field predicates */
  currentDateReport?: InputMaybe<Scalars['Boolean']['input']>;
  currentDateReportNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** derived_reports edge predicates */
  hasDerivedReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportsWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** input_config field predicates */
  inputConfig?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  inputConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** map_config field predicates */
  mapConfig?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  mapConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** multi_date_multi_request field predicates */
  multiDateMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDateMultiRequestNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** multi_device field predicates */
  multiDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** multi_device_multi_request field predicates */
  multiDeviceMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceMultiRequestNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BaseReportWhereInput>;
  or?: InputMaybe<Array<BaseReportWhereInput>>;
  /** resolver field predicates */
  resolver?: InputMaybe<Scalars['String']['input']>;
  resolverContains?: InputMaybe<Scalars['String']['input']>;
  resolverContainsFold?: InputMaybe<Scalars['String']['input']>;
  resolverEqualFold?: InputMaybe<Scalars['String']['input']>;
  resolverGT?: InputMaybe<Scalars['String']['input']>;
  resolverGTE?: InputMaybe<Scalars['String']['input']>;
  resolverHasPrefix?: InputMaybe<Scalars['String']['input']>;
  resolverHasSuffix?: InputMaybe<Scalars['String']['input']>;
  resolverIn?: InputMaybe<Array<Scalars['String']['input']>>;
  resolverLT?: InputMaybe<Scalars['String']['input']>;
  resolverLTE?: InputMaybe<Scalars['String']['input']>;
  resolverNEQ?: InputMaybe<Scalars['String']['input']>;
  resolverNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** table_config field predicates */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  tableConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ChangeLog = Node & {
  __typename?: 'ChangeLog';
  action: ChangeLogAction;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  impersonatedUserID?: Maybe<Scalars['ID']['output']>;
  modelID: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
  organisationID?: Maybe<Scalars['ID']['output']>;
  previousData?: Maybe<Scalars['JSON']['output']>;
  remoteIP?: Maybe<Scalars['NullString']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedData?: Maybe<Scalars['JSON']['output']>;
  userAgent?: Maybe<Scalars['NullString']['output']>;
  userID?: Maybe<Scalars['ID']['output']>;
};

/** ChangeLogAction is enum for the field action */
export enum ChangeLogAction {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/** A connection to a list of items. */
export type ChangeLogConnection = {
  __typename?: 'ChangeLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChangeLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChangeLogEdge = {
  __typename?: 'ChangeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChangeLog>;
};

export enum ChangeLogField {
  Action = 'action',
  CreatedAt = 'createdAt',
  ImpersonatedUserId = 'impersonatedUserID',
  ModelId = 'modelID',
  ModelName = 'modelName',
  OrganisationId = 'organisationID',
  PreviousData = 'previousData',
  RemoteIp = 'remoteIP',
  UpdatedAt = 'updatedAt',
  UpdatedData = 'updatedData',
  UserAgent = 'userAgent',
  UserId = 'userID'
}

/** Ordering options for ChangeLog connections */
export type ChangeLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ChangeLogs. */
  field: ChangeLogOrderField;
};

/** Properties by which ChangeLog connections can be ordered. */
export enum ChangeLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  ModelName = 'modelName',
  RemoteIp = 'remoteIP',
  UpdatedAt = 'updatedAt',
  UserAgent = 'userAgent'
}

/**
 * ChangeLogWhereInput is used for filtering ChangeLog objects.
 * Input was generated by ent.
 */
export type ChangeLogWhereInput = {
  /** action field predicates */
  action?: InputMaybe<ChangeLogAction>;
  actionIn?: InputMaybe<Array<ChangeLogAction>>;
  actionNEQ?: InputMaybe<ChangeLogAction>;
  actionNotIn?: InputMaybe<Array<ChangeLogAction>>;
  and?: InputMaybe<Array<ChangeLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** impersonated_user_id field predicates */
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** model_id field predicates */
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelIDGT?: InputMaybe<Scalars['ID']['input']>;
  modelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  modelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelIDLT?: InputMaybe<Scalars['ID']['input']>;
  modelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  modelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  modelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** model_name field predicates */
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelNameContains?: InputMaybe<Scalars['String']['input']>;
  modelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  modelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  modelNameGT?: InputMaybe<Scalars['String']['input']>;
  modelNameGTE?: InputMaybe<Scalars['String']['input']>;
  modelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  modelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  modelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  modelNameLT?: InputMaybe<Scalars['String']['input']>;
  modelNameLTE?: InputMaybe<Scalars['String']['input']>;
  modelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  modelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ChangeLogWhereInput>;
  or?: InputMaybe<Array<ChangeLogWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** previous_data field predicates */
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  previousDataGT?: InputMaybe<Scalars['JSON']['input']>;
  previousDataGTE?: InputMaybe<Scalars['JSON']['input']>;
  previousDataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  previousDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  previousDataLT?: InputMaybe<Scalars['JSON']['input']>;
  previousDataLTE?: InputMaybe<Scalars['JSON']['input']>;
  previousDataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  previousDataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  previousDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** remote_ip field predicates */
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPGT?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPGTE?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  remoteIPIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remoteIPLT?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPLTE?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPNEQ?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPNotIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  remoteIPNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_data field predicates */
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataGT?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataGTE?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  updatedDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDataLT?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataLTE?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  updatedDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userAgentGT?: InputMaybe<Scalars['NullString']['input']>;
  userAgentGTE?: InputMaybe<Scalars['NullString']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['NullString']['input']>;
  userAgentLTE?: InputMaybe<Scalars['NullString']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['NullString']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerConfig = Node & {
  __typename?: 'ConsumerConfig';
  active: Scalars['Boolean']['output'];
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  apiSkipSsl: Scalars['Boolean']['output'];
  apiTimeoutSeconds: Scalars['Int']['output'];
  apiURL?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastResponse?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['Time']['output']>;
  periodicSeconds: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
  vehicleNameAsImei: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type ConsumerConfigConnection = {
  __typename?: 'ConsumerConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConsumerConfigEdge = {
  __typename?: 'ConsumerConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerConfig>;
};

export enum ConsumerConfigField {
  Active = 'active',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  ApiSkipSsl = 'apiSkipSsl',
  ApiTimeoutSeconds = 'apiTimeoutSeconds',
  ApiUrl = 'apiURL',
  Config = 'config',
  CreatedAt = 'createdAt',
  LastFailedAt = 'lastFailedAt',
  LastResponse = 'lastResponse',
  LastSuccessAt = 'lastSuccessAt',
  Name = 'name',
  NextAttemptAt = 'nextAttemptAt',
  PeriodicSeconds = 'periodicSeconds',
  TaskName = 'taskName',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  VehicleNameAsImei = 'vehicleNameAsImei'
}

/** Ordering options for ConsumerConfig connections */
export type ConsumerConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ConsumerConfigs. */
  field: ConsumerConfigOrderField;
};

/** Properties by which ConsumerConfig connections can be ordered. */
export enum ConsumerConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ConsumerConfigWhereInput is used for filtering ConsumerConfig objects.
 * Input was generated by ent.
 */
export type ConsumerConfigWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ConsumerConfigWhereInput>>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_skip_ssl field predicates */
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiSkipSslNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_timeout_seconds field predicates */
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  apiTimeoutSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** api_url field predicates */
  apiURL?: InputMaybe<Scalars['String']['input']>;
  apiURLContains?: InputMaybe<Scalars['String']['input']>;
  apiURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiURLGT?: InputMaybe<Scalars['String']['input']>;
  apiURLGTE?: InputMaybe<Scalars['String']['input']>;
  apiURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiURLLT?: InputMaybe<Scalars['String']['input']>;
  apiURLLTE?: InputMaybe<Scalars['String']['input']>;
  apiURLNEQ?: InputMaybe<Scalars['String']['input']>;
  apiURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** config field predicates */
  config?: InputMaybe<Scalars['JSON']['input']>;
  configGT?: InputMaybe<Scalars['JSON']['input']>;
  configGTE?: InputMaybe<Scalars['JSON']['input']>;
  configIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  configLT?: InputMaybe<Scalars['JSON']['input']>;
  configLTE?: InputMaybe<Scalars['JSON']['input']>;
  configNEQ?: InputMaybe<Scalars['JSON']['input']>;
  configNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_response field predicates */
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastResponseContains?: InputMaybe<Scalars['String']['input']>;
  lastResponseContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseGT?: InputMaybe<Scalars['String']['input']>;
  lastResponseGTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastResponseIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastResponseLT?: InputMaybe<Scalars['String']['input']>;
  lastResponseLTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseNEQ?: InputMaybe<Scalars['String']['input']>;
  lastResponseNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_attempt_at field predicates */
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConsumerConfigWhereInput>;
  or?: InputMaybe<Array<ConsumerConfigWhereInput>>;
  /** periodic_seconds field predicates */
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vehicle_name_as_imei field predicates */
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleNameAsImeiNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerServer = Node & {
  __typename?: 'ConsumerServer';
  active: Scalars['Boolean']['output'];
  allowedImei: Array<Scalars['String']['output']>;
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastFailedImei?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  lastSuccessImei?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type ConsumerServerConnection = {
  __typename?: 'ConsumerServerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerServerEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConsumerServerEdge = {
  __typename?: 'ConsumerServerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerServer>;
};

export enum ConsumerServerField {
  Active = 'active',
  AllowedImei = 'allowedImei',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  CreatedAt = 'createdAt',
  LastFailedAt = 'lastFailedAt',
  LastFailedImei = 'lastFailedImei',
  LastSuccessAt = 'lastSuccessAt',
  LastSuccessImei = 'lastSuccessImei',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for ConsumerServer connections */
export type ConsumerServerOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ConsumerServers. */
  field: ConsumerServerOrderField;
};

/** Properties by which ConsumerServer connections can be ordered. */
export enum ConsumerServerOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ConsumerServerWhereInput is used for filtering ConsumerServer objects.
 * Input was generated by ent.
 */
export type ConsumerServerWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ConsumerServerWhereInput>>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_failed_imei field predicates */
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiContains?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiGT?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiGTE?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFailedImeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedImeiLT?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiLTE?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiNEQ?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFailedImeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_imei field predicates */
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiContains?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiGT?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiGTE?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastSuccessImeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessImeiLT?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiLTE?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiNEQ?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastSuccessImeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConsumerServerWhereInput>;
  or?: InputMaybe<Array<ConsumerServerWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateAPIUserInput is used for create APIUser object.
 * Input was generated by ent.
 */
export type CreateApiUserInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateBaseAddonInput is used for create BaseAddon object.
 * Input was generated by ent.
 */
export type CreateBaseAddonInput = {
  baselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  integrationCode: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseLicensePlanAddonInput is used for create BaseLicensePlanAddon object.
 * Input was generated by ent.
 */
export type CreateBaseLicensePlanAddonInput = {
  baseaddonID: Scalars['ID']['input'];
  baselicenseplanID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  licenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseLicensePlanInput is used for create BaseLicensePlan object.
 * Input was generated by ent.
 */
export type CreateBaseLicensePlanInput = {
  baselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  licenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  module: BaseLicensePlanModule;
  name: Scalars['String']['input'];
  organisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  price: Scalars['Float']['input'];
  tenure: Scalars['Int']['input'];
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseReportInput is used for create BaseReport object.
 * Input was generated by ent.
 */
export type CreateBaseReportInput = {
  chartConfig: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currentDateReport: Scalars['Boolean']['input'];
  derivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  inputConfig: Scalars['JSON']['input'];
  mapConfig: Scalars['JSON']['input'];
  multiDateMultiRequest: Scalars['Boolean']['input'];
  multiDevice: Scalars['Boolean']['input'];
  multiDeviceMultiRequest: Scalars['Boolean']['input'];
  resolver: Scalars['String']['input'];
  tableConfig: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateChangeLogInput is used for create ChangeLog object.
 * Input was generated by ent.
 */
export type CreateChangeLogInput = {
  action?: InputMaybe<ChangeLogAction>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  modelID: Scalars['ID']['input'];
  modelName: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateConsumerConfigInput is used for create ConsumerConfig object.
 * Input was generated by ent.
 */
export type CreateConsumerConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  taskName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateConsumerServerInput is used for create ConsumerServer object.
 * Input was generated by ent.
 */
export type CreateConsumerServerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedImei: Array<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateDerivedReportInput is used for create DerivedReport object.
 * Input was generated by ent.
 */
export type CreateDerivedReportInput = {
  baseReportID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableConfig: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDeviceACLInput is used for create DeviceACL object.
 * Input was generated by ent.
 */
export type CreateDeviceAclInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicegroupsID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organisationUserID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceActionLogInput is used for create DeviceActionLog object.
 * Input was generated by ent.
 */
export type CreateDeviceActionLogInput = {
  actionDescription: Scalars['String']['input'];
  actionType?: InputMaybe<DeviceActionLogActionType>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicesID: Scalars['ID']['input'];
  status?: InputMaybe<DeviceActionLogStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceAddonModelInput is used for create DeviceAddonModel object.
 * Input was generated by ent.
 */
export type CreateDeviceAddonModelInput = {
  addonType: DeviceAddonModelAddonType;
  channelType: DeviceAddonModelChannelType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceAdvancedConfigInput is used for create DeviceAdvancedConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceAdvancedConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
};

/**
 * CreateDeviceCategoryInput is used for create DeviceCategory object.
 * Input was generated by ent.
 */
export type CreateDeviceCategoryInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<DeviceCategoryType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceChannelConfigInput is used for create DeviceChannelConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceChannelConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  deviceaddonmodelID: Scalars['ID']['input'];
  devicemodelchannelID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceCommandInput is used for create DeviceCommand object.
 * Input was generated by ent.
 */
export type CreateDeviceCommandInput = {
  command: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  deviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceDocumentInput is used for create DeviceDocument object.
 * Input was generated by ent.
 */
export type CreateDeviceDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentTypeID: Scalars['ID']['input'];
  deviceID: Scalars['ID']['input'];
  expiryDate: Scalars['Time']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceDocumentTypeInput is used for create DeviceDocumentType object.
 * Input was generated by ent.
 */
export type CreateDeviceDocumentTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupDocumentInput is used for create DeviceGroupDocument object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentTypeID: Scalars['ID']['input'];
  deviceGroupID: Scalars['ID']['input'];
  expiryDate: Scalars['Time']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupDocumentTypeInput is used for create DeviceGroupDocumentType object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupDocumentTypeInput = {
  applicableGroupType: DeviceGroupDocumentTypeApplicableGroupType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupInput is used for create DeviceGroup object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceVehicleID?: InputMaybe<Scalars['ID']['input']>;
  deviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupOrganisationID: Scalars['ID']['input'];
  devicegroupRootOrganisationID: Scalars['ID']['input'];
  driverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  friendlyName: Scalars['String']['input'];
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupType: DeviceGroupGroupType;
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDeviceInput is used for create Device object.
 * Input was generated by ent.
 */
export type CreateDeviceInput = {
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicecategoryID: Scalars['ID']['input'];
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicemodelID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  imei: Scalars['String']['input'];
  ingestServer?: InputMaybe<DeviceIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  licenseID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  rootOrganisationID: Scalars['ID']['input'];
  simID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceModelChannelInput is used for create DeviceModelChannel object.
 * Input was generated by ent.
 */
export type CreateDeviceModelChannelInput = {
  channelName: Scalars['String']['input'];
  channelType: DeviceModelChannelChannelType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceModelID: Scalars['ID']['input'];
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isBuiltin: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceModelInput is used for create DeviceModel object.
 * Input was generated by ent.
 */
export type CreateDeviceModelInput = {
  commandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer: Scalars['String']['input'];
  mediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceParkingModeConfigInput is used for create DeviceParkingModeConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceParkingModeConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceSharingInput is used for create DeviceSharing object.
 * Input was generated by ent.
 */
export type CreateDeviceSharingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationUserID: Scalars['ID']['input'];
  shareType?: InputMaybe<DeviceSharingShareType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceVehicleInput is used for create DeviceVehicle object.
 * Input was generated by ent.
 */
export type CreateDeviceVehicleInput = {
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dealer?: InputMaybe<Scalars['String']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  oem?: InputMaybe<Scalars['String']['input']>;
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber: Scalars['String']['input'];
  vehicleType: DeviceVehicleVehicleType;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateDomainInput is used for create Domain object.
 * Input was generated by ent.
 */
export type CreateDomainInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  domain: Scalars['String']['input'];
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateExportInput is used for create Export object.
 * Input was generated by ent.
 */
export type CreateExportInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  exportData: Scalars['String']['input'];
  exportKey: Scalars['String']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ExportStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateFirebasePrivateKeyInput is used for create FirebasePrivateKey object.
 * Input was generated by ent.
 */
export type CreateFirebasePrivateKeyInput = {
  authProviderX509CertURL: Scalars['String']['input'];
  authURI: Scalars['String']['input'];
  clientEmail: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  clientX509CertURL: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileName: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  privateKeyID: Scalars['String']['input'];
  projectID: Scalars['String']['input'];
  senderID?: InputMaybe<Scalars['String']['input']>;
  tokenURI: Scalars['String']['input'];
  type: Scalars['String']['input'];
  universeDomain: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateGeofenceDeviceGroupInput is used for create GeofenceDeviceGroup object.
 * Input was generated by ent.
 */
export type CreateGeofenceDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicegroupID: Scalars['ID']['input'];
  geofenceID: Scalars['ID']['input'];
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateGeofenceInput is used for create Geofence object.
 * Input was generated by ent.
 */
export type CreateGeofenceInput = {
  color: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  radius: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateKmlInput is used for create Kml object.
 * Input was generated by ent.
 */
export type CreateKmlInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLegacySyncInput is used for create LegacySync object.
 * Input was generated by ent.
 */
export type CreateLegacySyncInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LegacySyncStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  syncData: Scalars['String']['input'];
  syncKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLicenseInput is used for create License object.
 * Input was generated by ent.
 */
export type CreateLicenseInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  licenseOrderID: Scalars['ID']['input'];
  moduleType: LicenseModuleType;
  organisationID: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<LicenseStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLicenseOrderAddonInput is used for create LicenseOrderAddon object.
 * Input was generated by ent.
 */
export type CreateLicenseOrderAddonInput = {
  baselicenseaddonID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  licenseorderID: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLoginLogInput is used for create LoginLog object.
 * Input was generated by ent.
 */
export type CreateLoginLogInput = {
  attempts: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  identifier: Scalars['String']['input'];
  identifierType: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateMapConfigInput is used for create MapConfig object.
 * Input was generated by ent.
 */
export type CreateMapConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: MapConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/**
 * CreateMediaFileInput is used for create MediaFile object.
 * Input was generated by ent.
 */
export type CreateMediaFileInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  exportID?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  kmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  status?: InputMaybe<MediaFileStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  userAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateNotifyChannelInput is used for create NotifyChannel object.
 * Input was generated by ent.
 */
export type CreateNotifyChannelInput = {
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  kind: NotifyChannelKind;
  linkedData: Scalars['String']['input'];
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigChannelInput is used for create NotifyConfigChannel object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigChannelInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notifyChannelID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigDeviceGroupInput is used for create NotifyConfigDeviceGroup object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigEventInput is used for create NotifyConfigEvent object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigEventInput = {
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  notifyConfigID: Scalars['ID']['input'];
  notifyEventOptionID: Scalars['ID']['input'];
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * CreateNotifyConfigGeofenceInput is used for create NotifyConfigGeofence object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigGeofenceInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  geofenceID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigInput is used for create NotifyConfig object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigInput = {
  alertWindow: Scalars['Boolean']['input'];
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  autoAddNewDevices: Scalars['Boolean']['input'];
  autoAddNewGeofences: Scalars['Boolean']['input'];
  channelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  enabled: Scalars['Boolean']['input'];
  eventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ignoreDuplicateForSeconds: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<NotifyConfigPriority>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyEventOptionInput is used for create NotifyEventOption object.
 * Input was generated by ent.
 */
export type CreateNotifyEventOptionInput = {
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMaxLabel: Scalars['String']['input'];
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMinLabel: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMetersLabel: Scalars['String']['input'];
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceToleranceMetersLabel: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  /** Source of event for backend processing */
  kind?: InputMaybe<NotifyEventOptionKind>;
  /** label to display in UI */
  label: Scalars['String']['input'];
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  speedToleranceKnotsLabel: Scalars['String']['input'];
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  timeToleranceSecondsLabel: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  waitTimeSecondsLabel: Scalars['String']['input'];
};

/**
 * CreateOrganisationInput is used for create Organisation object.
 * Input was generated by ent.
 */
export type CreateOrganisationInput = {
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  baselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  exportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  legacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  organisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  organisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  simIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  yardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateOrganisationReportAccessInput is used for create OrganisationReportAccess object.
 * Input was generated by ent.
 */
export type CreateOrganisationReportAccessInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  derivedReportID: Scalars['ID']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationRoleInput is used for create OrganisationRole object.
 * Input was generated by ent.
 */
export type CreateOrganisationRoleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  organisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateOrganisationRolePermissionInput is used for create OrganisationRolePermission object.
 * Input was generated by ent.
 */
export type CreateOrganisationRolePermissionInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  organisationRoleID: Scalars['ID']['input'];
  permissionID: Scalars['ID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationUpgradeInput is used for create OrganisationUpgrade object.
 * Input was generated by ent.
 */
export type CreateOrganisationUpgradeInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endDate: Scalars['Time']['input'];
  organisationID: Scalars['ID']['input'];
  startDate: Scalars['Time']['input'];
  status?: InputMaybe<OrganisationUpgradeStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID: Scalars['ID']['input'];
};

/**
 * CreateOrganisationUserDocumentInput is used for create OrganisationUserDocument object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserDocumentInput = {
  attachment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationuserID: Scalars['ID']['input'];
  organisationuserdocumenttypeID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateOrganisationUserDocumentTypeInput is used for create OrganisationUserDocumentType object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserDocumentTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationUserInput is used for create OrganisationUser object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserInput = {
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverprofilesID?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  userType?: InputMaybe<OrganisationUserUserType>;
};

/**
 * CreatePeriodicJobInput is used for create PeriodicJob object.
 * Input was generated by ent.
 */
export type CreatePeriodicJobInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  queueName: Scalars['String']['input'];
  schedule: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePermissionInput is used for create Permission object.
 * Input was generated by ent.
 */
export type CreatePermissionInput = {
  createLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  editLabel?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<PermissionGroup>;
  label: Scalars['String']['input'];
  name: PermissionName;
  readLabel?: InputMaybe<Scalars['String']['input']>;
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  sorter?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePinnedDevicesInput is used for create PinnedDevices object.
 * Input was generated by ent.
 */
export type CreatePinnedDevicesInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreatePoiInput is used for create Poi object.
 * Input was generated by ent.
 */
export type CreatePoiInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  iconColor: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  lat: Scalars['String']['input'];
  long: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateProfileInput is used for create Profile object.
 * Input was generated by ent.
 */
export type CreateProfileInput = {
  baseLocation: Scalars['String']['input'];
  bloodGroup: Scalars['String']['input'];
  contractNumber: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  department: Scalars['String']['input'];
  employeeNo: Scalars['String']['input'];
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationusersID: Scalars['ID']['input'];
  supervisorName: Scalars['String']['input'];
  supervisorPhonenumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePusherConfigInput is used for create PusherConfig object.
 * Input was generated by ent.
 */
export type CreatePusherConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adminID?: InputMaybe<Scalars['Int']['input']>;
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIds: Array<Scalars['Int']['input']>;
  headers: Scalars['JSON']['input'];
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  taskName: Scalars['String']['input'];
  type?: InputMaybe<PusherConfigType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreatePusherLogInput is used for create PusherLog object.
 * Input was generated by ent.
 */
export type CreatePusherLogInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  sentData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateSettingInput is used for create Setting object.
 * Input was generated by ent.
 */
export type CreateSettingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
};

/**
 * CreateSimInput is used for create Sim object.
 * Input was generated by ent.
 */
export type CreateSimInput = {
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  imsi: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  simNumber: Scalars['String']['input'];
  simOperator?: InputMaybe<SimSimOperator>;
  status?: InputMaybe<SimStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateStaffRoleInput is used for create StaffRole object.
 * Input was generated by ent.
 */
export type CreateStaffRoleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateSubscriptionLicenseOrderInput is used for create SubscriptionLicenseOrder object.
 * Input was generated by ent.
 */
export type CreateSubscriptionLicenseOrderInput = {
  baselicenseplanID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  licenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  perUnitPrice: Scalars['Float']['input'];
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  tenure: Scalars['Int']['input'];
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSupportDocumentInput is used for create SupportDocument object.
 * Input was generated by ent.
 */
export type CreateSupportDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  data: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nchunk: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateUpgradeInput is used for create Upgrade object.
 * Input was generated by ent.
 */
export type CreateUpgradeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  integrationCode: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUpgradeOrganisationPriceInput is used for create UpgradeOrganisationPrice object.
 * Input was generated by ent.
 */
export type CreateUpgradeOrganisationPriceInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID: Scalars['ID']['input'];
};

/**
 * CreateUserConfigInput is used for create UserConfig object.
 * Input was generated by ent.
 */
export type CreateUserConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: UserConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/**
 * CreateUserFcmTokenInput is used for create UserFcmToken object.
 * Input was generated by ent.
 */
export type CreateUserFcmTokenInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceType: Scalars['String']['input'];
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken: Scalars['String']['input'];
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['Int']['input'];
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  /** Address of the user */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  apiUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** City of the user */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country of the user */
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  exportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  lastLogin?: InputMaybe<Scalars['Time']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  mediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Mobile number of the user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  password: Scalars['String']['input'];
  poiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Postal code of the user */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  /** State of the user */
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUserReportBookmarkInput is used for create UserReportBookmark object.
 * Input was generated by ent.
 */
export type CreateUserReportBookmarkInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  derivedReportID: Scalars['ID']['input'];
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateWalletInput is used for create Wallet object.
 * Input was generated by ent.
 */
export type CreateWalletInput = {
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  wallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateWalletPaymentTransactionInput is used for create WalletPaymentTransaction object.
 * Input was generated by ent.
 */
export type CreateWalletPaymentTransactionInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  subtotal: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  transactionDate: Scalars['Time']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID: Scalars['ID']['input'];
};

/**
 * CreateWalletTransactionInput is used for create WalletTransaction object.
 * Input was generated by ent.
 */
export type CreateWalletTransactionInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionType: WalletTransactionTransactionType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageType?: InputMaybe<WalletTransactionUsageType>;
  walletID: Scalars['ID']['input'];
};

/**
 * CreateWhatsAppConfigInput is used for create WhatsAppConfig object.
 * Input was generated by ent.
 */
export type CreateWhatsAppConfigInput = {
  companyID: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notes?: InputMaybe<Scalars['Int']['input']>;
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateWhitelabelConfigInput is used for create WhitelabelConfig object.
 * Input was generated by ent.
 */
export type CreateWhitelabelConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: WhitelabelConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateWhitelabelCoreSettingOverrideInput is used for create WhitelabelCoreSettingOverride object.
 * Input was generated by ent.
 */
export type CreateWhitelabelCoreSettingOverrideInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: WhitelabelCoreSettingOverrideKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateWhitelabelInput is used for create Whitelabel object.
 * Input was generated by ent.
 */
export type CreateWhitelabelInput = {
  brandName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  domainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileWhitelabelLoginLogoID?: InputMaybe<Scalars['ID']['input']>;
  mediafileWhitelabelLogoID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  whitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardDriverProfileInput is used for create YardDriverProfile object.
 * Input was generated by ent.
 */
export type CreateYardDriverProfileInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dlExpiry: Scalars['Time']['input'];
  dlNumber: Scalars['String']['input'];
  lastUpdated: Scalars['Time']['input'];
  mediafileAvatarID?: InputMaybe<Scalars['ID']['input']>;
  mediafileDlImageID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardMaterialInput is used for create YardMaterial object.
 * Input was generated by ent.
 */
export type CreateYardMaterialInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardMaterialTypeInput is used for create YardMaterialType object.
 * Input was generated by ent.
 */
export type CreateYardMaterialTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardTripApprovalInput is used for create YardTripApproval object.
 * Input was generated by ent.
 */
export type CreateYardTripApprovalInput = {
  approvalMatrixID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  status: YardTripApprovalStatus;
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
};

/**
 * CreateYardTripInput is used for create YardTrip object.
 * Input was generated by ent.
 */
export type CreateYardTripInput = {
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<YardTripPurpose>;
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusCurrentID?: InputMaybe<Scalars['ID']['input']>;
  tripStatusLastID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  warehouseID: Scalars['ID']['input'];
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardTripStatusInput is used for create YardTripStatus object.
 * Input was generated by ent.
 */
export type CreateYardTripStatusInput = {
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  materialID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  routePathID: Scalars['ID']['input'];
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardVehicleInput is used for create YardVehicle object.
 * Input was generated by ent.
 */
export type CreateYardVehicleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  lastUpdated: Scalars['Time']['input'];
  mediafileVehicleInsuranceImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehiclePollutionImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehicleRcID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber: Scalars['String']['input'];
  vehicleRcExpiry: Scalars['Time']['input'];
  vehicleRcNumber: Scalars['String']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardVendorInput is used for create YardVendor object.
 * Input was generated by ent.
 */
export type CreateYardVendorInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCode: Scalars['String']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseActivityTypeInput is used for create YardWarehouseActivityType object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseActivityTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseApprovalMatrixInput is used for create YardWarehouseApprovalMatrix object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseApprovalMatrixInput = {
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  label: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  preApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseDockInput is used for create YardWarehouseDock object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseDockInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  geofenceID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseInput is used for create YardWarehouse object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseParkingInput is used for create YardWarehouseParking object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseParkingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  slotName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseRouteInput is used for create YardWarehouseRoute object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseRouteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  preferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeType: YardWarehouseRouteRouteType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseRoutePathInput is used for create YardWarehouseRoutePath object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseRoutePathInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  maxWaitTime: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  organisationID: Scalars['ID']['input'];
  routeID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CrudPermission = {
  __typename?: 'CrudPermission';
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  name: PermissionName;
  read: Scalars['Boolean']['output'];
};

export type CurrentUserResponse = {
  __typename?: 'CurrentUserResponse';
  organisationUser: OrganisationUser;
  permissions: Array<Maybe<CrudPermission>>;
};

export type DerivedReport = Node & {
  __typename?: 'DerivedReport';
  baseReport: BaseReport;
  baseReportID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  enabledForAllOrganisation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organisationID?: Maybe<Scalars['ID']['output']>;
  organisationReportAccesses?: Maybe<Array<OrganisationReportAccess>>;
  tableConfig: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userReportBookmarks?: Maybe<Array<UserReportBookmark>>;
};

/** A connection to a list of items. */
export type DerivedReportConnection = {
  __typename?: 'DerivedReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DerivedReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DerivedReportEdge = {
  __typename?: 'DerivedReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DerivedReport>;
};

export enum DerivedReportField {
  BaseReportId = 'baseReportID',
  CreatedAt = 'createdAt',
  Description = 'description',
  EnabledForAllOrganisation = 'enabledForAllOrganisation',
  OrganisationId = 'organisationID',
  TableConfig = 'tableConfig',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DerivedReport connections */
export type DerivedReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DerivedReports. */
  field: DerivedReportOrderField;
};

/** Properties by which DerivedReport connections can be ordered. */
export enum DerivedReportOrderField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/**
 * DerivedReportWhereInput is used for filtering DerivedReport objects.
 * Input was generated by ent.
 */
export type DerivedReportWhereInput = {
  and?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** base_report_id field predicates */
  baseReportID?: InputMaybe<Scalars['ID']['input']>;
  baseReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled_for_all_organisation field predicates */
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForAllOrganisationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** base_report edge predicates */
  hasBaseReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaseReportWith?: InputMaybe<Array<BaseReportWhereInput>>;
  /** organisation_report_accesses edge predicates */
  hasOrganisationReportAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationReportAccessesWith?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** user_report_bookmarks edge predicates */
  hasUserReportBookmarks?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserReportBookmarksWith?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DerivedReportWhereInput>;
  or?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** table_config field predicates */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  tableConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Device = Node & {
  __typename?: 'Device';
  associatedSimID: Scalars['ID']['output'];
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deviceActionLogs?: Maybe<Array<DeviceActionLog>>;
  deviceCategoryID: Scalars['ID']['output'];
  deviceDocuments?: Maybe<Array<DeviceDocument>>;
  deviceGroup?: Maybe<DeviceGroup>;
  deviceadvancedconfigs?: Maybe<Array<DeviceAdvancedConfig>>;
  devicecategory: DeviceCategory;
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devicemodel: DeviceModel;
  externalID?: Maybe<Scalars['String']['output']>;
  groupID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imei: Scalars['String']['output'];
  ingestServer: DeviceIngestServer;
  isActive: Scalars['Boolean']['output'];
  isMaintenance: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastPing?: Maybe<Scalars['Time']['output']>;
  license?: Maybe<License>;
  modelID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  rootOrganisation: Organisation;
  rootOrganisationID: Scalars['ID']['output'];
  sim: Sim;
  updatedAt: Scalars['Time']['output'];
};

export type DeviceAcl = Node & {
  __typename?: 'DeviceACL';
  createdAt: Scalars['Time']['output'];
  devicegroupID: Scalars['ID']['output'];
  devicegroups: DeviceGroup;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organisationUser: OrganisationUser;
  organisationuserID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceAclConnection = {
  __typename?: 'DeviceACLConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAclEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAclEdge = {
  __typename?: 'DeviceACLEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAcl>;
};

export enum DeviceAclField {
  CreatedAt = 'createdAt',
  DevicegroupId = 'devicegroupID',
  Name = 'name',
  OrganisationuserId = 'organisationuserID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceACL connections */
export type DeviceAclOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceACLs. */
  field: DeviceAclOrderField;
};

/** Properties by which DeviceACL connections can be ordered. */
export enum DeviceAclOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceACLWhereInput is used for filtering DeviceACL objects.
 * Input was generated by ent.
 */
export type DeviceAclWhereInput = {
  and?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicegroup_id field predicates */
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceAclWhereInput>;
  or?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceActionLog = Node & {
  __typename?: 'DeviceActionLog';
  actionDescription: Scalars['String']['output'];
  actionType: DeviceActionLogActionType;
  createdAt: Scalars['Time']['output'];
  deviceID: Scalars['ID']['output'];
  devices: Device;
  id: Scalars['ID']['output'];
  status: DeviceActionLogStatus;
  updatedAt: Scalars['Time']['output'];
};

/** DeviceActionLogActionType is enum for the field action_type */
export enum DeviceActionLogActionType {
  Command = 'Command',
  UpdateImei = 'UpdateIMEI'
}

/** A connection to a list of items. */
export type DeviceActionLogConnection = {
  __typename?: 'DeviceActionLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceActionLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceActionLogEdge = {
  __typename?: 'DeviceActionLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceActionLog>;
};

export enum DeviceActionLogField {
  ActionDescription = 'actionDescription',
  ActionType = 'actionType',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceActionLog connections */
export type DeviceActionLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceActionLogs. */
  field: DeviceActionLogOrderField;
};

/** Properties by which DeviceActionLog connections can be ordered. */
export enum DeviceActionLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceActionLogStatus is enum for the field status */
export enum DeviceActionLogStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Success = 'Success'
}

/**
 * DeviceActionLogWhereInput is used for filtering DeviceActionLog objects.
 * Input was generated by ent.
 */
export type DeviceActionLogWhereInput = {
  /** action_description field predicates */
  actionDescription?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actionDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** action_type field predicates */
  actionType?: InputMaybe<DeviceActionLogActionType>;
  actionTypeIn?: InputMaybe<Array<DeviceActionLogActionType>>;
  actionTypeNEQ?: InputMaybe<DeviceActionLogActionType>;
  actionTypeNotIn?: InputMaybe<Array<DeviceActionLogActionType>>;
  and?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceActionLogWhereInput>;
  or?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<DeviceActionLogStatus>;
  statusIn?: InputMaybe<Array<DeviceActionLogStatus>>;
  statusNEQ?: InputMaybe<DeviceActionLogStatus>;
  statusNotIn?: InputMaybe<Array<DeviceActionLogStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceAddonModel = Node & {
  __typename?: 'DeviceAddonModel';
  addonType: DeviceAddonModelAddonType;
  channelType: DeviceAddonModelChannelType;
  createdAt: Scalars['Time']['output'];
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceAddonModelAddonType is enum for the field addon_type */
export enum DeviceAddonModelAddonType {
  Camera = 'Camera',
  Fuel = 'Fuel',
  Temperature = 'Temperature',
  Tracker = 'Tracker'
}

/** DeviceAddonModelChannelType is enum for the field channel_type */
export enum DeviceAddonModelChannelType {
  Analog = 'Analog',
  Digital = 'Digital'
}

/** A connection to a list of items. */
export type DeviceAddonModelConnection = {
  __typename?: 'DeviceAddonModelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAddonModelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAddonModelEdge = {
  __typename?: 'DeviceAddonModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAddonModel>;
};

export enum DeviceAddonModelField {
  AddonType = 'addonType',
  ChannelType = 'channelType',
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceAddonModel connections */
export type DeviceAddonModelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceAddonModels. */
  field: DeviceAddonModelOrderField;
};

/** Properties by which DeviceAddonModel connections can be ordered. */
export enum DeviceAddonModelOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceAddonModelWhereInput is used for filtering DeviceAddonModel objects.
 * Input was generated by ent.
 */
export type DeviceAddonModelWhereInput = {
  /** addon_type field predicates */
  addonType?: InputMaybe<DeviceAddonModelAddonType>;
  addonTypeIn?: InputMaybe<Array<DeviceAddonModelAddonType>>;
  addonTypeNEQ?: InputMaybe<DeviceAddonModelAddonType>;
  addonTypeNotIn?: InputMaybe<Array<DeviceAddonModelAddonType>>;
  and?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** channel_type field predicates */
  channelType?: InputMaybe<DeviceAddonModelChannelType>;
  channelTypeIn?: InputMaybe<Array<DeviceAddonModelChannelType>>;
  channelTypeNEQ?: InputMaybe<DeviceAddonModelChannelType>;
  channelTypeNotIn?: InputMaybe<Array<DeviceAddonModelChannelType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceAddonModelWhereInput>;
  or?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceAdvancedConfig = Node & {
  __typename?: 'DeviceAdvancedConfig';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DeviceAdvancedConfigConnection = {
  __typename?: 'DeviceAdvancedConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAdvancedConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAdvancedConfigEdge = {
  __typename?: 'DeviceAdvancedConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAdvancedConfig>;
};

export enum DeviceAdvancedConfigField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

/** Ordering options for DeviceAdvancedConfig connections */
export type DeviceAdvancedConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceAdvancedConfigs. */
  field: DeviceAdvancedConfigOrderField;
};

/** Properties by which DeviceAdvancedConfig connections can be ordered. */
export enum DeviceAdvancedConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceAdvancedConfigWhereInput is used for filtering DeviceAdvancedConfig objects.
 * Input was generated by ent.
 */
export type DeviceAdvancedConfigWhereInput = {
  and?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceAdvancedConfigWhereInput>;
  or?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceCategory = Node & {
  __typename?: 'DeviceCategory';
  createdAt: Scalars['Time']['output'];
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devices?: Maybe<Array<Device>>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: DeviceCategoryType;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceCategoryConnection = {
  __typename?: 'DeviceCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceCategoryEdge = {
  __typename?: 'DeviceCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceCategory>;
};

export enum DeviceCategoryField {
  CreatedAt = 'createdAt',
  Icon = 'icon',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceCategory connections */
export type DeviceCategoryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceCategories. */
  field: DeviceCategoryOrderField;
};

/** Properties by which DeviceCategory connections can be ordered. */
export enum DeviceCategoryOrderField {
  Icon = 'ICON',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceCategoryType is enum for the field type */
export enum DeviceCategoryType {
  Idle = 'Idle',
  IgnitionOff = 'IgnitionOff',
  IgnitionOn = 'IgnitionOn',
  Inactive = 'Inactive'
}

/**
 * DeviceCategoryWhereInput is used for filtering DeviceCategory objects.
 * Input was generated by ent.
 */
export type DeviceCategoryWhereInput = {
  and?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** icon field predicates */
  icon?: InputMaybe<Scalars['String']['input']>;
  iconContains?: InputMaybe<Scalars['String']['input']>;
  iconContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconGT?: InputMaybe<Scalars['String']['input']>;
  iconGTE?: InputMaybe<Scalars['String']['input']>;
  iconHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconLT?: InputMaybe<Scalars['String']['input']>;
  iconLTE?: InputMaybe<Scalars['String']['input']>;
  iconNEQ?: InputMaybe<Scalars['String']['input']>;
  iconNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceCategoryWhereInput>;
  or?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** type field predicates */
  type?: InputMaybe<DeviceCategoryType>;
  typeIn?: InputMaybe<Array<DeviceCategoryType>>;
  typeNEQ?: InputMaybe<DeviceCategoryType>;
  typeNotIn?: InputMaybe<Array<DeviceCategoryType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceChannelConfig = Node & {
  __typename?: 'DeviceChannelConfig';
  attachedDeviceModelID: Scalars['ID']['output'];
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  deviceaddonmodel: DeviceAddonModel;
  devicemodelchannel: DeviceModelChannel;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceChannelConfigConnection = {
  __typename?: 'DeviceChannelConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceChannelConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceChannelConfigEdge = {
  __typename?: 'DeviceChannelConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceChannelConfig>;
};

export enum DeviceChannelConfigField {
  AttachedDeviceModelId = 'attachedDeviceModelID',
  ChannelId = 'channelID',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceChannelConfig connections */
export type DeviceChannelConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceChannelConfigs. */
  field: DeviceChannelConfigOrderField;
};

/** Properties by which DeviceChannelConfig connections can be ordered. */
export enum DeviceChannelConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceChannelConfigWhereInput is used for filtering DeviceChannelConfig objects.
 * Input was generated by ent.
 */
export type DeviceChannelConfigWhereInput = {
  and?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** attached_device_model_id field predicates */
  attachedDeviceModelID?: InputMaybe<Scalars['ID']['input']>;
  attachedDeviceModelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachedDeviceModelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attachedDeviceModelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** channel_id field predicates */
  channelID?: InputMaybe<Scalars['ID']['input']>;
  channelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  channelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** deviceaddonmodel edge predicates */
  hasDeviceaddonmodel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaddonmodelWith?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** devicemodelchannel edge predicates */
  hasDevicemodelchannel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelchannelWith?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceChannelConfigWhereInput>;
  or?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceCommand = Node & {
  __typename?: 'DeviceCommand';
  command: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  deviceModels?: Maybe<Array<DeviceModel>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceCommandConnection = {
  __typename?: 'DeviceCommandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceCommandEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceCommandEdge = {
  __typename?: 'DeviceCommandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceCommand>;
};

export enum DeviceCommandField {
  Command = 'command',
  CreatedAt = 'createdAt',
  Description = 'description',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceCommand connections */
export type DeviceCommandOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceCommands. */
  field: DeviceCommandOrderField;
};

/** Properties by which DeviceCommand connections can be ordered. */
export enum DeviceCommandOrderField {
  Description = 'DESCRIPTION',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceCommandWhereInput is used for filtering DeviceCommand objects.
 * Input was generated by ent.
 */
export type DeviceCommandWhereInput = {
  and?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** command field predicates */
  command?: InputMaybe<Scalars['String']['input']>;
  commandContains?: InputMaybe<Scalars['String']['input']>;
  commandContainsFold?: InputMaybe<Scalars['String']['input']>;
  commandEqualFold?: InputMaybe<Scalars['String']['input']>;
  commandGT?: InputMaybe<Scalars['String']['input']>;
  commandGTE?: InputMaybe<Scalars['String']['input']>;
  commandHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commandHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commandIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commandLT?: InputMaybe<Scalars['String']['input']>;
  commandLTE?: InputMaybe<Scalars['String']['input']>;
  commandNEQ?: InputMaybe<Scalars['String']['input']>;
  commandNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** device_models edge predicates */
  hasDeviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelsWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceCommandWhereInput>;
  or?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type DeviceDocument = Node & {
  __typename?: 'DeviceDocument';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceDocumentType: DeviceDocumentType;
  deviceDocumentTypeID: Scalars['ID']['output'];
  deviceID: Scalars['ID']['output'];
  documentID?: Maybe<Scalars['ID']['output']>;
  expiryDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceDocumentConnection = {
  __typename?: 'DeviceDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceDocumentEdge = {
  __typename?: 'DeviceDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceDocument>;
};

export enum DeviceDocumentField {
  CreatedAt = 'createdAt',
  DeviceDocumentTypeId = 'deviceDocumentTypeID',
  DeviceId = 'deviceID',
  DocumentId = 'documentID',
  ExpiryDate = 'expiryDate',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceDocument connections */
export type DeviceDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceDocuments. */
  field: DeviceDocumentOrderField;
};

/** Properties by which DeviceDocument connections can be ordered. */
export enum DeviceDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceDocumentType = Node & {
  __typename?: 'DeviceDocumentType';
  createdAt: Scalars['Time']['output'];
  deviceDocumentTypeDocuments?: Maybe<Array<DeviceDocument>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceDocumentTypeConnection = {
  __typename?: 'DeviceDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceDocumentTypeEdge = {
  __typename?: 'DeviceDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceDocumentType>;
};

export enum DeviceDocumentTypeField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceDocumentType connections */
export type DeviceDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceDocumentTypes. */
  field: DeviceDocumentTypeOrderField;
};

/** Properties by which DeviceDocumentType connections can be ordered. */
export enum DeviceDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceDocumentTypeWhereInput is used for filtering DeviceDocumentType objects.
 * Input was generated by ent.
 */
export type DeviceDocumentTypeWhereInput = {
  and?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_document_type_documents edge predicates */
  hasDeviceDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentTypeDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceDocumentTypeWhereInput>;
  or?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * DeviceDocumentWhereInput is used for filtering DeviceDocument objects.
 * Input was generated by ent.
 */
export type DeviceDocumentWhereInput = {
  and?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_document_type_id field predicates */
  deviceDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceDocumentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceDocumentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceDocumentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_id field predicates */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  documentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  documentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_date field predicates */
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiryDateLT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateLTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_document_type edge predicates */
  hasDeviceDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentTypeWith?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceDocumentWhereInput>;
  or?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Device>;
};

export enum DeviceField {
  AssociatedSimId = 'associatedSimID',
  BoltLegacyId = 'boltLegacyID',
  CreatedAt = 'createdAt',
  DeviceCategoryId = 'deviceCategoryID',
  ExternalId = 'externalID',
  GroupId = 'groupID',
  Imei = 'imei',
  IngestServer = 'ingestServer',
  IsActive = 'isActive',
  IsMaintenance = 'isMaintenance',
  IsOnline = 'isOnline',
  LastPing = 'lastPing',
  ModelId = 'modelID',
  Name = 'name',
  OrganisationId = 'organisationID',
  RootOrganisationId = 'rootOrganisationID',
  UpdatedAt = 'updatedAt'
}

export type DeviceGroup = Node & {
  __typename?: 'DeviceGroup';
  createdAt: Scalars['Time']['output'];
  device?: Maybe<Device>;
  deviceGroupDocuments?: Maybe<Array<DeviceGroupDocument>>;
  deviceParkingModeConfigs?: Maybe<Array<DeviceParkingModeConfig>>;
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  deviceVehicle?: Maybe<DeviceVehicle>;
  deviceacls?: Maybe<Array<DeviceAcl>>;
  devicegroupOrganisation: Organisation;
  devicegroupRootOrganisation: Organisation;
  devices?: Maybe<Array<Device>>;
  driverprofiles?: Maybe<Array<Profile>>;
  friendlyName: Scalars['String']['output'];
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  groupType: DeviceGroupGroupType;
  id: Scalars['ID']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisationID: Scalars['ID']['output'];
  ownerAddress?: Maybe<Scalars['String']['output']>;
  ownerContactNumber?: Maybe<Scalars['String']['output']>;
  ownerFullName?: Maybe<Scalars['String']['output']>;
  ownerInstallationDate?: Maybe<Scalars['Time']['output']>;
  primaryTrackingDeviceID?: Maybe<Scalars['ID']['output']>;
  rootOrganisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardDriverTrips?: Maybe<Array<YardTrip>>;
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type DeviceGroupConnection = {
  __typename?: 'DeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type DeviceGroupDocument = Node & {
  __typename?: 'DeviceGroupDocument';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupDocumentType: DeviceGroupDocumentType;
  deviceGroupDocumentTypeID: Scalars['ID']['output'];
  deviceGroupID: Scalars['ID']['output'];
  documentID?: Maybe<Scalars['ID']['output']>;
  expiryDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceGroupDocumentConnection = {
  __typename?: 'DeviceGroupDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceGroupDocumentEdge = {
  __typename?: 'DeviceGroupDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroupDocument>;
};

export enum DeviceGroupDocumentField {
  CreatedAt = 'createdAt',
  DeviceGroupDocumentTypeId = 'deviceGroupDocumentTypeID',
  DeviceGroupId = 'deviceGroupID',
  DocumentId = 'documentID',
  ExpiryDate = 'expiryDate',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceGroupDocument connections */
export type DeviceGroupDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroupDocuments. */
  field: DeviceGroupDocumentOrderField;
};

/** Properties by which DeviceGroupDocument connections can be ordered. */
export enum DeviceGroupDocumentOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceGroupDocumentType = Node & {
  __typename?: 'DeviceGroupDocumentType';
  applicableGroupType: DeviceGroupDocumentTypeApplicableGroupType;
  createdAt: Scalars['Time']['output'];
  deviceGroupDocumentTypeDocuments?: Maybe<Array<DeviceGroupDocument>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceGroupDocumentTypeApplicableGroupType is enum for the field applicable_group_type */
export enum DeviceGroupDocumentTypeApplicableGroupType {
  Asset = 'Asset',
  Dashcam = 'Dashcam',
  Personal = 'Personal',
  Vehicle = 'Vehicle'
}

/** A connection to a list of items. */
export type DeviceGroupDocumentTypeConnection = {
  __typename?: 'DeviceGroupDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceGroupDocumentTypeEdge = {
  __typename?: 'DeviceGroupDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroupDocumentType>;
};

export enum DeviceGroupDocumentTypeField {
  ApplicableGroupType = 'applicableGroupType',
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceGroupDocumentType connections */
export type DeviceGroupDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroupDocumentTypes. */
  field: DeviceGroupDocumentTypeOrderField;
};

/** Properties by which DeviceGroupDocumentType connections can be ordered. */
export enum DeviceGroupDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceGroupDocumentTypeWhereInput is used for filtering DeviceGroupDocumentType objects.
 * Input was generated by ent.
 */
export type DeviceGroupDocumentTypeWhereInput = {
  and?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  /** applicable_group_type field predicates */
  applicableGroupType?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  applicableGroupTypeIn?: InputMaybe<Array<DeviceGroupDocumentTypeApplicableGroupType>>;
  applicableGroupTypeNEQ?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  applicableGroupTypeNotIn?: InputMaybe<Array<DeviceGroupDocumentTypeApplicableGroupType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_document_type_documents edge predicates */
  hasDeviceGroupDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentTypeDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceGroupDocumentTypeWhereInput>;
  or?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * DeviceGroupDocumentWhereInput is used for filtering DeviceGroupDocument objects.
 * Input was generated by ent.
 */
export type DeviceGroupDocumentWhereInput = {
  and?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_document_type_id field predicates */
  deviceGroupDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupDocumentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupDocumentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupDocumentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_id field predicates */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  documentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  documentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_date field predicates */
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiryDateLT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateLTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_group_document_type edge predicates */
  hasDeviceGroupDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentTypeWith?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceGroupDocumentWhereInput>;
  or?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type DeviceGroupEdge = {
  __typename?: 'DeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroup>;
};

export enum DeviceGroupField {
  CreatedAt = 'createdAt',
  FriendlyName = 'friendlyName',
  GroupType = 'groupType',
  OrganisationId = 'organisationID',
  OwnerAddress = 'ownerAddress',
  OwnerContactNumber = 'ownerContactNumber',
  OwnerFullName = 'ownerFullName',
  OwnerInstallationDate = 'ownerInstallationDate',
  PrimaryTrackingDeviceId = 'primaryTrackingDeviceID',
  RootOrganisationId = 'rootOrganisationID',
  UpdatedAt = 'updatedAt'
}

/** DeviceGroupGroupType is enum for the field group_type */
export enum DeviceGroupGroupType {
  Asset = 'Asset',
  Dashcam = 'Dashcam',
  Personal = 'Personal',
  Vehicle = 'Vehicle'
}

/** Ordering options for DeviceGroup connections */
export type DeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroups. */
  field: DeviceGroupOrderField;
};

/** Properties by which DeviceGroup connections can be ordered. */
export enum DeviceGroupOrderField {
  FriendlyName = 'FRIENDLY_NAME',
  OwnerAddress = 'OWNER_ADDRESS',
  OwnerContactNumber = 'OWNER_CONTACT_NUMBER',
  OwnerFullName = 'OWNER_FULL_NAME',
  OwnerInstallationDate = 'OWNER_INSTALLATION_DATE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceGroupWhereInput is used for filtering DeviceGroup objects.
 * Input was generated by ent.
 */
export type DeviceGroupWhereInput = {
  and?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** friendly_name field predicates */
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  friendlyNameContains?: InputMaybe<Scalars['String']['input']>;
  friendlyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  friendlyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  friendlyNameGT?: InputMaybe<Scalars['String']['input']>;
  friendlyNameGTE?: InputMaybe<Scalars['String']['input']>;
  friendlyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  friendlyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  friendlyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyNameLT?: InputMaybe<Scalars['String']['input']>;
  friendlyNameLTE?: InputMaybe<Scalars['String']['input']>;
  friendlyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  friendlyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** group_type field predicates */
  groupType?: InputMaybe<DeviceGroupGroupType>;
  groupTypeIn?: InputMaybe<Array<DeviceGroupGroupType>>;
  groupTypeNEQ?: InputMaybe<DeviceGroupGroupType>;
  groupTypeNotIn?: InputMaybe<Array<DeviceGroupGroupType>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_group_documents edge predicates */
  hasDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** device_parking_mode_configs edge predicates */
  hasDeviceParkingModeConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceParkingModeConfigsWith?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** device_vehicle edge predicates */
  hasDeviceVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceVehicleWith?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** deviceacls edge predicates */
  hasDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaclsWith?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** devicegroup_organisation edge predicates */
  hasDevicegroupOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** devicegroup_root_organisation edge predicates */
  hasDevicegroupRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** driverprofiles edge predicates */
  hasDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverprofilesWith?: InputMaybe<Array<ProfileWhereInput>>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** yard_driver_trips edge predicates */
  hasYardDriverTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceGroupWhereInput>;
  or?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** owner_address field predicates */
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerAddressContains?: InputMaybe<Scalars['String']['input']>;
  ownerAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerAddressGT?: InputMaybe<Scalars['String']['input']>;
  ownerAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ownerAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerAddressLT?: InputMaybe<Scalars['String']['input']>;
  ownerAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ownerAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_contact_number field predicates */
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberContains?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberGT?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberGTE?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerContactNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerContactNumberLT?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberLTE?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerContactNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_full_name field predicates */
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameContains?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameGT?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameGTE?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerFullNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerFullNameLT?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameLTE?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerFullNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_installation_date field predicates */
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  ownerInstallationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerInstallationDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  ownerInstallationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** primary_tracking_device_id field predicates */
  primaryTrackingDeviceID?: InputMaybe<Scalars['ID']['input']>;
  primaryTrackingDeviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryTrackingDeviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTrackingDeviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  primaryTrackingDeviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryTrackingDeviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** DeviceIngestServer is enum for the field ingest_server */
export enum DeviceIngestServer {
  Bolt = 'BOLT',
  Track = 'TRACK'
}

export type DeviceModel = Node & {
  __typename?: 'DeviceModel';
  commands?: Maybe<Array<DeviceCommand>>;
  createdAt: Scalars['Time']['output'];
  devicemodelchannels?: Maybe<Array<DeviceModelChannel>>;
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  isAssetTracker: Scalars['Boolean']['output'];
  isDashcam: Scalars['Boolean']['output'];
  isPersonalTracker: Scalars['Boolean']['output'];
  isVehicleTracker: Scalars['Boolean']['output'];
  isWireless: Scalars['Boolean']['output'];
  manufacturer: Scalars['String']['output'];
  mediaFiles?: Maybe<Array<MediaFile>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type DeviceModelChannel = Node & {
  __typename?: 'DeviceModelChannel';
  channelName: Scalars['String']['output'];
  channelType: DeviceModelChannelChannelType;
  createdAt: Scalars['Time']['output'];
  deviceModel: DeviceModel;
  deviceModelID: Scalars['ID']['output'];
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  id: Scalars['ID']['output'];
  isBuiltin: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceModelChannelChannelType is enum for the field channel_type */
export enum DeviceModelChannelChannelType {
  Analog = 'Analog',
  Digital = 'Digital'
}

/** A connection to a list of items. */
export type DeviceModelChannelConnection = {
  __typename?: 'DeviceModelChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceModelChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceModelChannelEdge = {
  __typename?: 'DeviceModelChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceModelChannel>;
};

export enum DeviceModelChannelField {
  ChannelName = 'channelName',
  ChannelType = 'channelType',
  CreatedAt = 'createdAt',
  DeviceModelId = 'deviceModelID',
  IsBuiltin = 'isBuiltin',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceModelChannel connections */
export type DeviceModelChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceModelChannels. */
  field: DeviceModelChannelOrderField;
};

/** Properties by which DeviceModelChannel connections can be ordered. */
export enum DeviceModelChannelOrderField {
  ChannelName = 'CHANNEL_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceModelChannelWhereInput is used for filtering DeviceModelChannel objects.
 * Input was generated by ent.
 */
export type DeviceModelChannelWhereInput = {
  and?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** channel_name field predicates */
  channelName?: InputMaybe<Scalars['String']['input']>;
  channelNameContains?: InputMaybe<Scalars['String']['input']>;
  channelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  channelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  channelNameGT?: InputMaybe<Scalars['String']['input']>;
  channelNameGTE?: InputMaybe<Scalars['String']['input']>;
  channelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  channelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  channelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  channelNameLT?: InputMaybe<Scalars['String']['input']>;
  channelNameLTE?: InputMaybe<Scalars['String']['input']>;
  channelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  channelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** channel_type field predicates */
  channelType?: InputMaybe<DeviceModelChannelChannelType>;
  channelTypeIn?: InputMaybe<Array<DeviceModelChannelChannelType>>;
  channelTypeNEQ?: InputMaybe<DeviceModelChannelChannelType>;
  channelTypeNotIn?: InputMaybe<Array<DeviceModelChannelChannelType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_model_id field predicates */
  deviceModelID?: InputMaybe<Scalars['ID']['input']>;
  deviceModelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceModelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceModelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_model edge predicates */
  hasDeviceModel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_builtin field predicates */
  isBuiltin?: InputMaybe<Scalars['Boolean']['input']>;
  isBuiltinNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceModelChannelWhereInput>;
  or?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type DeviceModelConnection = {
  __typename?: 'DeviceModelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceModelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceModelEdge = {
  __typename?: 'DeviceModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceModel>;
};

export enum DeviceModelField {
  CreatedAt = 'createdAt',
  IsAssetTracker = 'isAssetTracker',
  IsDashcam = 'isDashcam',
  IsPersonalTracker = 'isPersonalTracker',
  IsVehicleTracker = 'isVehicleTracker',
  IsWireless = 'isWireless',
  Manufacturer = 'manufacturer',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceModel connections */
export type DeviceModelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceModels. */
  field: DeviceModelOrderField;
};

/** Properties by which DeviceModel connections can be ordered. */
export enum DeviceModelOrderField {
  Manufacturer = 'MANUFACTURER',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceModelWhereInput is used for filtering DeviceModel objects.
 * Input was generated by ent.
 */
export type DeviceModelWhereInput = {
  and?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** commands edge predicates */
  hasCommands?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommandsWith?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** devicemodelchannels edge predicates */
  hasDevicemodelchannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelchannelsWith?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** media_files edge predicates */
  hasMediaFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediaFilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_asset_tracker field predicates */
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isAssetTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_dashcam field predicates */
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcamNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_personal_tracker field predicates */
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_vehicle_tracker field predicates */
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_wireless field predicates */
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  isWirelessNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manufacturer field predicates */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerContains?: InputMaybe<Scalars['String']['input']>;
  manufacturerContainsFold?: InputMaybe<Scalars['String']['input']>;
  manufacturerEqualFold?: InputMaybe<Scalars['String']['input']>;
  manufacturerGT?: InputMaybe<Scalars['String']['input']>;
  manufacturerGTE?: InputMaybe<Scalars['String']['input']>;
  manufacturerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  manufacturerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  manufacturerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerLT?: InputMaybe<Scalars['String']['input']>;
  manufacturerLTE?: InputMaybe<Scalars['String']['input']>;
  manufacturerNEQ?: InputMaybe<Scalars['String']['input']>;
  manufacturerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceModelWhereInput>;
  or?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Ordering options for Device connections */
export type DeviceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Devices. */
  field: DeviceOrderField;
};

/** Properties by which Device connections can be ordered. */
export enum DeviceOrderField {
  Imei = 'IMEI',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceParkingModeConfig = Node & {
  __typename?: 'DeviceParkingModeConfig';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parkingMode: Scalars['Boolean']['output'];
  parkingSchedule: Scalars['Boolean']['output'];
  parkingScheduleDays?: Maybe<Array<Scalars['String']['output']>>;
  parkingScheduleEndUtc?: Maybe<Scalars['Time']['output']>;
  parkingScheduleStartUtc?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceParkingModeConfigConnection = {
  __typename?: 'DeviceParkingModeConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceParkingModeConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceParkingModeConfigEdge = {
  __typename?: 'DeviceParkingModeConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceParkingModeConfig>;
};

export enum DeviceParkingModeConfigField {
  CreatedAt = 'createdAt',
  DeviceGroupId = 'deviceGroupID',
  ParkingMode = 'parkingMode',
  ParkingSchedule = 'parkingSchedule',
  ParkingScheduleDays = 'parkingScheduleDays',
  ParkingScheduleEndUtc = 'parkingScheduleEndUtc',
  ParkingScheduleStartUtc = 'parkingScheduleStartUtc',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceParkingModeConfig connections */
export type DeviceParkingModeConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceParkingModeConfigs. */
  field: DeviceParkingModeConfigOrderField;
};

/** Properties by which DeviceParkingModeConfig connections can be ordered. */
export enum DeviceParkingModeConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceParkingModeConfigWhereInput is used for filtering DeviceParkingModeConfig objects.
 * Input was generated by ent.
 */
export type DeviceParkingModeConfigWhereInput = {
  and?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceParkingModeConfigWhereInput>;
  or?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** parking_mode field predicates */
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingModeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule field predicates */
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule_end_utc field predicates */
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcGT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleEndUtcIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleEndUtcLT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleEndUtcNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule_start_utc field predicates */
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcGT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleStartUtcIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleStartUtcLT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleStartUtcNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceSharing = Node & {
  __typename?: 'DeviceSharing';
  createdAt: Scalars['Time']['output'];
  deviceGroups?: Maybe<Array<DeviceGroup>>;
  expiresOn?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationUser: User;
  shareType: DeviceSharingShareType;
  sharedbyID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceSharingConnection = {
  __typename?: 'DeviceSharingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceSharingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceSharingEdge = {
  __typename?: 'DeviceSharingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceSharing>;
};

export enum DeviceSharingField {
  CreatedAt = 'createdAt',
  ExpiresOn = 'expiresOn',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  ShareType = 'shareType',
  SharedbyId = 'sharedbyID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceSharing connections */
export type DeviceSharingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceSharings. */
  field: DeviceSharingOrderField;
};

/** Properties by which DeviceSharing connections can be ordered. */
export enum DeviceSharingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceSharingShareType is enum for the field share_type */
export enum DeviceSharingShareType {
  Brief = 'Brief',
  Detailed = 'Detailed'
}

/**
 * DeviceSharingWhereInput is used for filtering DeviceSharing objects.
 * Input was generated by ent.
 */
export type DeviceSharingWhereInput = {
  and?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_on field predicates */
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresOnLT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_groups edge predicates */
  hasDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<UserWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceSharingWhereInput>;
  or?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** share_type field predicates */
  shareType?: InputMaybe<DeviceSharingShareType>;
  shareTypeIn?: InputMaybe<Array<DeviceSharingShareType>>;
  shareTypeNEQ?: InputMaybe<DeviceSharingShareType>;
  shareTypeNotIn?: InputMaybe<Array<DeviceSharingShareType>>;
  /** sharedby_id field predicates */
  sharedbyID?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharedbyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum DeviceStatus {
  Idle = 'idle',
  IgnitionOff = 'ignitionOff',
  IgnitionOn = 'ignitionOn',
  Inactive = 'inactive'
}

export type DeviceVehicle = Node & {
  __typename?: 'DeviceVehicle';
  chassisNo?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  dealer?: Maybe<Scalars['String']['output']>;
  deviceGroup: DeviceGroup;
  groupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  insuranceEndDate?: Maybe<Scalars['Time']['output']>;
  insurancePremium?: Maybe<Scalars['String']['output']>;
  insuranceStartDate?: Maybe<Scalars['Time']['output']>;
  oem?: Maybe<Scalars['String']['output']>;
  registeredRto?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  vehicleNumber: Scalars['String']['output'];
  vehicleType: DeviceVehicleVehicleType;
  warranty?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type DeviceVehicleConnection = {
  __typename?: 'DeviceVehicleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceVehicleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceVehicleEdge = {
  __typename?: 'DeviceVehicleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceVehicle>;
};

export enum DeviceVehicleField {
  ChassisNo = 'chassisNo',
  Country = 'country',
  CreatedAt = 'createdAt',
  Dealer = 'dealer',
  GroupId = 'groupID',
  InsuranceCompany = 'insuranceCompany',
  InsuranceEndDate = 'insuranceEndDate',
  InsurancePremium = 'insurancePremium',
  InsuranceStartDate = 'insuranceStartDate',
  Oem = 'oem',
  RegisteredRto = 'registeredRto',
  State = 'state',
  UpdatedAt = 'updatedAt',
  VehicleNumber = 'vehicleNumber',
  VehicleType = 'vehicleType',
  Warranty = 'warranty'
}

/** Ordering options for DeviceVehicle connections */
export type DeviceVehicleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceVehicles. */
  field: DeviceVehicleOrderField;
};

/** Properties by which DeviceVehicle connections can be ordered. */
export enum DeviceVehicleOrderField {
  VehicleNumber = 'VEHICLE_NUMBER',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceVehicleVehicleType is enum for the field vehicle_type */
export enum DeviceVehicleVehicleType {
  Ev = 'EV',
  NonEv = 'NonEV'
}

/**
 * DeviceVehicleWhereInput is used for filtering DeviceVehicle objects.
 * Input was generated by ent.
 */
export type DeviceVehicleWhereInput = {
  and?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  /** chassis_no field predicates */
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  chassisNoContains?: InputMaybe<Scalars['String']['input']>;
  chassisNoContainsFold?: InputMaybe<Scalars['String']['input']>;
  chassisNoEqualFold?: InputMaybe<Scalars['String']['input']>;
  chassisNoGT?: InputMaybe<Scalars['String']['input']>;
  chassisNoGTE?: InputMaybe<Scalars['String']['input']>;
  chassisNoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  chassisNoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  chassisNoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  chassisNoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  chassisNoLT?: InputMaybe<Scalars['String']['input']>;
  chassisNoLTE?: InputMaybe<Scalars['String']['input']>;
  chassisNoNEQ?: InputMaybe<Scalars['String']['input']>;
  chassisNoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  chassisNoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dealer field predicates */
  dealer?: InputMaybe<Scalars['String']['input']>;
  dealerContains?: InputMaybe<Scalars['String']['input']>;
  dealerContainsFold?: InputMaybe<Scalars['String']['input']>;
  dealerEqualFold?: InputMaybe<Scalars['String']['input']>;
  dealerGT?: InputMaybe<Scalars['String']['input']>;
  dealerGTE?: InputMaybe<Scalars['String']['input']>;
  dealerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dealerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dealerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dealerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dealerLT?: InputMaybe<Scalars['String']['input']>;
  dealerLTE?: InputMaybe<Scalars['String']['input']>;
  dealerNEQ?: InputMaybe<Scalars['String']['input']>;
  dealerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dealerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** insurance_company field predicates */
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyContains?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyContainsFold?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyEqualFold?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyGT?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyGTE?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceCompanyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceCompanyLT?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyLTE?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyNEQ?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceCompanyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_end_date field predicates */
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceEndDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceEndDateLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceEndDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_premium field predicates */
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumContains?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumContainsFold?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumEqualFold?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumGT?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumGTE?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumHasPrefix?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumHasSuffix?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insurancePremiumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insurancePremiumLT?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumLTE?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumNEQ?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insurancePremiumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_start_date field predicates */
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceStartDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceStartDateLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceStartDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceVehicleWhereInput>;
  /** oem field predicates */
  oem?: InputMaybe<Scalars['String']['input']>;
  oemContains?: InputMaybe<Scalars['String']['input']>;
  oemContainsFold?: InputMaybe<Scalars['String']['input']>;
  oemEqualFold?: InputMaybe<Scalars['String']['input']>;
  oemGT?: InputMaybe<Scalars['String']['input']>;
  oemGTE?: InputMaybe<Scalars['String']['input']>;
  oemHasPrefix?: InputMaybe<Scalars['String']['input']>;
  oemHasSuffix?: InputMaybe<Scalars['String']['input']>;
  oemIn?: InputMaybe<Array<Scalars['String']['input']>>;
  oemIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  oemLT?: InputMaybe<Scalars['String']['input']>;
  oemLTE?: InputMaybe<Scalars['String']['input']>;
  oemNEQ?: InputMaybe<Scalars['String']['input']>;
  oemNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  oemNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  /** registered_rto field predicates */
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  registeredRtoContains?: InputMaybe<Scalars['String']['input']>;
  registeredRtoContainsFold?: InputMaybe<Scalars['String']['input']>;
  registeredRtoEqualFold?: InputMaybe<Scalars['String']['input']>;
  registeredRtoGT?: InputMaybe<Scalars['String']['input']>;
  registeredRtoGTE?: InputMaybe<Scalars['String']['input']>;
  registeredRtoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  registeredRtoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  registeredRtoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredRtoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  registeredRtoLT?: InputMaybe<Scalars['String']['input']>;
  registeredRtoLTE?: InputMaybe<Scalars['String']['input']>;
  registeredRtoNEQ?: InputMaybe<Scalars['String']['input']>;
  registeredRtoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredRtoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_number field predicates */
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vehicle_type field predicates */
  vehicleType?: InputMaybe<DeviceVehicleVehicleType>;
  vehicleTypeIn?: InputMaybe<Array<DeviceVehicleVehicleType>>;
  vehicleTypeNEQ?: InputMaybe<DeviceVehicleVehicleType>;
  vehicleTypeNotIn?: InputMaybe<Array<DeviceVehicleVehicleType>>;
  /** warranty field predicates */
  warranty?: InputMaybe<Scalars['String']['input']>;
  warrantyContains?: InputMaybe<Scalars['String']['input']>;
  warrantyContainsFold?: InputMaybe<Scalars['String']['input']>;
  warrantyEqualFold?: InputMaybe<Scalars['String']['input']>;
  warrantyGT?: InputMaybe<Scalars['String']['input']>;
  warrantyGTE?: InputMaybe<Scalars['String']['input']>;
  warrantyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  warrantyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  warrantyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  warrantyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyLT?: InputMaybe<Scalars['String']['input']>;
  warrantyLTE?: InputMaybe<Scalars['String']['input']>;
  warrantyNEQ?: InputMaybe<Scalars['String']['input']>;
  warrantyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  warrantyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * DeviceWhereInput is used for filtering Device objects.
 * Input was generated by ent.
 */
export type DeviceWhereInput = {
  and?: InputMaybe<Array<DeviceWhereInput>>;
  /** associated_sim_id field predicates */
  associatedSimID?: InputMaybe<Scalars['ID']['input']>;
  associatedSimIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedSimIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  associatedSimIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_category_id field predicates */
  deviceCategoryID?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceCategoryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_action_logs edge predicates */
  hasDeviceActionLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceActionLogsWith?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** device_documents edge predicates */
  hasDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** deviceadvancedconfigs edge predicates */
  hasDeviceadvancedconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceadvancedconfigsWith?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** devicecategory edge predicates */
  hasDevicecategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicecategoryWith?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devicemodel edge predicates */
  hasDevicemodel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** license edge predicates */
  hasLicense?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** root_organisation edge predicates */
  hasRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** sim edge predicates */
  hasSim?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimWith?: InputMaybe<Array<SimWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imei field predicates */
  imei?: InputMaybe<Scalars['String']['input']>;
  imeiContains?: InputMaybe<Scalars['String']['input']>;
  imeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imeiGT?: InputMaybe<Scalars['String']['input']>;
  imeiGTE?: InputMaybe<Scalars['String']['input']>;
  imeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiLT?: InputMaybe<Scalars['String']['input']>;
  imeiLTE?: InputMaybe<Scalars['String']['input']>;
  imeiNEQ?: InputMaybe<Scalars['String']['input']>;
  imeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ingest_server field predicates */
  ingestServer?: InputMaybe<DeviceIngestServer>;
  ingestServerIn?: InputMaybe<Array<DeviceIngestServer>>;
  ingestServerNEQ?: InputMaybe<DeviceIngestServer>;
  ingestServerNotIn?: InputMaybe<Array<DeviceIngestServer>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_maintenance field predicates */
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenanceNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_online field predicates */
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_ping field predicates */
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  lastPingGT?: InputMaybe<Scalars['Time']['input']>;
  lastPingGTE?: InputMaybe<Scalars['Time']['input']>;
  lastPingIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastPingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingLT?: InputMaybe<Scalars['Time']['input']>;
  lastPingLTE?: InputMaybe<Scalars['Time']['input']>;
  lastPingNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastPingNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastPingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** model_id field predicates */
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  modelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceWhereInput>;
  or?: InputMaybe<Array<DeviceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Domain = Node & {
  __typename?: 'Domain';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sslVerificationStatus: DomainSslVerificationStatus;
  updatedAt: Scalars['Time']['output'];
  verificationID?: Maybe<Scalars['String']['output']>;
  verificationLastChecked?: Maybe<Scalars['Time']['output']>;
  verificationStatus: DomainVerificationStatus;
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type DomainConnection = {
  __typename?: 'DomainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DomainEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DomainEdge = {
  __typename?: 'DomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Domain>;
};

export enum DomainField {
  Alias = 'alias',
  CreatedAt = 'createdAt',
  Domain = 'domain',
  SslVerificationStatus = 'sslVerificationStatus',
  UpdatedAt = 'updatedAt',
  VerificationId = 'verificationID',
  VerificationLastChecked = 'verificationLastChecked',
  VerificationStatus = 'verificationStatus',
  WhitelabelId = 'whitelabelID'
}

/** Ordering options for Domain connections */
export type DomainOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Domains. */
  field: DomainOrderField;
};

/** Properties by which Domain connections can be ordered. */
export enum DomainOrderField {
  Alias = 'ALIAS',
  Domain = 'DOMAIN',
  VerificationLastChecked = 'VERIFICATION_LAST_CHECKED',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DomainSslVerificationStatus is enum for the field ssl_verification_status */
export enum DomainSslVerificationStatus {
  Active = 'Active',
  Pending = 'Pending',
  Provisioning = 'Provisioning',
  ProvisioningFailed = 'ProvisioningFailed',
  VerificationFailed = 'VerificationFailed',
  VerificationSuccess = 'VerificationSuccess',
  WaitingToVerify = 'WaitingToVerify'
}

/** DomainVerificationStatus is enum for the field verification_status */
export enum DomainVerificationStatus {
  Active = 'Active',
  Pending = 'Pending',
  Provisioning = 'Provisioning',
  ProvisioningFailed = 'ProvisioningFailed',
  VerificationFailed = 'VerificationFailed',
  VerificationSuccess = 'VerificationSuccess',
  WaitingToVerify = 'WaitingToVerify'
}

/**
 * DomainWhereInput is used for filtering Domain objects.
 * Input was generated by ent.
 */
export type DomainWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<DomainWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** domain field predicates */
  domain?: InputMaybe<Scalars['String']['input']>;
  domainContains?: InputMaybe<Scalars['String']['input']>;
  domainContainsFold?: InputMaybe<Scalars['String']['input']>;
  domainEqualFold?: InputMaybe<Scalars['String']['input']>;
  domainGT?: InputMaybe<Scalars['String']['input']>;
  domainGTE?: InputMaybe<Scalars['String']['input']>;
  domainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  domainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  domainIn?: InputMaybe<Array<Scalars['String']['input']>>;
  domainLT?: InputMaybe<Scalars['String']['input']>;
  domainLTE?: InputMaybe<Scalars['String']['input']>;
  domainNEQ?: InputMaybe<Scalars['String']['input']>;
  domainNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DomainWhereInput>;
  or?: InputMaybe<Array<DomainWhereInput>>;
  /** ssl_verification_status field predicates */
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  sslVerificationStatusIn?: InputMaybe<Array<DomainSslVerificationStatus>>;
  sslVerificationStatusNEQ?: InputMaybe<DomainSslVerificationStatus>;
  sslVerificationStatusNotIn?: InputMaybe<Array<DomainSslVerificationStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** verification_id field predicates */
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationIDContains?: InputMaybe<Scalars['String']['input']>;
  verificationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  verificationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  verificationIDGT?: InputMaybe<Scalars['String']['input']>;
  verificationIDGTE?: InputMaybe<Scalars['String']['input']>;
  verificationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  verificationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  verificationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verificationIDLT?: InputMaybe<Scalars['String']['input']>;
  verificationIDLTE?: InputMaybe<Scalars['String']['input']>;
  verificationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  verificationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verification_last_checked field predicates */
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedGT?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedGTE?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verificationLastCheckedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verificationLastCheckedLT?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedLTE?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedNEQ?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verificationLastCheckedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verification_status field predicates */
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  verificationStatusIn?: InputMaybe<Array<DomainVerificationStatus>>;
  verificationStatusNEQ?: InputMaybe<DomainVerificationStatus>;
  verificationStatusNotIn?: InputMaybe<Array<DomainVerificationStatus>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Export = Node & {
  __typename?: 'Export';
  createdAt: Scalars['Time']['output'];
  exportData: Scalars['String']['output'];
  exportKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mediaID?: Maybe<Scalars['ID']['output']>;
  mediafile?: Maybe<MediaFile>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  status: ExportStatus;
  statusMsg?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type ExportConnection = {
  __typename?: 'ExportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExportEdge = {
  __typename?: 'ExportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Export>;
};

export enum ExportField {
  CreatedAt = 'createdAt',
  ExportData = 'exportData',
  ExportKey = 'exportKey',
  MediaId = 'mediaID',
  OrganisationId = 'organisationID',
  Status = 'status',
  StatusMsg = 'statusMsg',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for Export connections */
export type ExportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Exports. */
  field: ExportOrderField;
};

/** Properties by which Export connections can be ordered. */
export enum ExportOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** ExportStatus is enum for the field status */
export enum ExportStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Success = 'Success'
}

/**
 * ExportWhereInput is used for filtering Export objects.
 * Input was generated by ent.
 */
export type ExportWhereInput = {
  and?: InputMaybe<Array<ExportWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** export_data field predicates */
  exportData?: InputMaybe<Scalars['String']['input']>;
  exportDataContains?: InputMaybe<Scalars['String']['input']>;
  exportDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  exportDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  exportDataGT?: InputMaybe<Scalars['String']['input']>;
  exportDataGTE?: InputMaybe<Scalars['String']['input']>;
  exportDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  exportDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  exportDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  exportDataLT?: InputMaybe<Scalars['String']['input']>;
  exportDataLTE?: InputMaybe<Scalars['String']['input']>;
  exportDataNEQ?: InputMaybe<Scalars['String']['input']>;
  exportDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** export_key field predicates */
  exportKey?: InputMaybe<Scalars['String']['input']>;
  exportKeyContains?: InputMaybe<Scalars['String']['input']>;
  exportKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  exportKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  exportKeyGT?: InputMaybe<Scalars['String']['input']>;
  exportKeyGTE?: InputMaybe<Scalars['String']['input']>;
  exportKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  exportKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  exportKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  exportKeyLT?: InputMaybe<Scalars['String']['input']>;
  exportKeyLTE?: InputMaybe<Scalars['String']['input']>;
  exportKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  exportKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** media_id field predicates */
  mediaID?: InputMaybe<Scalars['ID']['input']>;
  mediaIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediaIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  mediaIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediaIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ExportWhereInput>;
  or?: InputMaybe<Array<ExportWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<ExportStatus>;
  statusIn?: InputMaybe<Array<ExportStatus>>;
  /** status_msg field predicates */
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  statusMsgContains?: InputMaybe<Scalars['String']['input']>;
  statusMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgGT?: InputMaybe<Scalars['String']['input']>;
  statusMsgGTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  statusMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusMsgLT?: InputMaybe<Scalars['String']['input']>;
  statusMsgLTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  statusMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNEQ?: InputMaybe<ExportStatus>;
  statusNotIn?: InputMaybe<Array<ExportStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FirebasePrivateKey = Node & {
  __typename?: 'FirebasePrivateKey';
  authProviderX509CertURL: Scalars['String']['output'];
  authURI: Scalars['String']['output'];
  clientEmail: Scalars['String']['output'];
  clientID: Scalars['String']['output'];
  clientX509CertURL: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateKey: Scalars['String']['output'];
  privateKeyID: Scalars['String']['output'];
  projectID: Scalars['String']['output'];
  senderID?: Maybe<Scalars['String']['output']>;
  tokenURI: Scalars['String']['output'];
  type: Scalars['String']['output'];
  universeDomain: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type FirebasePrivateKeyConnection = {
  __typename?: 'FirebasePrivateKeyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FirebasePrivateKeyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirebasePrivateKeyEdge = {
  __typename?: 'FirebasePrivateKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FirebasePrivateKey>;
};

export enum FirebasePrivateKeyField {
  AuthProviderX509CertUrl = 'authProviderX509CertURL',
  AuthUri = 'authURI',
  ClientEmail = 'clientEmail',
  ClientId = 'clientID',
  ClientX509CertUrl = 'clientX509CertURL',
  CreatedAt = 'createdAt',
  FileName = 'fileName',
  PrivateKey = 'privateKey',
  PrivateKeyId = 'privateKeyID',
  ProjectId = 'projectID',
  SenderId = 'senderID',
  TokenUri = 'tokenURI',
  Type = 'type',
  UniverseDomain = 'universeDomain',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for FirebasePrivateKey connections */
export type FirebasePrivateKeyOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FirebasePrivateKeys. */
  field: FirebasePrivateKeyOrderField;
};

/** Properties by which FirebasePrivateKey connections can be ordered. */
export enum FirebasePrivateKeyOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * FirebasePrivateKeyWhereInput is used for filtering FirebasePrivateKey objects.
 * Input was generated by ent.
 */
export type FirebasePrivateKeyWhereInput = {
  and?: InputMaybe<Array<FirebasePrivateKeyWhereInput>>;
  /** auth_provider_x509_cert_url field predicates */
  authProviderX509CertURL?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLContains?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLGT?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLGTE?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authProviderX509CertURLLT?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLLTE?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLNEQ?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** auth_uri field predicates */
  authURI?: InputMaybe<Scalars['String']['input']>;
  authURIContains?: InputMaybe<Scalars['String']['input']>;
  authURIContainsFold?: InputMaybe<Scalars['String']['input']>;
  authURIEqualFold?: InputMaybe<Scalars['String']['input']>;
  authURIGT?: InputMaybe<Scalars['String']['input']>;
  authURIGTE?: InputMaybe<Scalars['String']['input']>;
  authURIHasPrefix?: InputMaybe<Scalars['String']['input']>;
  authURIHasSuffix?: InputMaybe<Scalars['String']['input']>;
  authURIIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authURILT?: InputMaybe<Scalars['String']['input']>;
  authURILTE?: InputMaybe<Scalars['String']['input']>;
  authURINEQ?: InputMaybe<Scalars['String']['input']>;
  authURINotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_email field predicates */
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientEmailContains?: InputMaybe<Scalars['String']['input']>;
  clientEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientEmailGT?: InputMaybe<Scalars['String']['input']>;
  clientEmailGTE?: InputMaybe<Scalars['String']['input']>;
  clientEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientEmailLT?: InputMaybe<Scalars['String']['input']>;
  clientEmailLTE?: InputMaybe<Scalars['String']['input']>;
  clientEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  clientEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_id field predicates */
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientIDContains?: InputMaybe<Scalars['String']['input']>;
  clientIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientIDGT?: InputMaybe<Scalars['String']['input']>;
  clientIDGTE?: InputMaybe<Scalars['String']['input']>;
  clientIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIDLT?: InputMaybe<Scalars['String']['input']>;
  clientIDLTE?: InputMaybe<Scalars['String']['input']>;
  clientIDNEQ?: InputMaybe<Scalars['String']['input']>;
  clientIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_x509_cert_url field predicates */
  clientX509CertURL?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLContains?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLGT?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLGTE?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientX509CertURLLT?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLLTE?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLNEQ?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_name field predicates */
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileNameContains?: InputMaybe<Scalars['String']['input']>;
  fileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileNameGT?: InputMaybe<Scalars['String']['input']>;
  fileNameGTE?: InputMaybe<Scalars['String']['input']>;
  fileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameLT?: InputMaybe<Scalars['String']['input']>;
  fileNameLTE?: InputMaybe<Scalars['String']['input']>;
  fileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FirebasePrivateKeyWhereInput>;
  or?: InputMaybe<Array<FirebasePrivateKeyWhereInput>>;
  /** private_key field predicates */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyContains?: InputMaybe<Scalars['String']['input']>;
  privateKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyGT?: InputMaybe<Scalars['String']['input']>;
  privateKeyGTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  /** private_key_id field predicates */
  privateKeyID?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyLT?: InputMaybe<Scalars['String']['input']>;
  privateKeyLTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  privateKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['String']['input']>;
  projectIDContains?: InputMaybe<Scalars['String']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectIDGT?: InputMaybe<Scalars['String']['input']>;
  projectIDGTE?: InputMaybe<Scalars['String']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIDLT?: InputMaybe<Scalars['String']['input']>;
  projectIDLTE?: InputMaybe<Scalars['String']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['String']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sender_id field predicates */
  senderID?: InputMaybe<Scalars['String']['input']>;
  senderIDContains?: InputMaybe<Scalars['String']['input']>;
  senderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  senderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  senderIDGT?: InputMaybe<Scalars['String']['input']>;
  senderIDGTE?: InputMaybe<Scalars['String']['input']>;
  senderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  senderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  senderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  senderIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  senderIDLT?: InputMaybe<Scalars['String']['input']>;
  senderIDLTE?: InputMaybe<Scalars['String']['input']>;
  senderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  senderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  senderIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** token_uri field predicates */
  tokenURI?: InputMaybe<Scalars['String']['input']>;
  tokenURIContains?: InputMaybe<Scalars['String']['input']>;
  tokenURIContainsFold?: InputMaybe<Scalars['String']['input']>;
  tokenURIEqualFold?: InputMaybe<Scalars['String']['input']>;
  tokenURIGT?: InputMaybe<Scalars['String']['input']>;
  tokenURIGTE?: InputMaybe<Scalars['String']['input']>;
  tokenURIHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenURIHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tokenURIIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURILT?: InputMaybe<Scalars['String']['input']>;
  tokenURILTE?: InputMaybe<Scalars['String']['input']>;
  tokenURINEQ?: InputMaybe<Scalars['String']['input']>;
  tokenURINotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<Scalars['String']['input']>;
  typeContains?: InputMaybe<Scalars['String']['input']>;
  typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeGT?: InputMaybe<Scalars['String']['input']>;
  typeGTE?: InputMaybe<Scalars['String']['input']>;
  typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeLT?: InputMaybe<Scalars['String']['input']>;
  typeLTE?: InputMaybe<Scalars['String']['input']>;
  typeNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** universe_domain field predicates */
  universeDomain?: InputMaybe<Scalars['String']['input']>;
  universeDomainContains?: InputMaybe<Scalars['String']['input']>;
  universeDomainContainsFold?: InputMaybe<Scalars['String']['input']>;
  universeDomainEqualFold?: InputMaybe<Scalars['String']['input']>;
  universeDomainGT?: InputMaybe<Scalars['String']['input']>;
  universeDomainGTE?: InputMaybe<Scalars['String']['input']>;
  universeDomainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  universeDomainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  universeDomainIn?: InputMaybe<Array<Scalars['String']['input']>>;
  universeDomainLT?: InputMaybe<Scalars['String']['input']>;
  universeDomainLTE?: InputMaybe<Scalars['String']['input']>;
  universeDomainNEQ?: InputMaybe<Scalars['String']['input']>;
  universeDomainNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Geofence = Node & {
  __typename?: 'Geofence';
  color: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  geoJSON?: Maybe<Scalars['GeoJSON']['output']>;
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  radius: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  useAsAddress: Scalars['Boolean']['output'];
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
};

/** A connection to a list of items. */
export type GeofenceConnection = {
  __typename?: 'GeofenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GeofenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type GeofenceDeviceGroup = Node & {
  __typename?: 'GeofenceDeviceGroup';
  createdAt: Scalars['Time']['output'];
  devicegroup: DeviceGroup;
  devicegroupID: Scalars['ID']['output'];
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isIn: Scalars['Boolean']['output'];
  lastUpdate?: Maybe<Scalars['Time']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GeofenceDeviceGroupConnection = {
  __typename?: 'GeofenceDeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GeofenceDeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GeofenceDeviceGroupEdge = {
  __typename?: 'GeofenceDeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GeofenceDeviceGroup>;
};

export enum GeofenceDeviceGroupField {
  CreatedAt = 'createdAt',
  DevicegroupId = 'devicegroupID',
  GeofenceId = 'geofenceID',
  IsIn = 'isIn',
  LastUpdate = 'lastUpdate',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for GeofenceDeviceGroup connections */
export type GeofenceDeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GeofenceDeviceGroups. */
  field: GeofenceDeviceGroupOrderField;
};

/** Properties by which GeofenceDeviceGroup connections can be ordered. */
export enum GeofenceDeviceGroupOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * GeofenceDeviceGroupWhereInput is used for filtering GeofenceDeviceGroup objects.
 * Input was generated by ent.
 */
export type GeofenceDeviceGroupWhereInput = {
  and?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicegroup_id field predicates */
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** geofence_id field predicates */
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devicegroup edge predicates */
  hasDevicegroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** geofence edge predicates */
  hasGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_in field predicates */
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  isInNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_update field predicates */
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GeofenceDeviceGroupWhereInput>;
  or?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type GeofenceEdge = {
  __typename?: 'GeofenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Geofence>;
};

export enum GeofenceField {
  Color = 'color',
  CreatedAt = 'createdAt',
  GeoJson = 'geoJSON',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  Radius = 'radius',
  UpdatedAt = 'updatedAt',
  UseAsAddress = 'useAsAddress'
}

/** Ordering options for Geofence connections */
export type GeofenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Geofences. */
  field: GeofenceOrderField;
};

/** Properties by which Geofence connections can be ordered. */
export enum GeofenceOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * GeofenceWhereInput is used for filtering Geofence objects.
 * Input was generated by ent.
 */
export type GeofenceWhereInput = {
  and?: InputMaybe<Array<GeofenceWhereInput>>;
  /** color field predicates */
  color?: InputMaybe<Scalars['String']['input']>;
  colorContains?: InputMaybe<Scalars['String']['input']>;
  colorContainsFold?: InputMaybe<Scalars['String']['input']>;
  colorEqualFold?: InputMaybe<Scalars['String']['input']>;
  colorGT?: InputMaybe<Scalars['String']['input']>;
  colorGTE?: InputMaybe<Scalars['String']['input']>;
  colorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  colorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  colorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  colorLT?: InputMaybe<Scalars['String']['input']>;
  colorLTE?: InputMaybe<Scalars['String']['input']>;
  colorNEQ?: InputMaybe<Scalars['String']['input']>;
  colorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** geo_json field predicates */
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONGT?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONGTE?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONIn?: InputMaybe<Array<Scalars['GeoJSON']['input']>>;
  geoJSONIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  geoJSONLT?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONLTE?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONNEQ?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONNotIn?: InputMaybe<Array<Scalars['GeoJSON']['input']>>;
  geoJSONNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<GeofenceWhereInput>;
  or?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** radius field predicates */
  radius?: InputMaybe<Scalars['Float']['input']>;
  radiusGT?: InputMaybe<Scalars['Float']['input']>;
  radiusGTE?: InputMaybe<Scalars['Float']['input']>;
  radiusIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  radiusLT?: InputMaybe<Scalars['Float']['input']>;
  radiusLTE?: InputMaybe<Scalars['Float']['input']>;
  radiusNEQ?: InputMaybe<Scalars['Float']['input']>;
  radiusNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** use_as_address field predicates */
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
  useAsAddressNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Kml = Node & {
  __typename?: 'Kml';
  createdAt: Scalars['Time']['output'];
  file: MediaFile;
  fileID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type KmlConnection = {
  __typename?: 'KmlConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<KmlEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KmlEdge = {
  __typename?: 'KmlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kml>;
};

export enum KmlField {
  CreatedAt = 'createdAt',
  FileId = 'fileID',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Kml connections */
export type KmlOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Kmls. */
  field: KmlOrderField;
};

/** Properties by which Kml connections can be ordered. */
export enum KmlOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * KmlWhereInput is used for filtering Kml objects.
 * Input was generated by ent.
 */
export type KmlWhereInput = {
  and?: InputMaybe<Array<KmlWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_id field predicates */
  fileID?: InputMaybe<Scalars['ID']['input']>;
  fileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KmlWhereInput>;
  or?: InputMaybe<Array<KmlWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LastFewEventsResponse = {
  __typename?: 'LastFewEventsResponse';
  attributes?: Maybe<Scalars['JSON']['output']>;
  deviceId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  fixTime: Scalars['Time']['output'];
  geofenceName?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LegacySync = Node & {
  __typename?: 'LegacySync';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  status: LegacySyncStatus;
  statusMsg?: Maybe<Scalars['String']['output']>;
  syncData: Scalars['String']['output'];
  syncKey: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LegacySyncConnection = {
  __typename?: 'LegacySyncConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LegacySyncEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LegacySyncEdge = {
  __typename?: 'LegacySyncEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LegacySync>;
};

export enum LegacySyncField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  Status = 'status',
  StatusMsg = 'statusMsg',
  SyncData = 'syncData',
  SyncKey = 'syncKey',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LegacySync connections */
export type LegacySyncOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LegacySyncs. */
  field: LegacySyncOrderField;
};

/** Properties by which LegacySync connections can be ordered. */
export enum LegacySyncOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LegacySyncStatus is enum for the field status */
export enum LegacySyncStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Success = 'Success'
}

/**
 * LegacySyncWhereInput is used for filtering LegacySync objects.
 * Input was generated by ent.
 */
export type LegacySyncWhereInput = {
  and?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LegacySyncWhereInput>;
  or?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<LegacySyncStatus>;
  statusIn?: InputMaybe<Array<LegacySyncStatus>>;
  /** status_msg field predicates */
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  statusMsgContains?: InputMaybe<Scalars['String']['input']>;
  statusMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgGT?: InputMaybe<Scalars['String']['input']>;
  statusMsgGTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  statusMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusMsgLT?: InputMaybe<Scalars['String']['input']>;
  statusMsgLTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  statusMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNEQ?: InputMaybe<LegacySyncStatus>;
  statusNotIn?: InputMaybe<Array<LegacySyncStatus>>;
  /** sync_data field predicates */
  syncData?: InputMaybe<Scalars['String']['input']>;
  syncDataContains?: InputMaybe<Scalars['String']['input']>;
  syncDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  syncDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  syncDataGT?: InputMaybe<Scalars['String']['input']>;
  syncDataGTE?: InputMaybe<Scalars['String']['input']>;
  syncDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  syncDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  syncDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  syncDataLT?: InputMaybe<Scalars['String']['input']>;
  syncDataLTE?: InputMaybe<Scalars['String']['input']>;
  syncDataNEQ?: InputMaybe<Scalars['String']['input']>;
  syncDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sync_key field predicates */
  syncKey?: InputMaybe<Scalars['String']['input']>;
  syncKeyContains?: InputMaybe<Scalars['String']['input']>;
  syncKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  syncKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  syncKeyGT?: InputMaybe<Scalars['String']['input']>;
  syncKeyGTE?: InputMaybe<Scalars['String']['input']>;
  syncKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  syncKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  syncKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  syncKeyLT?: InputMaybe<Scalars['String']['input']>;
  syncKeyLTE?: InputMaybe<Scalars['String']['input']>;
  syncKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  syncKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type License = Node & {
  __typename?: 'License';
  autoRenew: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  device?: Maybe<Device>;
  endDate?: Maybe<Scalars['Time']['output']>;
  expiryReminderDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  licenseOrder: SubscriptionLicenseOrder;
  licenseOrderID: Scalars['ID']['output'];
  linkedDeviceID?: Maybe<Scalars['ID']['output']>;
  moduleType: LicenseModuleType;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Time']['output']>;
  status: LicenseStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LicenseConnection = {
  __typename?: 'LicenseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<License>;
};

export enum LicenseField {
  AutoRenew = 'autoRenew',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  ExpiryReminderDays = 'expiryReminderDays',
  LicenseOrderId = 'licenseOrderID',
  LinkedDeviceId = 'linkedDeviceID',
  ModuleType = 'moduleType',
  OrganisationId = 'organisationID',
  StartDate = 'startDate',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** LicenseModuleType is enum for the field module_type */
export enum LicenseModuleType {
  Device = 'Device',
  User = 'User'
}

/** Ordering options for License connections */
export type LicenseOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Licenses. */
  field: LicenseOrderField;
};

export type LicenseOrderAddon = Node & {
  __typename?: 'LicenseOrderAddon';
  baseLicensePlanAddonID: Scalars['ID']['output'];
  baselicenseaddon: BaseLicensePlanAddon;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  licenseOrderID: Scalars['ID']['output'];
  licenseorder: SubscriptionLicenseOrder;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LicenseOrderAddonConnection = {
  __typename?: 'LicenseOrderAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseOrderAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LicenseOrderAddonEdge = {
  __typename?: 'LicenseOrderAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LicenseOrderAddon>;
};

export enum LicenseOrderAddonField {
  BaseLicensePlanAddonId = 'baseLicensePlanAddonID',
  CreatedAt = 'createdAt',
  LicenseOrderId = 'licenseOrderID',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LicenseOrderAddon connections */
export type LicenseOrderAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LicenseOrderAddons. */
  field: LicenseOrderAddonOrderField;
};

/** Properties by which LicenseOrderAddon connections can be ordered. */
export enum LicenseOrderAddonOrderField {
  Price = 'PRICE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * LicenseOrderAddonWhereInput is used for filtering LicenseOrderAddon objects.
 * Input was generated by ent.
 */
export type LicenseOrderAddonWhereInput = {
  and?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** base_license_plan_addon_id field predicates */
  baseLicensePlanAddonID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanAddonIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanAddonIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanAddonIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** baselicenseaddon edge predicates */
  hasBaselicenseaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** licenseorder edge predicates */
  hasLicenseorder?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** license_order_id field predicates */
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LicenseOrderAddonWhereInput>;
  or?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Properties by which License connections can be ordered. */
export enum LicenseOrderField {
  EndDate = 'END_DATE',
  ModuleType = 'MODULE_TYPE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LicenseStatus is enum for the field status */
export enum LicenseStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Grace = 'Grace',
  Pending = 'Pending'
}

/**
 * LicenseWhereInput is used for filtering License objects.
 * Input was generated by ent.
 */
export type LicenseWhereInput = {
  and?: InputMaybe<Array<LicenseWhereInput>>;
  /** auto_renew field predicates */
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  endDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_reminder_days field predicates */
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysGT?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  expiryReminderDaysLT?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** license_order edge predicates */
  hasLicenseOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrderWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** license_order_id field predicates */
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** linked_device_id field predicates */
  linkedDeviceID?: InputMaybe<Scalars['ID']['input']>;
  linkedDeviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedDeviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  linkedDeviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  linkedDeviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedDeviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** module_type field predicates */
  moduleType?: InputMaybe<LicenseModuleType>;
  moduleTypeIn?: InputMaybe<Array<LicenseModuleType>>;
  moduleTypeNEQ?: InputMaybe<LicenseModuleType>;
  moduleTypeNotIn?: InputMaybe<Array<LicenseModuleType>>;
  not?: InputMaybe<LicenseWhereInput>;
  or?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  startDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<LicenseStatus>;
  statusIn?: InputMaybe<Array<LicenseStatus>>;
  statusNEQ?: InputMaybe<LicenseStatus>;
  statusNotIn?: InputMaybe<Array<LicenseStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LoginLog = Node & {
  __typename?: 'LoginLog';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  identifierType: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LoginLogConnection = {
  __typename?: 'LoginLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoginLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoginLogEdge = {
  __typename?: 'LoginLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoginLog>;
};

export enum LoginLogField {
  Attempts = 'attempts',
  CreatedAt = 'createdAt',
  Identifier = 'identifier',
  IdentifierType = 'identifierType',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LoginLog connections */
export type LoginLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LoginLogs. */
  field: LoginLogOrderField;
};

/** Properties by which LoginLog connections can be ordered. */
export enum LoginLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * LoginLogWhereInput is used for filtering LoginLog objects.
 * Input was generated by ent.
 */
export type LoginLogWhereInput = {
  and?: InputMaybe<Array<LoginLogWhereInput>>;
  /** attempts field predicates */
  attempts?: InputMaybe<Scalars['Int']['input']>;
  attemptsGT?: InputMaybe<Scalars['Int']['input']>;
  attemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptsLT?: InputMaybe<Scalars['Int']['input']>;
  attemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** identifier field predicates */
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  identifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  identifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  identifierGT?: InputMaybe<Scalars['String']['input']>;
  identifierGTE?: InputMaybe<Scalars['String']['input']>;
  identifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  identifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  identifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  identifierLT?: InputMaybe<Scalars['String']['input']>;
  identifierLTE?: InputMaybe<Scalars['String']['input']>;
  identifierNEQ?: InputMaybe<Scalars['String']['input']>;
  identifierNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** identifier_type field predicates */
  identifierType?: InputMaybe<Scalars['String']['input']>;
  identifierTypeContains?: InputMaybe<Scalars['String']['input']>;
  identifierTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  identifierTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  identifierTypeGT?: InputMaybe<Scalars['String']['input']>;
  identifierTypeGTE?: InputMaybe<Scalars['String']['input']>;
  identifierTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  identifierTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  identifierTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  identifierTypeLT?: InputMaybe<Scalars['String']['input']>;
  identifierTypeLTE?: InputMaybe<Scalars['String']['input']>;
  identifierTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  identifierTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<LoginLogWhereInput>;
  or?: InputMaybe<Array<LoginLogWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  organisationUser: OrganisationUser;
  permissions: Array<Maybe<CrudPermission>>;
  token: Scalars['String']['output'];
};

export type MapConfig = Node & {
  __typename?: 'MapConfig';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: MapConfigKey;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type MapConfigConnection = {
  __typename?: 'MapConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MapConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MapConfigEdge = {
  __typename?: 'MapConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MapConfig>;
};

export enum MapConfigField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Value = 'value'
}

/** MapConfigKey is enum for the field key */
export enum MapConfigKey {
  GeofenceLabel = 'geofence_label',
  GroupLabels = 'group_labels',
  IdleSeconds = 'idle_seconds',
  MapCluster = 'map_cluster',
  PeriodicPan = 'periodic_pan',
  PeriodicPanGeoOut = 'periodic_pan_geo_out',
  PoiCluster = 'poi_cluster',
  PoisLoadZoom = 'pois_load_zoom',
  RefreshRate = 'refresh_rate',
  ShowGeofences = 'show_geofences',
  ShowPois = 'show_pois',
  StartStopLineGeofence = 'start_stop_line_geofence',
  ZoomOutOnGeofence = 'zoom_out_on_geofence'
}

/** Ordering options for MapConfig connections */
export type MapConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MapConfigs. */
  field: MapConfigOrderField;
};

/** Properties by which MapConfig connections can be ordered. */
export enum MapConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * MapConfigWhereInput is used for filtering MapConfig objects.
 * Input was generated by ent.
 */
export type MapConfigWhereInput = {
  and?: InputMaybe<Array<MapConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<MapConfigKey>;
  keyIn?: InputMaybe<Array<MapConfigKey>>;
  keyNEQ?: InputMaybe<MapConfigKey>;
  keyNotIn?: InputMaybe<Array<MapConfigKey>>;
  not?: InputMaybe<MapConfigWhereInput>;
  or?: InputMaybe<Array<MapConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaFile = Node & {
  __typename?: 'MediaFile';
  createdAt: Scalars['Time']['output'];
  deviceDocumentMedia?: Maybe<Array<DeviceDocument>>;
  deviceGroupDocumentMedia?: Maybe<Array<DeviceGroupDocument>>;
  deviceModelsMedias?: Maybe<Array<DeviceModel>>;
  export?: Maybe<Export>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  kmls?: Maybe<Array<Kml>>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
  status: MediaFileStatus;
  updatedAt: Scalars['Time']['output'];
  upgrade?: Maybe<Upgrade>;
  user?: Maybe<User>;
  userAvatar?: Maybe<Array<User>>;
  userID?: Maybe<Scalars['ID']['output']>;
  whitelabelLoginLogo?: Maybe<Array<Whitelabel>>;
  whitelabelLogo?: Maybe<Array<Whitelabel>>;
  yardDriverDetailsAvatar?: Maybe<Array<YardDriverProfile>>;
  yardDriverDetailsDlImage?: Maybe<Array<YardDriverProfile>>;
  yardVehicleInsuranceImage?: Maybe<Array<YardVehicle>>;
  yardVehiclePollutionImage?: Maybe<Array<YardVehicle>>;
  yardVehicleRcImage?: Maybe<Array<YardVehicle>>;
};

/** A connection to a list of items. */
export type MediaFileConnection = {
  __typename?: 'MediaFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MediaFileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MediaFileEdge = {
  __typename?: 'MediaFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MediaFile>;
};

export enum MediaFileField {
  CreatedAt = 'createdAt',
  FileName = 'fileName',
  IsPublic = 'isPublic',
  OrganisationId = 'organisationID',
  Path = 'path',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for MediaFile connections */
export type MediaFileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MediaFiles. */
  field: MediaFileOrderField;
};

/** Properties by which MediaFile connections can be ordered. */
export enum MediaFileOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** MediaFileStatus is enum for the field status */
export enum MediaFileStatus {
  Failed = 'Failed',
  Orphaned = 'Orphaned',
  Pending = 'Pending',
  Uploaded = 'Uploaded',
  Uploading = 'Uploading'
}

/**
 * MediaFileWhereInput is used for filtering MediaFile objects.
 * Input was generated by ent.
 */
export type MediaFileWhereInput = {
  and?: InputMaybe<Array<MediaFileWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_name field predicates */
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileNameContains?: InputMaybe<Scalars['String']['input']>;
  fileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileNameGT?: InputMaybe<Scalars['String']['input']>;
  fileNameGTE?: InputMaybe<Scalars['String']['input']>;
  fileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileNameLT?: InputMaybe<Scalars['String']['input']>;
  fileNameLTE?: InputMaybe<Scalars['String']['input']>;
  fileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_document_media edge predicates */
  hasDeviceDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentMediaWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** device_group_document_media edge predicates */
  hasDeviceGroupDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentMediaWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** device_models_medias edge predicates */
  hasDeviceModelsMedias?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelsMediasWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** kmls edge predicates */
  hasKmls?: InputMaybe<Scalars['Boolean']['input']>;
  hasKmlsWith?: InputMaybe<Array<KmlWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_avatar edge predicates */
  hasUserAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserAvatarWith?: InputMaybe<Array<UserWhereInput>>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** whitelabel_login_logo edge predicates */
  hasWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelLoginLogoWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** whitelabel_logo edge predicates */
  hasWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelLogoWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** yard_driver_details_avatar edge predicates */
  hasYardDriverDetailsAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverDetailsAvatarWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_driver_details_dl_image edge predicates */
  hasYardDriverDetailsDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverDetailsDlImageWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_vehicle_insurance_image edge predicates */
  hasYardVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehicleInsuranceImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vehicle_pollution_image edge predicates */
  hasYardVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehiclePollutionImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vehicle_rc_image edge predicates */
  hasYardVehicleRcImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehicleRcImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_public field predicates */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MediaFileWhereInput>;
  or?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<MediaFileStatus>;
  statusIn?: InputMaybe<Array<MediaFileStatus>>;
  statusNEQ?: InputMaybe<MediaFileStatus>;
  statusNotIn?: InputMaybe<Array<MediaFileStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  APIUserCreate: ApiUser;
  APIUserCreateBulk?: Maybe<Array<ApiUser>>;
  APIUserDelete: ApiUser;
  APIUserUpdate: ApiUser;
  BaseAddonCreate: BaseAddon;
  BaseAddonCreateBulk?: Maybe<Array<BaseAddon>>;
  BaseAddonDelete: BaseAddon;
  BaseAddonUpdate: BaseAddon;
  BaseLicensePlanAddonCreate: BaseLicensePlanAddon;
  BaseLicensePlanAddonCreateBulk?: Maybe<Array<BaseLicensePlanAddon>>;
  BaseLicensePlanAddonDelete: BaseLicensePlanAddon;
  BaseLicensePlanAddonUpdate: BaseLicensePlanAddon;
  BaseLicensePlanCreate: BaseLicensePlan;
  BaseLicensePlanCreateBulk?: Maybe<Array<BaseLicensePlan>>;
  BaseLicensePlanDelete: BaseLicensePlan;
  BaseLicensePlanUpdate: BaseLicensePlan;
  BaseReportCreate: BaseReport;
  BaseReportCreateBulk?: Maybe<Array<BaseReport>>;
  BaseReportDelete: BaseReport;
  BaseReportUpdate: BaseReport;
  ChangeLogCreate: ChangeLog;
  ChangeLogCreateBulk?: Maybe<Array<ChangeLog>>;
  ChangeLogDelete: ChangeLog;
  ChangeLogUpdate: ChangeLog;
  ConsumerConfigCreate: ConsumerConfig;
  ConsumerConfigCreateBulk?: Maybe<Array<ConsumerConfig>>;
  ConsumerConfigDelete: ConsumerConfig;
  ConsumerConfigUpdate: ConsumerConfig;
  ConsumerServerCreate: ConsumerServer;
  ConsumerServerCreateBulk?: Maybe<Array<ConsumerServer>>;
  ConsumerServerDelete: ConsumerServer;
  ConsumerServerUpdate: ConsumerServer;
  DerivedReportCreate: DerivedReport;
  DerivedReportCreateBulk?: Maybe<Array<DerivedReport>>;
  DerivedReportDelete: DerivedReport;
  DerivedReportUpdate: DerivedReport;
  DeviceACLCreate: DeviceAcl;
  DeviceACLCreateBulk?: Maybe<Array<DeviceAcl>>;
  DeviceACLDelete: DeviceAcl;
  DeviceACLUpdate: DeviceAcl;
  DeviceActionLogCreate: DeviceActionLog;
  DeviceActionLogCreateBulk?: Maybe<Array<DeviceActionLog>>;
  DeviceActionLogDelete: DeviceActionLog;
  DeviceActionLogUpdate: DeviceActionLog;
  DeviceAddonModelCreate: DeviceAddonModel;
  DeviceAddonModelCreateBulk?: Maybe<Array<DeviceAddonModel>>;
  DeviceAddonModelDelete: DeviceAddonModel;
  DeviceAddonModelUpdate: DeviceAddonModel;
  DeviceAdvancedConfigCreate: DeviceAdvancedConfig;
  DeviceAdvancedConfigCreateBulk?: Maybe<Array<DeviceAdvancedConfig>>;
  DeviceAdvancedConfigDelete: DeviceAdvancedConfig;
  DeviceAdvancedConfigUpdate: DeviceAdvancedConfig;
  DeviceCategoryCreate: DeviceCategory;
  DeviceCategoryCreateBulk?: Maybe<Array<DeviceCategory>>;
  DeviceCategoryDelete: DeviceCategory;
  DeviceCategoryUpdate: DeviceCategory;
  DeviceChannelConfigCreate: DeviceChannelConfig;
  DeviceChannelConfigCreateBulk?: Maybe<Array<DeviceChannelConfig>>;
  DeviceChannelConfigDelete: DeviceChannelConfig;
  DeviceChannelConfigUpdate: DeviceChannelConfig;
  DeviceCommandCreate: DeviceCommand;
  DeviceCommandCreateBulk?: Maybe<Array<DeviceCommand>>;
  DeviceCommandDelete: DeviceCommand;
  DeviceCommandUpdate: DeviceCommand;
  DeviceCreate: Device;
  DeviceCreateBulk?: Maybe<Array<Device>>;
  DeviceDelete: Device;
  DeviceDocumentCreate: DeviceDocument;
  DeviceDocumentCreateBulk?: Maybe<Array<DeviceDocument>>;
  DeviceDocumentDelete: DeviceDocument;
  DeviceDocumentTypeCreate: DeviceDocumentType;
  DeviceDocumentTypeCreateBulk?: Maybe<Array<DeviceDocumentType>>;
  DeviceDocumentTypeDelete: DeviceDocumentType;
  DeviceDocumentTypeUpdate: DeviceDocumentType;
  DeviceDocumentUpdate: DeviceDocument;
  DeviceGroupCreate: DeviceGroup;
  DeviceGroupCreateBulk?: Maybe<Array<DeviceGroup>>;
  DeviceGroupDelete: DeviceGroup;
  DeviceGroupDocumentCreate: DeviceGroupDocument;
  DeviceGroupDocumentCreateBulk?: Maybe<Array<DeviceGroupDocument>>;
  DeviceGroupDocumentDelete: DeviceGroupDocument;
  DeviceGroupDocumentTypeCreate: DeviceGroupDocumentType;
  DeviceGroupDocumentTypeCreateBulk?: Maybe<Array<DeviceGroupDocumentType>>;
  DeviceGroupDocumentTypeDelete: DeviceGroupDocumentType;
  DeviceGroupDocumentTypeUpdate: DeviceGroupDocumentType;
  DeviceGroupDocumentUpdate: DeviceGroupDocument;
  DeviceGroupUpdate: DeviceGroup;
  DeviceModelChannelCreate: DeviceModelChannel;
  DeviceModelChannelCreateBulk?: Maybe<Array<DeviceModelChannel>>;
  DeviceModelChannelDelete: DeviceModelChannel;
  DeviceModelChannelUpdate: DeviceModelChannel;
  DeviceModelCreate: DeviceModel;
  DeviceModelCreateBulk?: Maybe<Array<DeviceModel>>;
  DeviceModelDelete: DeviceModel;
  DeviceModelUpdate: DeviceModel;
  DeviceParkingModeConfigCreate: DeviceParkingModeConfig;
  DeviceParkingModeConfigCreateBulk?: Maybe<Array<DeviceParkingModeConfig>>;
  DeviceParkingModeConfigDelete: DeviceParkingModeConfig;
  DeviceParkingModeConfigUpdate: DeviceParkingModeConfig;
  DeviceSharingCreate: DeviceSharing;
  DeviceSharingCreateBulk?: Maybe<Array<DeviceSharing>>;
  DeviceSharingDelete: DeviceSharing;
  DeviceSharingUpdate: DeviceSharing;
  DeviceUpdate: Device;
  DeviceVehicleCreate: DeviceVehicle;
  DeviceVehicleCreateBulk?: Maybe<Array<DeviceVehicle>>;
  DeviceVehicleDelete: DeviceVehicle;
  DeviceVehicleUpdate: DeviceVehicle;
  DomainCreate: Domain;
  DomainCreateBulk?: Maybe<Array<Domain>>;
  DomainDelete: Domain;
  DomainUpdate: Domain;
  ExportCreate: Export;
  ExportCreateBulk?: Maybe<Array<Export>>;
  ExportDelete: Export;
  ExportUpdate: Export;
  FirebasePrivateKeyCreate: FirebasePrivateKey;
  FirebasePrivateKeyCreateBulk?: Maybe<Array<FirebasePrivateKey>>;
  FirebasePrivateKeyDelete: FirebasePrivateKey;
  FirebasePrivateKeyUpdate: FirebasePrivateKey;
  GeofenceCreate: Geofence;
  GeofenceCreateBulk?: Maybe<Array<Geofence>>;
  GeofenceDelete: Geofence;
  GeofenceDeviceGroupCreate: GeofenceDeviceGroup;
  GeofenceDeviceGroupCreateBulk?: Maybe<Array<GeofenceDeviceGroup>>;
  GeofenceDeviceGroupDelete: GeofenceDeviceGroup;
  GeofenceDeviceGroupUpdate: GeofenceDeviceGroup;
  GeofenceUpdate: Geofence;
  KmlCreate: Kml;
  KmlCreateBulk?: Maybe<Array<Kml>>;
  KmlDelete: Kml;
  KmlUpdate: Kml;
  LegacySyncCreate: LegacySync;
  LegacySyncCreateBulk?: Maybe<Array<LegacySync>>;
  LegacySyncDelete: LegacySync;
  LegacySyncUpdate: LegacySync;
  LicenseCreate: License;
  LicenseCreateBulk?: Maybe<Array<License>>;
  LicenseDelete: License;
  LicenseOrderAddonCreate: LicenseOrderAddon;
  LicenseOrderAddonCreateBulk?: Maybe<Array<LicenseOrderAddon>>;
  LicenseOrderAddonDelete: LicenseOrderAddon;
  LicenseOrderAddonUpdate: LicenseOrderAddon;
  LicenseUpdate: License;
  LoginLogCreate: LoginLog;
  LoginLogCreateBulk?: Maybe<Array<LoginLog>>;
  LoginLogDelete: LoginLog;
  LoginLogUpdate: LoginLog;
  MapConfigCreate: MapConfig;
  MapConfigCreateBulk?: Maybe<Array<MapConfig>>;
  MapConfigDelete: MapConfig;
  MapConfigUpdate: MapConfig;
  MediaFileCreate: MediaFile;
  MediaFileCreateBulk?: Maybe<Array<MediaFile>>;
  MediaFileDelete: MediaFile;
  MediaFileUpdate: MediaFile;
  NotifyChannelCreate: NotifyChannel;
  NotifyChannelCreateBulk?: Maybe<Array<NotifyChannel>>;
  NotifyChannelDelete: NotifyChannel;
  NotifyChannelUpdate: NotifyChannel;
  NotifyConfigChannelCreate: NotifyConfigChannel;
  NotifyConfigChannelCreateBulk?: Maybe<Array<NotifyConfigChannel>>;
  NotifyConfigChannelDelete: NotifyConfigChannel;
  NotifyConfigChannelUpdate: NotifyConfigChannel;
  NotifyConfigCreate: NotifyConfig;
  NotifyConfigCreateBulk?: Maybe<Array<NotifyConfig>>;
  NotifyConfigDelete: NotifyConfig;
  NotifyConfigDeviceGroupCreate: NotifyConfigDeviceGroup;
  NotifyConfigDeviceGroupCreateBulk?: Maybe<Array<NotifyConfigDeviceGroup>>;
  NotifyConfigDeviceGroupDelete: NotifyConfigDeviceGroup;
  NotifyConfigDeviceGroupUpdate: NotifyConfigDeviceGroup;
  NotifyConfigEventCreate: NotifyConfigEvent;
  NotifyConfigEventCreateBulk?: Maybe<Array<NotifyConfigEvent>>;
  NotifyConfigEventDelete: NotifyConfigEvent;
  NotifyConfigEventUpdate: NotifyConfigEvent;
  NotifyConfigGeofenceCreate: NotifyConfigGeofence;
  NotifyConfigGeofenceCreateBulk?: Maybe<Array<NotifyConfigGeofence>>;
  NotifyConfigGeofenceDelete: NotifyConfigGeofence;
  NotifyConfigGeofenceUpdate: NotifyConfigGeofence;
  NotifyConfigUpdate: NotifyConfig;
  NotifyEventOptionCreate: NotifyEventOption;
  NotifyEventOptionCreateBulk?: Maybe<Array<NotifyEventOption>>;
  NotifyEventOptionDelete: NotifyEventOption;
  NotifyEventOptionUpdate: NotifyEventOption;
  OrganisationCreate: Organisation;
  OrganisationCreateBulk?: Maybe<Array<Organisation>>;
  OrganisationDelete: Organisation;
  OrganisationReportAccessCreate: OrganisationReportAccess;
  OrganisationReportAccessCreateBulk?: Maybe<Array<OrganisationReportAccess>>;
  OrganisationReportAccessDelete: OrganisationReportAccess;
  OrganisationReportAccessUpdate: OrganisationReportAccess;
  OrganisationRoleCreate: OrganisationRole;
  OrganisationRoleCreateBulk?: Maybe<Array<OrganisationRole>>;
  OrganisationRoleDelete: OrganisationRole;
  OrganisationRolePermissionCreate: OrganisationRolePermission;
  OrganisationRolePermissionCreateBulk?: Maybe<Array<OrganisationRolePermission>>;
  OrganisationRolePermissionDelete: OrganisationRolePermission;
  OrganisationRolePermissionUpdate: OrganisationRolePermission;
  OrganisationRoleUpdate: OrganisationRole;
  OrganisationUpdate: Organisation;
  OrganisationUpgradeCreate: OrganisationUpgrade;
  OrganisationUpgradeCreateBulk?: Maybe<Array<OrganisationUpgrade>>;
  OrganisationUpgradeDelete: OrganisationUpgrade;
  OrganisationUpgradeUpdate: OrganisationUpgrade;
  OrganisationUserCreate: OrganisationUser;
  OrganisationUserCreateBulk?: Maybe<Array<OrganisationUser>>;
  OrganisationUserDelete: OrganisationUser;
  OrganisationUserDocumentCreate: OrganisationUserDocument;
  OrganisationUserDocumentCreateBulk?: Maybe<Array<OrganisationUserDocument>>;
  OrganisationUserDocumentDelete: OrganisationUserDocument;
  OrganisationUserDocumentTypeCreate: OrganisationUserDocumentType;
  OrganisationUserDocumentTypeCreateBulk?: Maybe<Array<OrganisationUserDocumentType>>;
  OrganisationUserDocumentTypeDelete: OrganisationUserDocumentType;
  OrganisationUserDocumentTypeUpdate: OrganisationUserDocumentType;
  OrganisationUserDocumentUpdate: OrganisationUserDocument;
  OrganisationUserUpdate: OrganisationUser;
  PeriodicJobCreate: PeriodicJob;
  PeriodicJobCreateBulk?: Maybe<Array<PeriodicJob>>;
  PeriodicJobDelete: PeriodicJob;
  PeriodicJobUpdate: PeriodicJob;
  PermissionCreate: Permission;
  PermissionCreateBulk?: Maybe<Array<Permission>>;
  PermissionDelete: Permission;
  PermissionUpdate: Permission;
  PinnedDevicesCreate: PinnedDevices;
  PinnedDevicesCreateBulk?: Maybe<Array<PinnedDevices>>;
  PinnedDevicesDelete: PinnedDevices;
  PinnedDevicesUpdate: PinnedDevices;
  PoiCreate: Poi;
  PoiCreateBulk?: Maybe<Array<Poi>>;
  PoiDelete: Poi;
  PoiUpdate: Poi;
  ProfileCreate: Profile;
  ProfileCreateBulk?: Maybe<Array<Profile>>;
  ProfileDelete: Profile;
  ProfileUpdate: Profile;
  PusherConfigCreate: PusherConfig;
  PusherConfigCreateBulk?: Maybe<Array<PusherConfig>>;
  PusherConfigDelete: PusherConfig;
  PusherConfigUpdate: PusherConfig;
  PusherLogCreate: PusherLog;
  PusherLogCreateBulk?: Maybe<Array<PusherLog>>;
  PusherLogDelete: PusherLog;
  PusherLogUpdate: PusherLog;
  SaveFcmToken: Scalars['Boolean']['output'];
  SettingCreate: Setting;
  SettingCreateBulk?: Maybe<Array<Setting>>;
  SettingDelete: Setting;
  SettingUpdate: Setting;
  SimCreate: Sim;
  SimCreateBulk?: Maybe<Array<Sim>>;
  SimDelete: Sim;
  SimUpdate: Sim;
  StaffRoleCreate: StaffRole;
  StaffRoleCreateBulk?: Maybe<Array<StaffRole>>;
  StaffRoleDelete: StaffRole;
  StaffRoleUpdate: StaffRole;
  SubscriptionLicenseOrderCreate: SubscriptionLicenseOrder;
  SubscriptionLicenseOrderCreateBulk?: Maybe<Array<SubscriptionLicenseOrder>>;
  SubscriptionLicenseOrderDelete: SubscriptionLicenseOrder;
  SubscriptionLicenseOrderUpdate: SubscriptionLicenseOrder;
  SupportDocumentCreate: SupportDocument;
  SupportDocumentCreateBulk?: Maybe<Array<SupportDocument>>;
  SupportDocumentDelete: SupportDocument;
  SupportDocumentUpdate: SupportDocument;
  UpgradeCreate: Upgrade;
  UpgradeCreateBulk?: Maybe<Array<Upgrade>>;
  UpgradeDelete: Upgrade;
  UpgradeOrganisationPriceCreate: UpgradeOrganisationPrice;
  UpgradeOrganisationPriceCreateBulk?: Maybe<Array<UpgradeOrganisationPrice>>;
  UpgradeOrganisationPriceDelete: UpgradeOrganisationPrice;
  UpgradeOrganisationPriceUpdate: UpgradeOrganisationPrice;
  UpgradeUpdate: Upgrade;
  UserConfigCreate: UserConfig;
  UserConfigCreateBulk?: Maybe<Array<UserConfig>>;
  UserConfigDelete: UserConfig;
  UserConfigUpdate: UserConfig;
  UserCreate: User;
  UserCreateBulk?: Maybe<Array<User>>;
  UserDelete: User;
  UserFcmTokenCreate: UserFcmToken;
  UserFcmTokenCreateBulk?: Maybe<Array<UserFcmToken>>;
  UserFcmTokenDelete: UserFcmToken;
  UserFcmTokenUpdate: UserFcmToken;
  UserReportBookmarkCreate: UserReportBookmark;
  UserReportBookmarkCreateBulk?: Maybe<Array<UserReportBookmark>>;
  UserReportBookmarkDelete: UserReportBookmark;
  UserReportBookmarkUpdate: UserReportBookmark;
  UserUpdate: User;
  WalletCreate: Wallet;
  WalletCreateBulk?: Maybe<Array<Wallet>>;
  WalletDelete: Wallet;
  WalletPaymentTransactionCreate: WalletPaymentTransaction;
  WalletPaymentTransactionCreateBulk?: Maybe<Array<WalletPaymentTransaction>>;
  WalletPaymentTransactionDelete: WalletPaymentTransaction;
  WalletPaymentTransactionUpdate: WalletPaymentTransaction;
  WalletTransactionCreate: WalletTransaction;
  WalletTransactionCreateBulk?: Maybe<Array<WalletTransaction>>;
  WalletTransactionDelete: WalletTransaction;
  WalletTransactionUpdate: WalletTransaction;
  WalletUpdate: Wallet;
  WhatsAppConfigCreate: WhatsAppConfig;
  WhatsAppConfigCreateBulk?: Maybe<Array<WhatsAppConfig>>;
  WhatsAppConfigDelete: WhatsAppConfig;
  WhatsAppConfigUpdate: WhatsAppConfig;
  WhitelabelConfigCreate: WhitelabelConfig;
  WhitelabelConfigCreateBulk?: Maybe<Array<WhitelabelConfig>>;
  WhitelabelConfigDelete: WhitelabelConfig;
  WhitelabelConfigUpdate: WhitelabelConfig;
  WhitelabelCoreSettingOverrideCreate: WhitelabelCoreSettingOverride;
  WhitelabelCoreSettingOverrideCreateBulk?: Maybe<Array<WhitelabelCoreSettingOverride>>;
  WhitelabelCoreSettingOverrideDelete: WhitelabelCoreSettingOverride;
  WhitelabelCoreSettingOverrideUpdate: WhitelabelCoreSettingOverride;
  WhitelabelCreate: Whitelabel;
  WhitelabelCreateBulk?: Maybe<Array<Whitelabel>>;
  WhitelabelDelete: Whitelabel;
  WhitelabelUpdate: Whitelabel;
  YardDriverProfileCreate: YardDriverProfile;
  YardDriverProfileCreateBulk?: Maybe<Array<YardDriverProfile>>;
  YardDriverProfileDelete: YardDriverProfile;
  YardDriverProfileUpdate: YardDriverProfile;
  YardMaterialCreate: YardMaterial;
  YardMaterialCreateBulk?: Maybe<Array<YardMaterial>>;
  YardMaterialDelete: YardMaterial;
  YardMaterialTypeCreate: YardMaterialType;
  YardMaterialTypeCreateBulk?: Maybe<Array<YardMaterialType>>;
  YardMaterialTypeDelete: YardMaterialType;
  YardMaterialTypeUpdate: YardMaterialType;
  YardMaterialUpdate: YardMaterial;
  YardTripApprovalCreate: YardTripApproval;
  YardTripApprovalCreateBulk?: Maybe<Array<YardTripApproval>>;
  YardTripApprovalDelete: YardTripApproval;
  YardTripApprovalUpdate: YardTripApproval;
  YardTripCreate: YardTrip;
  YardTripCreateBulk?: Maybe<Array<YardTrip>>;
  YardTripDelete: YardTrip;
  YardTripStatusCreate: YardTripStatus;
  YardTripStatusCreateBulk?: Maybe<Array<YardTripStatus>>;
  YardTripStatusDelete: YardTripStatus;
  YardTripStatusUpdate: YardTripStatus;
  YardTripUpdate: YardTrip;
  YardVehicleCreate: YardVehicle;
  YardVehicleCreateBulk?: Maybe<Array<YardVehicle>>;
  YardVehicleDelete: YardVehicle;
  YardVehicleUpdate: YardVehicle;
  YardVendorCreate: YardVendor;
  YardVendorCreateBulk?: Maybe<Array<YardVendor>>;
  YardVendorDelete: YardVendor;
  YardVendorUpdate: YardVendor;
  YardWarehouseActivityTypeCreate: YardWarehouseActivityType;
  YardWarehouseActivityTypeCreateBulk?: Maybe<Array<YardWarehouseActivityType>>;
  YardWarehouseActivityTypeDelete: YardWarehouseActivityType;
  YardWarehouseActivityTypeUpdate: YardWarehouseActivityType;
  YardWarehouseApprovalMatrixCreate: YardWarehouseApprovalMatrix;
  YardWarehouseApprovalMatrixCreateBulk?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  YardWarehouseApprovalMatrixDelete: YardWarehouseApprovalMatrix;
  YardWarehouseApprovalMatrixUpdate: YardWarehouseApprovalMatrix;
  YardWarehouseCreate: YardWarehouse;
  YardWarehouseCreateBulk?: Maybe<Array<YardWarehouse>>;
  YardWarehouseDelete: YardWarehouse;
  YardWarehouseDockCreate: YardWarehouseDock;
  YardWarehouseDockCreateBulk?: Maybe<Array<YardWarehouseDock>>;
  YardWarehouseDockDelete: YardWarehouseDock;
  YardWarehouseDockUpdate: YardWarehouseDock;
  YardWarehouseParkingCreate: YardWarehouseParking;
  YardWarehouseParkingCreateBulk?: Maybe<Array<YardWarehouseParking>>;
  YardWarehouseParkingDelete: YardWarehouseParking;
  YardWarehouseParkingUpdate: YardWarehouseParking;
  YardWarehouseRouteCreate: YardWarehouseRoute;
  YardWarehouseRouteCreateBulk?: Maybe<Array<YardWarehouseRoute>>;
  YardWarehouseRouteDelete: YardWarehouseRoute;
  YardWarehouseRoutePathCreate: YardWarehouseRoutePath;
  YardWarehouseRoutePathCreateBulk?: Maybe<Array<YardWarehouseRoutePath>>;
  YardWarehouseRoutePathDelete: YardWarehouseRoutePath;
  YardWarehouseRoutePathUpdate: YardWarehouseRoutePath;
  YardWarehouseRouteUpdate: YardWarehouseRoute;
  YardWarehouseUpdate: YardWarehouse;
};


export type MutationApiUserCreateArgs = {
  input: CreateApiUserInput;
};


export type MutationApiUserCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateApiUserInput>>;
};


export type MutationApiUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApiUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiUserInput;
};


export type MutationBaseAddonCreateArgs = {
  input: CreateBaseAddonInput;
};


export type MutationBaseAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseAddonInput>>;
};


export type MutationBaseAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseAddonInput;
};


export type MutationBaseLicensePlanAddonCreateArgs = {
  input: CreateBaseLicensePlanAddonInput;
};


export type MutationBaseLicensePlanAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseLicensePlanAddonInput>>;
};


export type MutationBaseLicensePlanAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseLicensePlanAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseLicensePlanAddonInput;
};


export type MutationBaseLicensePlanCreateArgs = {
  input: CreateBaseLicensePlanInput;
};


export type MutationBaseLicensePlanCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseLicensePlanInput>>;
};


export type MutationBaseLicensePlanDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseLicensePlanUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseLicensePlanInput;
};


export type MutationBaseReportCreateArgs = {
  input: CreateBaseReportInput;
};


export type MutationBaseReportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseReportInput>>;
};


export type MutationBaseReportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseReportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseReportInput;
};


export type MutationChangeLogCreateArgs = {
  input: CreateChangeLogInput;
};


export type MutationChangeLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateChangeLogInput>>;
};


export type MutationChangeLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChangeLogInput;
};


export type MutationConsumerConfigCreateArgs = {
  input: CreateConsumerConfigInput;
};


export type MutationConsumerConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateConsumerConfigInput>>;
};


export type MutationConsumerConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConsumerConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsumerConfigInput;
};


export type MutationConsumerServerCreateArgs = {
  input: CreateConsumerServerInput;
};


export type MutationConsumerServerCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateConsumerServerInput>>;
};


export type MutationConsumerServerDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConsumerServerUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsumerServerInput;
};


export type MutationDerivedReportCreateArgs = {
  input: CreateDerivedReportInput;
};


export type MutationDerivedReportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDerivedReportInput>>;
};


export type MutationDerivedReportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDerivedReportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDerivedReportInput;
};


export type MutationDeviceAclCreateArgs = {
  input: CreateDeviceAclInput;
};


export type MutationDeviceAclCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceAclInput>>;
};


export type MutationDeviceAclDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceAclUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceAclInput;
};


export type MutationDeviceActionLogCreateArgs = {
  input: CreateDeviceActionLogInput;
};


export type MutationDeviceActionLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceActionLogInput>>;
};


export type MutationDeviceActionLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceActionLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceActionLogInput;
};


export type MutationDeviceAddonModelCreateArgs = {
  input: CreateDeviceAddonModelInput;
};


export type MutationDeviceAddonModelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceAddonModelInput>>;
};


export type MutationDeviceAddonModelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceAddonModelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceAddonModelInput;
};


export type MutationDeviceAdvancedConfigCreateArgs = {
  input: CreateDeviceAdvancedConfigInput;
};


export type MutationDeviceAdvancedConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceAdvancedConfigInput>>;
};


export type MutationDeviceAdvancedConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceAdvancedConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceAdvancedConfigInput;
};


export type MutationDeviceCategoryCreateArgs = {
  input: CreateDeviceCategoryInput;
};


export type MutationDeviceCategoryCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceCategoryInput>>;
};


export type MutationDeviceCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceCategoryInput;
};


export type MutationDeviceChannelConfigCreateArgs = {
  input: CreateDeviceChannelConfigInput;
};


export type MutationDeviceChannelConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceChannelConfigInput>>;
};


export type MutationDeviceChannelConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceChannelConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceChannelConfigInput;
};


export type MutationDeviceCommandCreateArgs = {
  input: CreateDeviceCommandInput;
};


export type MutationDeviceCommandCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceCommandInput>>;
};


export type MutationDeviceCommandDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceCommandUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceCommandInput;
};


export type MutationDeviceCreateArgs = {
  input: CreateDeviceInput;
};


export type MutationDeviceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceInput>>;
};


export type MutationDeviceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceDocumentCreateArgs = {
  input: CreateDeviceDocumentInput;
};


export type MutationDeviceDocumentCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceDocumentInput>>;
};


export type MutationDeviceDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceDocumentTypeCreateArgs = {
  input: CreateDeviceDocumentTypeInput;
};


export type MutationDeviceDocumentTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceDocumentTypeInput>>;
};


export type MutationDeviceDocumentTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceDocumentTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceDocumentTypeInput;
};


export type MutationDeviceDocumentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceDocumentInput;
};


export type MutationDeviceGroupCreateArgs = {
  input: CreateDeviceGroupInput;
};


export type MutationDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceGroupInput>>;
};


export type MutationDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceGroupDocumentCreateArgs = {
  input: CreateDeviceGroupDocumentInput;
};


export type MutationDeviceGroupDocumentCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceGroupDocumentInput>>;
};


export type MutationDeviceGroupDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceGroupDocumentTypeCreateArgs = {
  input: CreateDeviceGroupDocumentTypeInput;
};


export type MutationDeviceGroupDocumentTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceGroupDocumentTypeInput>>;
};


export type MutationDeviceGroupDocumentTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceGroupDocumentTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceGroupDocumentTypeInput;
};


export type MutationDeviceGroupDocumentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceGroupDocumentInput;
};


export type MutationDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceGroupInput;
};


export type MutationDeviceModelChannelCreateArgs = {
  input: CreateDeviceModelChannelInput;
};


export type MutationDeviceModelChannelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceModelChannelInput>>;
};


export type MutationDeviceModelChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceModelChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelChannelInput;
};


export type MutationDeviceModelCreateArgs = {
  input: CreateDeviceModelInput;
};


export type MutationDeviceModelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceModelInput>>;
};


export type MutationDeviceModelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceModelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelInput;
};


export type MutationDeviceParkingModeConfigCreateArgs = {
  input: CreateDeviceParkingModeConfigInput;
};


export type MutationDeviceParkingModeConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceParkingModeConfigInput>>;
};


export type MutationDeviceParkingModeConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceParkingModeConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceParkingModeConfigInput;
};


export type MutationDeviceSharingCreateArgs = {
  input: CreateDeviceSharingInput;
};


export type MutationDeviceSharingCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceSharingInput>>;
};


export type MutationDeviceSharingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceSharingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceSharingInput;
};


export type MutationDeviceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceInput;
};


export type MutationDeviceVehicleCreateArgs = {
  input: CreateDeviceVehicleInput;
};


export type MutationDeviceVehicleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceVehicleInput>>;
};


export type MutationDeviceVehicleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceVehicleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceVehicleInput;
};


export type MutationDomainCreateArgs = {
  input: CreateDomainInput;
};


export type MutationDomainCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDomainInput>>;
};


export type MutationDomainDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDomainUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDomainInput;
};


export type MutationExportCreateArgs = {
  input: CreateExportInput;
};


export type MutationExportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateExportInput>>;
};


export type MutationExportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExportInput;
};


export type MutationFirebasePrivateKeyCreateArgs = {
  input: CreateFirebasePrivateKeyInput;
};


export type MutationFirebasePrivateKeyCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateFirebasePrivateKeyInput>>;
};


export type MutationFirebasePrivateKeyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFirebasePrivateKeyUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFirebasePrivateKeyInput;
};


export type MutationGeofenceCreateArgs = {
  input: CreateGeofenceInput;
};


export type MutationGeofenceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateGeofenceInput>>;
};


export type MutationGeofenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGeofenceDeviceGroupCreateArgs = {
  input: CreateGeofenceDeviceGroupInput;
};


export type MutationGeofenceDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateGeofenceDeviceGroupInput>>;
};


export type MutationGeofenceDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGeofenceDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGeofenceDeviceGroupInput;
};


export type MutationGeofenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGeofenceInput;
};


export type MutationKmlCreateArgs = {
  input: CreateKmlInput;
};


export type MutationKmlCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateKmlInput>>;
};


export type MutationKmlDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationKmlUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKmlInput;
};


export type MutationLegacySyncCreateArgs = {
  input: CreateLegacySyncInput;
};


export type MutationLegacySyncCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLegacySyncInput>>;
};


export type MutationLegacySyncDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLegacySyncUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLegacySyncInput;
};


export type MutationLicenseCreateArgs = {
  input: CreateLicenseInput;
};


export type MutationLicenseCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLicenseInput>>;
};


export type MutationLicenseDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLicenseOrderAddonCreateArgs = {
  input: CreateLicenseOrderAddonInput;
};


export type MutationLicenseOrderAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLicenseOrderAddonInput>>;
};


export type MutationLicenseOrderAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLicenseOrderAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLicenseOrderAddonInput;
};


export type MutationLicenseUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLicenseInput;
};


export type MutationLoginLogCreateArgs = {
  input: CreateLoginLogInput;
};


export type MutationLoginLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLoginLogInput>>;
};


export type MutationLoginLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLoginLogInput;
};


export type MutationMapConfigCreateArgs = {
  input: CreateMapConfigInput;
};


export type MutationMapConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateMapConfigInput>>;
};


export type MutationMapConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMapConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMapConfigInput;
};


export type MutationMediaFileCreateArgs = {
  input: CreateMediaFileInput;
};


export type MutationMediaFileCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateMediaFileInput>>;
};


export type MutationMediaFileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMediaFileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMediaFileInput;
};


export type MutationNotifyChannelCreateArgs = {
  input: CreateNotifyChannelInput;
};


export type MutationNotifyChannelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyChannelInput>>;
};


export type MutationNotifyChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyChannelInput;
};


export type MutationNotifyConfigChannelCreateArgs = {
  input: CreateNotifyConfigChannelInput;
};


export type MutationNotifyConfigChannelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigChannelInput>>;
};


export type MutationNotifyConfigChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigChannelInput;
};


export type MutationNotifyConfigCreateArgs = {
  input: CreateNotifyConfigInput;
};


export type MutationNotifyConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigInput>>;
};


export type MutationNotifyConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigDeviceGroupCreateArgs = {
  input: CreateNotifyConfigDeviceGroupInput;
};


export type MutationNotifyConfigDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigDeviceGroupInput>>;
};


export type MutationNotifyConfigDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigDeviceGroupInput;
};


export type MutationNotifyConfigEventCreateArgs = {
  input: CreateNotifyConfigEventInput;
};


export type MutationNotifyConfigEventCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigEventInput>>;
};


export type MutationNotifyConfigEventDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigEventUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigEventInput;
};


export type MutationNotifyConfigGeofenceCreateArgs = {
  input: CreateNotifyConfigGeofenceInput;
};


export type MutationNotifyConfigGeofenceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigGeofenceInput>>;
};


export type MutationNotifyConfigGeofenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigGeofenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigGeofenceInput;
};


export type MutationNotifyConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigInput;
};


export type MutationNotifyEventOptionCreateArgs = {
  input: CreateNotifyEventOptionInput;
};


export type MutationNotifyEventOptionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyEventOptionInput>>;
};


export type MutationNotifyEventOptionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyEventOptionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyEventOptionInput;
};


export type MutationOrganisationCreateArgs = {
  input: CreateOrganisationInput;
};


export type MutationOrganisationCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationInput>>;
};


export type MutationOrganisationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationReportAccessCreateArgs = {
  input: CreateOrganisationReportAccessInput;
};


export type MutationOrganisationReportAccessCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationReportAccessInput>>;
};


export type MutationOrganisationReportAccessDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationReportAccessUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationReportAccessInput;
};


export type MutationOrganisationRoleCreateArgs = {
  input: CreateOrganisationRoleInput;
};


export type MutationOrganisationRoleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationRoleInput>>;
};


export type MutationOrganisationRoleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationRolePermissionCreateArgs = {
  input: CreateOrganisationRolePermissionInput;
};


export type MutationOrganisationRolePermissionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationRolePermissionInput>>;
};


export type MutationOrganisationRolePermissionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationRolePermissionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationRolePermissionInput;
};


export type MutationOrganisationRoleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationRoleInput;
};


export type MutationOrganisationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationInput;
};


export type MutationOrganisationUpgradeCreateArgs = {
  input: CreateOrganisationUpgradeInput;
};


export type MutationOrganisationUpgradeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUpgradeInput>>;
};


export type MutationOrganisationUpgradeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUpgradeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUpgradeInput;
};


export type MutationOrganisationUserCreateArgs = {
  input: CreateOrganisationUserInput;
};


export type MutationOrganisationUserCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUserInput>>;
};


export type MutationOrganisationUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUserDocumentCreateArgs = {
  input: CreateOrganisationUserDocumentInput;
};


export type MutationOrganisationUserDocumentCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUserDocumentInput>>;
};


export type MutationOrganisationUserDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUserDocumentTypeCreateArgs = {
  input: CreateOrganisationUserDocumentTypeInput;
};


export type MutationOrganisationUserDocumentTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUserDocumentTypeInput>>;
};


export type MutationOrganisationUserDocumentTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUserDocumentTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUserDocumentTypeInput;
};


export type MutationOrganisationUserDocumentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUserDocumentInput;
};


export type MutationOrganisationUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUserInput;
};


export type MutationPeriodicJobCreateArgs = {
  input: CreatePeriodicJobInput;
};


export type MutationPeriodicJobCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePeriodicJobInput>>;
};


export type MutationPeriodicJobDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPeriodicJobUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePeriodicJobInput;
};


export type MutationPermissionCreateArgs = {
  input: CreatePermissionInput;
};


export type MutationPermissionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePermissionInput>>;
};


export type MutationPermissionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPermissionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePermissionInput;
};


export type MutationPinnedDevicesCreateArgs = {
  input: CreatePinnedDevicesInput;
};


export type MutationPinnedDevicesCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePinnedDevicesInput>>;
};


export type MutationPinnedDevicesDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinnedDevicesUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePinnedDevicesInput;
};


export type MutationPoiCreateArgs = {
  input: CreatePoiInput;
};


export type MutationPoiCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePoiInput>>;
};


export type MutationPoiDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPoiUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePoiInput;
};


export type MutationProfileCreateArgs = {
  input: CreateProfileInput;
};


export type MutationProfileCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateProfileInput>>;
};


export type MutationProfileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProfileInput;
};


export type MutationPusherConfigCreateArgs = {
  input: CreatePusherConfigInput;
};


export type MutationPusherConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePusherConfigInput>>;
};


export type MutationPusherConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPusherConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePusherConfigInput;
};


export type MutationPusherLogCreateArgs = {
  input: CreatePusherLogInput;
};


export type MutationPusherLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePusherLogInput>>;
};


export type MutationPusherLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPusherLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePusherLogInput;
};


export type MutationSaveFcmTokenArgs = {
  fcmSenderId: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformKind: NotifyChannelFcmDevicePlatform;
  platformUniqueId: Scalars['String']['input'];
};


export type MutationSettingCreateArgs = {
  input: CreateSettingInput;
};


export type MutationSettingCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSettingInput>>;
};


export type MutationSettingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSettingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSettingInput;
};


export type MutationSimCreateArgs = {
  input: CreateSimInput;
};


export type MutationSimCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSimInput>>;
};


export type MutationSimDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSimUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSimInput;
};


export type MutationStaffRoleCreateArgs = {
  input: CreateStaffRoleInput;
};


export type MutationStaffRoleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateStaffRoleInput>>;
};


export type MutationStaffRoleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStaffRoleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStaffRoleInput;
};


export type MutationSubscriptionLicenseOrderCreateArgs = {
  input: CreateSubscriptionLicenseOrderInput;
};


export type MutationSubscriptionLicenseOrderCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSubscriptionLicenseOrderInput>>;
};


export type MutationSubscriptionLicenseOrderDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscriptionLicenseOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionLicenseOrderInput;
};


export type MutationSupportDocumentCreateArgs = {
  input: CreateSupportDocumentInput;
};


export type MutationSupportDocumentCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSupportDocumentInput>>;
};


export type MutationSupportDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSupportDocumentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupportDocumentInput;
};


export type MutationUpgradeCreateArgs = {
  input: CreateUpgradeInput;
};


export type MutationUpgradeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUpgradeInput>>;
};


export type MutationUpgradeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpgradeOrganisationPriceCreateArgs = {
  input: CreateUpgradeOrganisationPriceInput;
};


export type MutationUpgradeOrganisationPriceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUpgradeOrganisationPriceInput>>;
};


export type MutationUpgradeOrganisationPriceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpgradeOrganisationPriceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUpgradeOrganisationPriceInput;
};


export type MutationUpgradeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUpgradeInput;
};


export type MutationUserConfigCreateArgs = {
  input: CreateUserConfigInput;
};


export type MutationUserConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserConfigInput>>;
};


export type MutationUserConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserConfigInput;
};


export type MutationUserCreateArgs = {
  input: CreateUserInput;
};


export type MutationUserCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserInput>>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserFcmTokenCreateArgs = {
  input: CreateUserFcmTokenInput;
};


export type MutationUserFcmTokenCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserFcmTokenInput>>;
};


export type MutationUserFcmTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserFcmTokenUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserFcmTokenInput;
};


export type MutationUserReportBookmarkCreateArgs = {
  input: CreateUserReportBookmarkInput;
};


export type MutationUserReportBookmarkCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserReportBookmarkInput>>;
};


export type MutationUserReportBookmarkDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserReportBookmarkUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserReportBookmarkInput;
};


export type MutationUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationWalletCreateArgs = {
  input: CreateWalletInput;
};


export type MutationWalletCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletInput>>;
};


export type MutationWalletDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletPaymentTransactionCreateArgs = {
  input: CreateWalletPaymentTransactionInput;
};


export type MutationWalletPaymentTransactionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletPaymentTransactionInput>>;
};


export type MutationWalletPaymentTransactionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletPaymentTransactionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletPaymentTransactionInput;
};


export type MutationWalletTransactionCreateArgs = {
  input: CreateWalletTransactionInput;
};


export type MutationWalletTransactionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletTransactionInput>>;
};


export type MutationWalletTransactionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletTransactionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletTransactionInput;
};


export type MutationWalletUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletInput;
};


export type MutationWhatsAppConfigCreateArgs = {
  input: CreateWhatsAppConfigInput;
};


export type MutationWhatsAppConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWhatsAppConfigInput>>;
};


export type MutationWhatsAppConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWhatsAppConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWhatsAppConfigInput;
};


export type MutationWhitelabelConfigCreateArgs = {
  input: CreateWhitelabelConfigInput;
};


export type MutationWhitelabelConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWhitelabelConfigInput>>;
};


export type MutationWhitelabelConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWhitelabelConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWhitelabelConfigInput;
};


export type MutationWhitelabelCoreSettingOverrideCreateArgs = {
  input: CreateWhitelabelCoreSettingOverrideInput;
};


export type MutationWhitelabelCoreSettingOverrideCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWhitelabelCoreSettingOverrideInput>>;
};


export type MutationWhitelabelCoreSettingOverrideDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWhitelabelCoreSettingOverrideUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWhitelabelCoreSettingOverrideInput;
};


export type MutationWhitelabelCreateArgs = {
  input: CreateWhitelabelInput;
};


export type MutationWhitelabelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWhitelabelInput>>;
};


export type MutationWhitelabelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWhitelabelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWhitelabelInput;
};


export type MutationYardDriverProfileCreateArgs = {
  input: CreateYardDriverProfileInput;
};


export type MutationYardDriverProfileCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardDriverProfileInput>>;
};


export type MutationYardDriverProfileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardDriverProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardDriverProfileInput;
};


export type MutationYardMaterialCreateArgs = {
  input: CreateYardMaterialInput;
};


export type MutationYardMaterialCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardMaterialInput>>;
};


export type MutationYardMaterialDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardMaterialTypeCreateArgs = {
  input: CreateYardMaterialTypeInput;
};


export type MutationYardMaterialTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardMaterialTypeInput>>;
};


export type MutationYardMaterialTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardMaterialTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardMaterialTypeInput;
};


export type MutationYardMaterialUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardMaterialInput;
};


export type MutationYardTripApprovalCreateArgs = {
  input: CreateYardTripApprovalInput;
};


export type MutationYardTripApprovalCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardTripApprovalInput>>;
};


export type MutationYardTripApprovalDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardTripApprovalUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardTripApprovalInput;
};


export type MutationYardTripCreateArgs = {
  input: CreateYardTripInput;
};


export type MutationYardTripCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardTripInput>>;
};


export type MutationYardTripDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardTripStatusCreateArgs = {
  input: CreateYardTripStatusInput;
};


export type MutationYardTripStatusCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardTripStatusInput>>;
};


export type MutationYardTripStatusDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardTripStatusUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardTripStatusInput;
};


export type MutationYardTripUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardTripInput;
};


export type MutationYardVehicleCreateArgs = {
  input: CreateYardVehicleInput;
};


export type MutationYardVehicleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardVehicleInput>>;
};


export type MutationYardVehicleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardVehicleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardVehicleInput;
};


export type MutationYardVendorCreateArgs = {
  input: CreateYardVendorInput;
};


export type MutationYardVendorCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardVendorInput>>;
};


export type MutationYardVendorDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardVendorUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardVendorInput;
};


export type MutationYardWarehouseActivityTypeCreateArgs = {
  input: CreateYardWarehouseActivityTypeInput;
};


export type MutationYardWarehouseActivityTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseActivityTypeInput>>;
};


export type MutationYardWarehouseActivityTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseActivityTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseActivityTypeInput;
};


export type MutationYardWarehouseApprovalMatrixCreateArgs = {
  input: CreateYardWarehouseApprovalMatrixInput;
};


export type MutationYardWarehouseApprovalMatrixCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseApprovalMatrixInput>>;
};


export type MutationYardWarehouseApprovalMatrixDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseApprovalMatrixUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseApprovalMatrixInput;
};


export type MutationYardWarehouseCreateArgs = {
  input: CreateYardWarehouseInput;
};


export type MutationYardWarehouseCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseInput>>;
};


export type MutationYardWarehouseDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseDockCreateArgs = {
  input: CreateYardWarehouseDockInput;
};


export type MutationYardWarehouseDockCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseDockInput>>;
};


export type MutationYardWarehouseDockDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseDockUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseDockInput;
};


export type MutationYardWarehouseParkingCreateArgs = {
  input: CreateYardWarehouseParkingInput;
};


export type MutationYardWarehouseParkingCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseParkingInput>>;
};


export type MutationYardWarehouseParkingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseParkingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseParkingInput;
};


export type MutationYardWarehouseRouteCreateArgs = {
  input: CreateYardWarehouseRouteInput;
};


export type MutationYardWarehouseRouteCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseRouteInput>>;
};


export type MutationYardWarehouseRouteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseRoutePathCreateArgs = {
  input: CreateYardWarehouseRoutePathInput;
};


export type MutationYardWarehouseRoutePathCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseRoutePathInput>>;
};


export type MutationYardWarehouseRoutePathDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseRoutePathUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseRoutePathInput;
};


export type MutationYardWarehouseRouteUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseRouteInput;
};


export type MutationYardWarehouseUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseInput;
};

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type NotifyChannel = Node & {
  __typename?: 'NotifyChannel';
  bodyTemplate: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  emailTo: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fcmDevicePlatform: NotifyChannelFcmDevicePlatform;
  fcmSenderID: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: NotifyChannelKind;
  linkedData: Scalars['String']['output'];
  loggedInDeviceID: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  serverNotes: Scalars['String']['output'];
  smsCountryCode: Scalars['Int']['output'];
  smsNumber: Scalars['Int']['output'];
  subjectTemplate: Scalars['String']['output'];
  telegramBotToken: Scalars['String']['output'];
  telegramChatID: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyChannelConnection = {
  __typename?: 'NotifyChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyChannelEdge = {
  __typename?: 'NotifyChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyChannel>;
};

/** NotifyChannelFcmDevicePlatform is enum for the field fcm_device_platform */
export enum NotifyChannelFcmDevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum NotifyChannelField {
  BodyTemplate = 'bodyTemplate',
  CreatedAt = 'createdAt',
  EmailTo = 'emailTo',
  Enabled = 'enabled',
  FcmDevicePlatform = 'fcmDevicePlatform',
  FcmSenderId = 'fcmSenderID',
  FcmToken = 'fcmToken',
  Kind = 'kind',
  LinkedData = 'linkedData',
  LoggedInDeviceId = 'loggedInDeviceID',
  Name = 'name',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  ServerNotes = 'serverNotes',
  SmsCountryCode = 'smsCountryCode',
  SmsNumber = 'smsNumber',
  SubjectTemplate = 'subjectTemplate',
  TelegramBotToken = 'telegramBotToken',
  TelegramChatId = 'telegramChatID',
  UpdatedAt = 'updatedAt'
}

/** NotifyChannelKind is enum for the field kind */
export enum NotifyChannelKind {
  Call = 'Call',
  Email = 'Email',
  Push = 'Push',
  Sms = 'SMS',
  Telegram = 'Telegram',
  Webhook = 'Webhook',
  Whatsapp = 'Whatsapp'
}

/** Ordering options for NotifyChannel connections */
export type NotifyChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyChannels. */
  field: NotifyChannelOrderField;
};

/** Properties by which NotifyChannel connections can be ordered. */
export enum NotifyChannelOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyChannelWhereInput is used for filtering NotifyChannel objects.
 * Input was generated by ent.
 */
export type NotifyChannelWhereInput = {
  and?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** body_template field predicates */
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateContains?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateGT?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyTemplateLT?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email_to field predicates */
  emailTo?: InputMaybe<Scalars['String']['input']>;
  emailToContains?: InputMaybe<Scalars['String']['input']>;
  emailToContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailToEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailToGT?: InputMaybe<Scalars['String']['input']>;
  emailToGTE?: InputMaybe<Scalars['String']['input']>;
  emailToHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailToHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailToIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailToLT?: InputMaybe<Scalars['String']['input']>;
  emailToLTE?: InputMaybe<Scalars['String']['input']>;
  emailToNEQ?: InputMaybe<Scalars['String']['input']>;
  emailToNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fcm_device_platform field predicates */
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmDevicePlatformIn?: InputMaybe<Array<NotifyChannelFcmDevicePlatform>>;
  fcmDevicePlatformNEQ?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmDevicePlatformNotIn?: InputMaybe<Array<NotifyChannelFcmDevicePlatform>>;
  /** fcm_sender_id field predicates */
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContains?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDLT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDLTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_token field predicates */
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContains?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmTokenLT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenLTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotifyChannelKind>;
  kindIn?: InputMaybe<Array<NotifyChannelKind>>;
  kindNEQ?: InputMaybe<NotifyChannelKind>;
  kindNotIn?: InputMaybe<Array<NotifyChannelKind>>;
  /** linked_data field predicates */
  linkedData?: InputMaybe<Scalars['String']['input']>;
  linkedDataContains?: InputMaybe<Scalars['String']['input']>;
  linkedDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  linkedDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  linkedDataGT?: InputMaybe<Scalars['String']['input']>;
  linkedDataGTE?: InputMaybe<Scalars['String']['input']>;
  linkedDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  linkedDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  linkedDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedDataLT?: InputMaybe<Scalars['String']['input']>;
  linkedDataLTE?: InputMaybe<Scalars['String']['input']>;
  linkedDataNEQ?: InputMaybe<Scalars['String']['input']>;
  linkedDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** logged_in_device_id field predicates */
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDContains?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDGT?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDGTE?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  loggedInDeviceIDLT?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDLTE?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDNEQ?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyChannelWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** server_notes field predicates */
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  serverNotesContains?: InputMaybe<Scalars['String']['input']>;
  serverNotesContainsFold?: InputMaybe<Scalars['String']['input']>;
  serverNotesEqualFold?: InputMaybe<Scalars['String']['input']>;
  serverNotesGT?: InputMaybe<Scalars['String']['input']>;
  serverNotesGTE?: InputMaybe<Scalars['String']['input']>;
  serverNotesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  serverNotesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  serverNotesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  serverNotesLT?: InputMaybe<Scalars['String']['input']>;
  serverNotesLTE?: InputMaybe<Scalars['String']['input']>;
  serverNotesNEQ?: InputMaybe<Scalars['String']['input']>;
  serverNotesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sms_country_code field predicates */
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeGT?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  smsCountryCodeLT?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** sms_number field predicates */
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  smsNumberGT?: InputMaybe<Scalars['Int']['input']>;
  smsNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  smsNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  smsNumberLT?: InputMaybe<Scalars['Int']['input']>;
  smsNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  smsNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  smsNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** subject_template field predicates */
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateContains?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateGT?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectTemplateLT?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** telegram_bot_token field predicates */
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenContains?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenGT?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenGTE?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  telegramBotTokenLT?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenLTE?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** telegram_chat_id field predicates */
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDContains?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDGT?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDGTE?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  telegramChatIDLT?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDLTE?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDNEQ?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotifyConfig = Node & {
  __typename?: 'NotifyConfig';
  alertWindow: Scalars['Boolean']['output'];
  alertWindowEnd?: Maybe<Scalars['TimeOnly']['output']>;
  alertWindowStart?: Maybe<Scalars['TimeOnly']['output']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset: Scalars['Int']['output'];
  autoAddNewDevices: Scalars['Boolean']['output'];
  autoAddNewGeofences: Scalars['Boolean']['output'];
  channels?: Maybe<Array<NotifyChannel>>;
  createdAt: Scalars['Time']['output'];
  deviceGroups?: Maybe<Array<DeviceGroup>>;
  enabled: Scalars['Boolean']['output'];
  events?: Maybe<Array<NotifyEventOption>>;
  geofences?: Maybe<Array<Geofence>>;
  id: Scalars['ID']['output'];
  ignoreDuplicateForSeconds: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifyConfigChannels?: Maybe<Array<NotifyConfigChannel>>;
  notifyConfigDeviceGroups?: Maybe<Array<NotifyConfigDeviceGroup>>;
  notifyConfigEvents?: Maybe<Array<NotifyConfigEvent>>;
  notifyConfigGeofences?: Maybe<Array<NotifyConfigGeofence>>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  priority: NotifyConfigPriority;
  updatedAt: Scalars['Time']['output'];
};

export type NotifyConfigChannel = Node & {
  __typename?: 'NotifyConfigChannel';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notifyChannel: NotifyChannel;
  notifyChannelID: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigChannelConnection = {
  __typename?: 'NotifyConfigChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigChannelEdge = {
  __typename?: 'NotifyConfigChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigChannel>;
};

export enum NotifyConfigChannelField {
  CreatedAt = 'createdAt',
  NotifyChannelId = 'notifyChannelID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigChannel connections */
export type NotifyConfigChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigChannels. */
  field: NotifyConfigChannelOrderField;
};

/** Properties by which NotifyConfigChannel connections can be ordered. */
export enum NotifyConfigChannelOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigChannelWhereInput is used for filtering NotifyConfigChannel objects.
 * Input was generated by ent.
 */
export type NotifyConfigChannelWhereInput = {
  and?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigChannelWhereInput>;
  or?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type NotifyConfigConnection = {
  __typename?: 'NotifyConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type NotifyConfigDeviceGroup = Node & {
  __typename?: 'NotifyConfigDeviceGroup';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigDeviceGroupConnection = {
  __typename?: 'NotifyConfigDeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigDeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigDeviceGroupEdge = {
  __typename?: 'NotifyConfigDeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigDeviceGroup>;
};

export enum NotifyConfigDeviceGroupField {
  CreatedAt = 'createdAt',
  DeviceGroupId = 'deviceGroupID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigDeviceGroup connections */
export type NotifyConfigDeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigDeviceGroups. */
  field: NotifyConfigDeviceGroupOrderField;
};

/** Properties by which NotifyConfigDeviceGroup connections can be ordered. */
export enum NotifyConfigDeviceGroupOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigDeviceGroupWhereInput is used for filtering NotifyConfigDeviceGroup objects.
 * Input was generated by ent.
 */
export type NotifyConfigDeviceGroupWhereInput = {
  and?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
  or?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type NotifyConfigEdge = {
  __typename?: 'NotifyConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfig>;
};

export type NotifyConfigEvent = Node & {
  __typename?: 'NotifyConfigEvent';
  acceptableMax: Scalars['Float']['output'];
  acceptableMin: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  distanceMeters: Scalars['Float']['output'];
  distanceToleranceMeters: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  notifyEventOption: NotifyEventOption;
  notifyEventOptionID: Scalars['ID']['output'];
  speedToleranceKnots: Scalars['Float']['output'];
  timeToleranceSeconds: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  waitTimeSeconds: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigEventConnection = {
  __typename?: 'NotifyConfigEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigEventEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigEventEdge = {
  __typename?: 'NotifyConfigEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigEvent>;
};

export enum NotifyConfigEventField {
  AcceptableMax = 'acceptableMax',
  AcceptableMin = 'acceptableMin',
  CreatedAt = 'createdAt',
  DistanceMeters = 'distanceMeters',
  DistanceToleranceMeters = 'distanceToleranceMeters',
  NotifyConfigId = 'notifyConfigID',
  NotifyEventOptionId = 'notifyEventOptionID',
  SpeedToleranceKnots = 'speedToleranceKnots',
  TimeToleranceSeconds = 'timeToleranceSeconds',
  UpdatedAt = 'updatedAt',
  WaitTimeSeconds = 'waitTimeSeconds'
}

/** Ordering options for NotifyConfigEvent connections */
export type NotifyConfigEventOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigEvents. */
  field: NotifyConfigEventOrderField;
};

/** Properties by which NotifyConfigEvent connections can be ordered. */
export enum NotifyConfigEventOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigEventWhereInput is used for filtering NotifyConfigEvent objects.
 * Input was generated by ent.
 */
export type NotifyConfigEventWhereInput = {
  /** acceptable_max field predicates */
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxGT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxGTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  acceptableMaxLT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxLTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxNEQ?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** acceptable_min field predicates */
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinGT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinGTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  acceptableMinLT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinLTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinNEQ?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** distance_meters field predicates */
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** distance_tolerance_meters field predicates */
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceToleranceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigEventWhereInput>;
  or?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** speed_tolerance_knots field predicates */
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsGT?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsGTE?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  speedToleranceKnotsLT?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsLTE?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsNEQ?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** time_tolerance_seconds field predicates */
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsGT?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsGTE?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeToleranceSecondsLT?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsLTE?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsNEQ?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wait_time_seconds field predicates */
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsGT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsGTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  waitTimeSecondsLT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsLTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsNEQ?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum NotifyConfigField {
  AlertWindow = 'alertWindow',
  AlertWindowEnd = 'alertWindowEnd',
  AlertWindowStart = 'alertWindowStart',
  AlertWindowToUtcOffset = 'alertWindowToUtcOffset',
  AutoAddNewDevices = 'autoAddNewDevices',
  AutoAddNewGeofences = 'autoAddNewGeofences',
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  IgnoreDuplicateForSeconds = 'ignoreDuplicateForSeconds',
  Name = 'name',
  OrganisationId = 'organisationID',
  Priority = 'priority',
  UpdatedAt = 'updatedAt'
}

export type NotifyConfigGeofence = Node & {
  __typename?: 'NotifyConfigGeofence';
  createdAt: Scalars['Time']['output'];
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigGeofenceConnection = {
  __typename?: 'NotifyConfigGeofenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigGeofenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigGeofenceEdge = {
  __typename?: 'NotifyConfigGeofenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigGeofence>;
};

export enum NotifyConfigGeofenceField {
  CreatedAt = 'createdAt',
  GeofenceId = 'geofenceID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigGeofence connections */
export type NotifyConfigGeofenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigGeofences. */
  field: NotifyConfigGeofenceOrderField;
};

/** Properties by which NotifyConfigGeofence connections can be ordered. */
export enum NotifyConfigGeofenceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigGeofenceWhereInput is used for filtering NotifyConfigGeofence objects.
 * Input was generated by ent.
 */
export type NotifyConfigGeofenceWhereInput = {
  and?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigGeofenceWhereInput>;
  or?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Ordering options for NotifyConfig connections */
export type NotifyConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigs. */
  field: NotifyConfigOrderField;
};

/** Properties by which NotifyConfig connections can be ordered. */
export enum NotifyConfigOrderField {
  AlertWindowEnd = 'alertWindowEnd',
  AlertWindowStart = 'alertWindowStart',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** NotifyConfigPriority is enum for the field priority */
export enum NotifyConfigPriority {
  Alarm = 'Alarm',
  Normal = 'Normal'
}

/**
 * NotifyConfigWhereInput is used for filtering NotifyConfig objects.
 * Input was generated by ent.
 */
export type NotifyConfigWhereInput = {
  /** alert_window field predicates */
  alertWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_end field predicates */
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndGT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndGTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowEndLT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndLTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndNEQ?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndNotIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_start field predicates */
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartGT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartGTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowStartLT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartLTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartNEQ?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartNotIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_to_utc_offset field predicates */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetGT?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetGTE?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  alertWindowToUtcOffsetLT?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetLTE?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetNEQ?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** auto_add_new_devices field predicates */
  autoAddNewDevices?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewDevicesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** auto_add_new_geofences field predicates */
  autoAddNewGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewGeofencesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** channels edge predicates */
  hasChannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasChannelsWith?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** device_groups edge predicates */
  hasDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** geofences edge predicates */
  hasGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofencesWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** notify_config_channels edge predicates */
  hasNotifyConfigChannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigChannelsWith?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** notify_config_device_groups edge predicates */
  hasNotifyConfigDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigDeviceGroupsWith?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** notify_config_events edge predicates */
  hasNotifyConfigEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigEventsWith?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** notify_config_geofences edge predicates */
  hasNotifyConfigGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigGeofencesWith?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ignore_duplicate_for_seconds field predicates */
  ignoreDuplicateForSeconds?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ignoreDuplicateForSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyConfigWhereInput>;
  or?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** priority field predicates */
  priority?: InputMaybe<NotifyConfigPriority>;
  priorityIn?: InputMaybe<Array<NotifyConfigPriority>>;
  priorityNEQ?: InputMaybe<NotifyConfigPriority>;
  priorityNotIn?: InputMaybe<Array<NotifyConfigPriority>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotifyEventOption = Node & {
  __typename?: 'NotifyEventOption';
  acceptableMax: Scalars['Boolean']['output'];
  acceptableMaxLabel: Scalars['String']['output'];
  acceptableMin: Scalars['Boolean']['output'];
  acceptableMinLabel: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  distanceMeters: Scalars['Boolean']['output'];
  distanceMetersLabel: Scalars['String']['output'];
  distanceToleranceMeters: Scalars['Boolean']['output'];
  distanceToleranceMetersLabel: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Source of event for backend processing */
  kind: NotifyEventOptionKind;
  /** label to display in UI */
  label: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  speedToleranceKnots: Scalars['Boolean']['output'];
  speedToleranceKnotsLabel: Scalars['String']['output'];
  timeToleranceSeconds: Scalars['Boolean']['output'];
  timeToleranceSecondsLabel: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  waitTimeSeconds: Scalars['Boolean']['output'];
  waitTimeSecondsLabel: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type NotifyEventOptionConnection = {
  __typename?: 'NotifyEventOptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyEventOptionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyEventOptionEdge = {
  __typename?: 'NotifyEventOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyEventOption>;
};

export enum NotifyEventOptionField {
  AcceptableMax = 'acceptableMax',
  AcceptableMaxLabel = 'acceptableMaxLabel',
  AcceptableMin = 'acceptableMin',
  AcceptableMinLabel = 'acceptableMinLabel',
  CreatedAt = 'createdAt',
  Description = 'description',
  DistanceMeters = 'distanceMeters',
  DistanceMetersLabel = 'distanceMetersLabel',
  DistanceToleranceMeters = 'distanceToleranceMeters',
  DistanceToleranceMetersLabel = 'distanceToleranceMetersLabel',
  EventName = 'eventName',
  Kind = 'kind',
  Label = 'label',
  SpeedToleranceKnots = 'speedToleranceKnots',
  SpeedToleranceKnotsLabel = 'speedToleranceKnotsLabel',
  TimeToleranceSeconds = 'timeToleranceSeconds',
  TimeToleranceSecondsLabel = 'timeToleranceSecondsLabel',
  UpdatedAt = 'updatedAt',
  WaitTimeSeconds = 'waitTimeSeconds',
  WaitTimeSecondsLabel = 'waitTimeSecondsLabel'
}

/** NotifyEventOptionKind is enum for the field kind */
export enum NotifyEventOptionKind {
  Event = 'Event',
  Periodic = 'Periodic',
  Position = 'Position'
}

/** Ordering options for NotifyEventOption connections */
export type NotifyEventOptionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyEventOptions. */
  field: NotifyEventOptionOrderField;
};

/** Properties by which NotifyEventOption connections can be ordered. */
export enum NotifyEventOptionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyEventOptionWhereInput is used for filtering NotifyEventOption objects.
 * Input was generated by ent.
 */
export type NotifyEventOptionWhereInput = {
  /** acceptable_max field predicates */
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_max_label field predicates */
  acceptableMaxLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelContains?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelGT?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelGTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMaxLabelLT?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelLTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMaxNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_min field predicates */
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_min_label field predicates */
  acceptableMinLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelContains?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelGT?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelGTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMinLabelLT?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelLTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMinNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** distance_meters field predicates */
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_meters_label field predicates */
  distanceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelContains?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelGT?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelGTE?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceMetersLabelLT?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelLTE?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceMetersNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_tolerance_meters field predicates */
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_tolerance_meters_label field predicates */
  distanceToleranceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelContains?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelGT?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelGTE?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceToleranceMetersLabelLT?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelLTE?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceToleranceMetersNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_name field predicates */
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventNameContains?: InputMaybe<Scalars['String']['input']>;
  eventNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventNameGT?: InputMaybe<Scalars['String']['input']>;
  eventNameGTE?: InputMaybe<Scalars['String']['input']>;
  eventNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventNameLT?: InputMaybe<Scalars['String']['input']>;
  eventNameLTE?: InputMaybe<Scalars['String']['input']>;
  eventNameNEQ?: InputMaybe<Scalars['String']['input']>;
  eventNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotifyEventOptionKind>;
  kindIn?: InputMaybe<Array<NotifyEventOptionKind>>;
  kindNEQ?: InputMaybe<NotifyEventOptionKind>;
  kindNotIn?: InputMaybe<Array<NotifyEventOptionKind>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyEventOptionWhereInput>;
  or?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** speed_tolerance_knots field predicates */
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  /** speed_tolerance_knots_label field predicates */
  speedToleranceKnotsLabel?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelContains?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelGT?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speedToleranceKnotsLabelLT?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speedToleranceKnotsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** time_tolerance_seconds field predicates */
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  /** time_tolerance_seconds_label field predicates */
  timeToleranceSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelContains?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelGT?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToleranceSecondsLabelLT?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToleranceSecondsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wait_time_seconds field predicates */
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  /** wait_time_seconds_label field predicates */
  waitTimeSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelContains?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelGT?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  waitTimeSecondsLabelLT?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  waitTimeSecondsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

export type Organisation = Node & {
  __typename?: 'Organisation';
  allowChildCreation: Scalars['Boolean']['output'];
  availableLicenses: Scalars['Int']['output'];
  baselicenseplan?: Maybe<Array<BaseLicensePlan>>;
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressLine2?: Maybe<Scalars['String']['output']>;
  billingAddressState?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEnabled: Scalars['Boolean']['output'];
  billingGstin?: Maybe<Scalars['String']['output']>;
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  centralisedWallet: Scalars['Boolean']['output'];
  childOrganisations?: Maybe<Array<Organisation>>;
  createdAt: Scalars['Time']['output'];
  deviceLimit: Scalars['Int']['output'];
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devicegroupsRoot?: Maybe<Array<DeviceGroup>>;
  devices?: Maybe<Array<Device>>;
  devicesRoot?: Maybe<Array<Device>>;
  export?: Maybe<Array<Export>>;
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  id: Scalars['ID']['output'];
  ingestServer: OrganisationIngestServer;
  isActive: Scalars['Boolean']['output'];
  kmls?: Maybe<Array<Kml>>;
  legacysync?: Maybe<Array<LegacySync>>;
  license?: Maybe<Array<License>>;
  licenseOrders?: Maybe<Array<SubscriptionLicenseOrder>>;
  mapGeofences?: Maybe<Array<Geofence>>;
  mediafiles?: Maybe<Array<MediaFile>>;
  name: Scalars['String']['output'];
  organisationDeviceDocuments?: Maybe<Array<DeviceDocument>>;
  organisationDeviceGroupDocuments?: Maybe<Array<DeviceGroupDocument>>;
  organisationLimit: Scalars['Int']['output'];
  organisationupgrade?: Maybe<Array<OrganisationUpgrade>>;
  organisationusers?: Maybe<Array<OrganisationUser>>;
  organistionroles?: Maybe<Array<OrganisationRole>>;
  parentOrganisation?: Maybe<Organisation>;
  parentOrganisationID?: Maybe<Scalars['ID']['output']>;
  rootOrganisation?: Maybe<Organisation>;
  rootOrganisationID?: Maybe<Scalars['ID']['output']>;
  sim?: Maybe<Array<Sim>>;
  subOrganisations?: Maybe<Array<Organisation>>;
  totalLicenses: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  upgradeorganisationprice?: Maybe<Array<UpgradeOrganisationPrice>>;
  wallet?: Maybe<Wallet>;
  whitelabel?: Maybe<Whitelabel>;
  yardDriverProfiles?: Maybe<Array<YardDriverProfile>>;
  yardMaterialType?: Maybe<Array<YardMaterialType>>;
  yardMaterials?: Maybe<Array<YardMaterial>>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardVehicles?: Maybe<Array<YardVehicle>>;
  yardVendors?: Maybe<Array<YardVendor>>;
  yardWarehouseActivityTypes?: Maybe<Array<YardWarehouseActivityType>>;
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
  yardWarehouseParkings?: Maybe<Array<YardWarehouseParking>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
  yardWarehouses?: Maybe<Array<YardWarehouse>>;
};

/** A connection to a list of items. */
export type OrganisationConnection = {
  __typename?: 'OrganisationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationEdge = {
  __typename?: 'OrganisationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organisation>;
};

export enum OrganisationField {
  AllowChildCreation = 'allowChildCreation',
  AvailableLicenses = 'availableLicenses',
  BillingAddressCity = 'billingAddressCity',
  BillingAddressCountry = 'billingAddressCountry',
  BillingAddressLine1 = 'billingAddressLine1',
  BillingAddressLine2 = 'billingAddressLine2',
  BillingAddressState = 'billingAddressState',
  BillingEmail = 'billingEmail',
  BillingEnabled = 'billingEnabled',
  BillingGstin = 'billingGstin',
  BoltLegacyId = 'boltLegacyID',
  CentralisedWallet = 'centralisedWallet',
  CreatedAt = 'createdAt',
  DeviceLimit = 'deviceLimit',
  IngestServer = 'ingestServer',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationLimit = 'organisationLimit',
  ParentOrganisationId = 'parentOrganisationID',
  RootOrganisationId = 'rootOrganisationID',
  TotalLicenses = 'totalLicenses',
  UpdatedAt = 'updatedAt'
}

/** OrganisationIngestServer is enum for the field ingest_server */
export enum OrganisationIngestServer {
  Bolt = 'BOLT',
  Track = 'TRACK'
}

/** Ordering options for Organisation connections */
export type OrganisationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Organisations. */
  field: OrganisationOrderField;
};

/** Properties by which Organisation connections can be ordered. */
export enum OrganisationOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationReportAccess = Node & {
  __typename?: 'OrganisationReportAccess';
  createdAt: Scalars['Time']['output'];
  derivedReport: DerivedReport;
  derivedReportID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationReportAccessConnection = {
  __typename?: 'OrganisationReportAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationReportAccessEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationReportAccessEdge = {
  __typename?: 'OrganisationReportAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationReportAccess>;
};

export enum OrganisationReportAccessField {
  CreatedAt = 'createdAt',
  DerivedReportId = 'derivedReportID',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationReportAccess connections */
export type OrganisationReportAccessOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationReportAccesses. */
  field: OrganisationReportAccessOrderField;
};

/** Properties by which OrganisationReportAccess connections can be ordered. */
export enum OrganisationReportAccessOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationReportAccessWhereInput is used for filtering OrganisationReportAccess objects.
 * Input was generated by ent.
 */
export type OrganisationReportAccessWhereInput = {
  and?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** derived_report_id field predicates */
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  derivedReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** derived_report edge predicates */
  hasDerivedReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationReportAccessWhereInput>;
  or?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OrganisationRole = Node & {
  __typename?: 'OrganisationRole';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationRolePermissions?: Maybe<Array<OrganisationRolePermission>>;
  organisationusers?: Maybe<Array<OrganisationUser>>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Time']['output'];
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
};

/** A connection to a list of items. */
export type OrganisationRoleConnection = {
  __typename?: 'OrganisationRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationRoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationRoleEdge = {
  __typename?: 'OrganisationRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationRole>;
};

export enum OrganisationRoleField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  Permissions = 'permissions',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationRole connections */
export type OrganisationRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationRoles. */
  field: OrganisationRoleOrderField;
};

/** Properties by which OrganisationRole connections can be ordered. */
export enum OrganisationRoleOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationRolePermission = Node & {
  __typename?: 'OrganisationRolePermission';
  create: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organisationRole: OrganisationRole;
  organisationRoleID: Scalars['ID']['output'];
  permission: Permission;
  permissionID: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationRolePermissionConnection = {
  __typename?: 'OrganisationRolePermissionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationRolePermissionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationRolePermissionEdge = {
  __typename?: 'OrganisationRolePermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationRolePermission>;
};

export enum OrganisationRolePermissionField {
  Create = 'create',
  CreatedAt = 'createdAt',
  Delete = 'delete',
  Edit = 'edit',
  OrganisationRoleId = 'organisationRoleID',
  PermissionId = 'permissionID',
  Read = 'read',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationRolePermission connections */
export type OrganisationRolePermissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationRolePermissions. */
  field: OrganisationRolePermissionOrderField;
};

/** Properties by which OrganisationRolePermission connections can be ordered. */
export enum OrganisationRolePermissionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationRolePermissionWhereInput is used for filtering OrganisationRolePermission objects.
 * Input was generated by ent.
 */
export type OrganisationRolePermissionWhereInput = {
  and?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  /** create field predicates */
  create?: InputMaybe<Scalars['Boolean']['input']>;
  createNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** delete field predicates */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** edit field predicates */
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  editNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_role edge predicates */
  hasOrganisationRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** permission edge predicates */
  hasPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionWith?: InputMaybe<Array<PermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationRolePermissionWhereInput>;
  or?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  /** organisation_role_id field predicates */
  organisationRoleID?: InputMaybe<Scalars['ID']['input']>;
  organisationRoleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationRoleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationRoleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** permission_id field predicates */
  permissionID?: InputMaybe<Scalars['ID']['input']>;
  permissionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  permissionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  permissionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** read field predicates */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  readNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * OrganisationRoleWhereInput is used for filtering OrganisationRole objects.
 * Input was generated by ent.
 */
export type OrganisationRoleWhereInput = {
  and?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_role_permissions edge predicates */
  hasOrganisationRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationRolePermissionsWith?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationRoleWhereInput>;
  or?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** permissions field predicates */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  permissionsLT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsLTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OrganisationUpgrade = Node & {
  __typename?: 'OrganisationUpgrade';
  autoRenew: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  startDate: Scalars['Time']['output'];
  status: OrganisationUpgradeStatus;
  updatedAt: Scalars['Time']['output'];
  upgrade: Upgrade;
  upgradeID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type OrganisationUpgradeConnection = {
  __typename?: 'OrganisationUpgradeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUpgradeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUpgradeEdge = {
  __typename?: 'OrganisationUpgradeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUpgrade>;
};

export enum OrganisationUpgradeField {
  AutoRenew = 'autoRenew',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  OrganisationId = 'organisationID',
  StartDate = 'startDate',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UpgradeId = 'upgradeID'
}

/** Ordering options for OrganisationUpgrade connections */
export type OrganisationUpgradeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUpgrades. */
  field: OrganisationUpgradeOrderField;
};

/** Properties by which OrganisationUpgrade connections can be ordered. */
export enum OrganisationUpgradeOrderField {
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** OrganisationUpgradeStatus is enum for the field status */
export enum OrganisationUpgradeStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Grace = 'Grace',
  Pending = 'Pending'
}

/**
 * OrganisationUpgradeWhereInput is used for filtering OrganisationUpgrade objects.
 * Input was generated by ent.
 */
export type OrganisationUpgradeWhereInput = {
  and?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** auto_renew field predicates */
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  endDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationUpgradeWhereInput>;
  or?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  startDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** status field predicates */
  status?: InputMaybe<OrganisationUpgradeStatus>;
  statusIn?: InputMaybe<Array<OrganisationUpgradeStatus>>;
  statusNEQ?: InputMaybe<OrganisationUpgradeStatus>;
  statusNotIn?: InputMaybe<Array<OrganisationUpgradeStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** upgrade_id field predicates */
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  upgradeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrganisationUser = Node & {
  __typename?: 'OrganisationUser';
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deviceacls?: Maybe<Array<DeviceAcl>>;
  driverprofiles?: Maybe<Profile>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationuserDocuments?: Maybe<Array<OrganisationUserDocument>>;
  role: OrganisationRole;
  roleID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  userType: OrganisationUserUserType;
};

/** A connection to a list of items. */
export type OrganisationUserConnection = {
  __typename?: 'OrganisationUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type OrganisationUserDocument = Node & {
  __typename?: 'OrganisationUserDocument';
  attachment: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisationuser: OrganisationUser;
  organisationuserID: Scalars['ID']['output'];
  organisationuserdocumenttype: OrganisationUserDocumentType;
  organisationuserdocumenttypeID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  verificationStatus: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type OrganisationUserDocumentConnection = {
  __typename?: 'OrganisationUserDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUserDocumentEdge = {
  __typename?: 'OrganisationUserDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUserDocument>;
};

export enum OrganisationUserDocumentField {
  Attachment = 'attachment',
  CreatedAt = 'createdAt',
  OrganisationuserId = 'organisationuserID',
  OrganisationuserdocumenttypeId = 'organisationuserdocumenttypeID',
  UpdatedAt = 'updatedAt',
  VerificationStatus = 'verificationStatus'
}

/** Ordering options for OrganisationUserDocument connections */
export type OrganisationUserDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUserDocuments. */
  field: OrganisationUserDocumentOrderField;
};

/** Properties by which OrganisationUserDocument connections can be ordered. */
export enum OrganisationUserDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationUserDocumentType = Node & {
  __typename?: 'OrganisationUserDocumentType';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationuserDocuments?: Maybe<Array<OrganisationUserDocument>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationUserDocumentTypeConnection = {
  __typename?: 'OrganisationUserDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUserDocumentTypeEdge = {
  __typename?: 'OrganisationUserDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUserDocumentType>;
};

export enum OrganisationUserDocumentTypeField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationUserDocumentType connections */
export type OrganisationUserDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUserDocumentTypes. */
  field: OrganisationUserDocumentTypeOrderField;
};

/** Properties by which OrganisationUserDocumentType connections can be ordered. */
export enum OrganisationUserDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationUserDocumentTypeWhereInput is used for filtering OrganisationUserDocumentType objects.
 * Input was generated by ent.
 */
export type OrganisationUserDocumentTypeWhereInput = {
  and?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisationuser_documents edge predicates */
  hasOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserDocumentsWith?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationUserDocumentTypeWhereInput>;
  or?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * OrganisationUserDocumentWhereInput is used for filtering OrganisationUserDocument objects.
 * Input was generated by ent.
 */
export type OrganisationUserDocumentWhereInput = {
  and?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** attachment field predicates */
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentContains?: InputMaybe<Scalars['String']['input']>;
  attachmentContainsFold?: InputMaybe<Scalars['String']['input']>;
  attachmentEqualFold?: InputMaybe<Scalars['String']['input']>;
  attachmentGT?: InputMaybe<Scalars['String']['input']>;
  attachmentGTE?: InputMaybe<Scalars['String']['input']>;
  attachmentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  attachmentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  attachmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentLT?: InputMaybe<Scalars['String']['input']>;
  attachmentLTE?: InputMaybe<Scalars['String']['input']>;
  attachmentNEQ?: InputMaybe<Scalars['String']['input']>;
  attachmentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisationuser edge predicates */
  hasOrganisationuser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organisationuserdocumenttype edge predicates */
  hasOrganisationuserdocumenttype?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserdocumenttypeWith?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationUserDocumentWhereInput>;
  or?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** organisationuserdocumenttype_id field predicates */
  organisationuserdocumenttypeID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserdocumenttypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** verification_status field predicates */
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  verificationStatusNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An edge in a connection. */
export type OrganisationUserEdge = {
  __typename?: 'OrganisationUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUser>;
};

export enum OrganisationUserField {
  BoltLegacyId = 'boltLegacyID',
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  RoleId = 'roleID',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  UserType = 'userType'
}

/** Ordering options for OrganisationUser connections */
export type OrganisationUserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUsers. */
  field: OrganisationUserOrderField;
};

/** Properties by which OrganisationUser connections can be ordered. */
export enum OrganisationUserOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** OrganisationUserUserType is enum for the field user_type */
export enum OrganisationUserUserType {
  Driver = 'driver',
  User = 'user'
}

/**
 * OrganisationUserWhereInput is used for filtering OrganisationUser objects.
 * Input was generated by ent.
 */
export type OrganisationUserWhereInput = {
  and?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deviceacls edge predicates */
  hasDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaclsWith?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** driverprofiles edge predicates */
  hasDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverprofilesWith?: InputMaybe<Array<ProfileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisationuser_documents edge predicates */
  hasOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserDocumentsWith?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<OrganisationUserWhereInput>;
  or?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** user_type field predicates */
  userType?: InputMaybe<OrganisationUserUserType>;
  userTypeIn?: InputMaybe<Array<OrganisationUserUserType>>;
  userTypeNEQ?: InputMaybe<OrganisationUserUserType>;
  userTypeNotIn?: InputMaybe<Array<OrganisationUserUserType>>;
};

/**
 * OrganisationWhereInput is used for filtering Organisation objects.
 * Input was generated by ent.
 */
export type OrganisationWhereInput = {
  /** allow_child_creation field predicates */
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  allowChildCreationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<OrganisationWhereInput>>;
  /** available_licenses field predicates */
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesGT?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesGTE?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  availableLicensesLT?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesLTE?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesNEQ?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** billing_address_city field predicates */
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressCityLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_country field predicates */
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCountryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressCountryLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCountryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_line_1 field predicates */
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1Contains?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1ContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1EqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1GT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1GTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1HasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1HasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1In?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine1IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressLine1LT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1LTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1NEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine1NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_line_2 field predicates */
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2Contains?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2ContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2EqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2GT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2GTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2HasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2HasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2In?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine2IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressLine2LT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2LTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2NEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine2NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_state field predicates */
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressStateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressStateLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressStateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_email field predicates */
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEmailContains?: InputMaybe<Scalars['String']['input']>;
  billingEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingEmailGT?: InputMaybe<Scalars['String']['input']>;
  billingEmailGTE?: InputMaybe<Scalars['String']['input']>;
  billingEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingEmailLT?: InputMaybe<Scalars['String']['input']>;
  billingEmailLTE?: InputMaybe<Scalars['String']['input']>;
  billingEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  billingEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_enabled field predicates */
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_gstin field predicates */
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  billingGstinContains?: InputMaybe<Scalars['String']['input']>;
  billingGstinContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingGstinEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingGstinGT?: InputMaybe<Scalars['String']['input']>;
  billingGstinGTE?: InputMaybe<Scalars['String']['input']>;
  billingGstinHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingGstinHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingGstinIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingGstinIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstinLT?: InputMaybe<Scalars['String']['input']>;
  billingGstinLTE?: InputMaybe<Scalars['String']['input']>;
  billingGstinNEQ?: InputMaybe<Scalars['String']['input']>;
  billingGstinNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingGstinNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** centralised_wallet field predicates */
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  centralisedWalletNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_limit field predicates */
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitGT?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceLimitLT?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** child_organisations edge predicates */
  hasChildOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** devicegroups_root edge predicates */
  hasDevicegroupsRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsRootWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** devices_root edge predicates */
  hasDevicesRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesRootWith?: InputMaybe<Array<DeviceWhereInput>>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** kmls edge predicates */
  hasKmls?: InputMaybe<Scalars['Boolean']['input']>;
  hasKmlsWith?: InputMaybe<Array<KmlWhereInput>>;
  /** legacysync edge predicates */
  hasLegacysync?: InputMaybe<Scalars['Boolean']['input']>;
  hasLegacysyncWith?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** license edge predicates */
  hasLicense?: InputMaybe<Scalars['Boolean']['input']>;
  /** license_orders edge predicates */
  hasLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrdersWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  hasLicenseWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** map_geofences edge predicates */
  hasMapGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasMapGeofencesWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** mediafiles edge predicates */
  hasMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation_device_documents edge predicates */
  hasOrganisationDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationDeviceDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** organisation_device_group_documents edge predicates */
  hasOrganisationDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationDeviceGroupDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** organisationupgrade edge predicates */
  hasOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationupgradeWith?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organistionroles edge predicates */
  hasOrganistionroles?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganistionrolesWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** parent_organisation edge predicates */
  hasParentOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** root_organisation edge predicates */
  hasRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** sim edge predicates */
  hasSim?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimWith?: InputMaybe<Array<SimWhereInput>>;
  /** sub_organisations edge predicates */
  hasSubOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgradeorganisationprice edge predicates */
  hasUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeorganisationpriceWith?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** yard_driver_profiles edge predicates */
  hasYardDriverProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverProfilesWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_material_type edge predicates */
  hasYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialTypeWith?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** yard_materials edge predicates */
  hasYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_vehicles edge predicates */
  hasYardVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehiclesWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vendors edge predicates */
  hasYardVendors?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVendorsWith?: InputMaybe<Array<YardVendorWhereInput>>;
  /** yard_warehouse_activity_types edge predicates */
  hasYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseActivityTypesWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** yard_warehouse_parkings edge predicates */
  hasYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseParkingsWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** yard_warehouses edge predicates */
  hasYardWarehouses?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehousesWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ingest_server field predicates */
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  ingestServerIn?: InputMaybe<Array<OrganisationIngestServer>>;
  ingestServerNEQ?: InputMaybe<OrganisationIngestServer>;
  ingestServerNotIn?: InputMaybe<Array<OrganisationIngestServer>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationWhereInput>;
  or?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisation_limit field predicates */
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitGT?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  organisationLimitLT?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** parent_organisation_id field predicates */
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  parentOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_licenses field predicates */
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesGT?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesGTE?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLicensesLT?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesLTE?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesNEQ?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type ParsedPositionSubPacket = {
  __typename?: 'ParsedPositionSubPacket';
  altitude: Scalars['Float']['output'];
  attributes: PositionAttributesParsed;
  course: Scalars['Float']['output'];
  deviceTime: Scalars['Time']['output'];
  fixTime: Scalars['Time']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  outdated: Scalars['Boolean']['output'];
  protocol: Scalars['String']['output'];
  serverTime: Scalars['Time']['output'];
  speed: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PeriodicJob = Node & {
  __typename?: 'PeriodicJob';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastRunAt?: Maybe<Scalars['Time']['output']>;
  lastTaskResponse?: Maybe<Scalars['JSON']['output']>;
  nextRunAt?: Maybe<Scalars['Time']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  queueName: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type PeriodicJobConnection = {
  __typename?: 'PeriodicJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PeriodicJobEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PeriodicJobEdge = {
  __typename?: 'PeriodicJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PeriodicJob>;
};

export enum PeriodicJobField {
  CreatedAt = 'createdAt',
  Description = 'description',
  IsActive = 'isActive',
  LastRunAt = 'lastRunAt',
  LastTaskResponse = 'lastTaskResponse',
  NextRunAt = 'nextRunAt',
  Params = 'params',
  QueueName = 'queueName',
  Schedule = 'schedule',
  TaskName = 'taskName',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for PeriodicJob connections */
export type PeriodicJobOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PeriodicJobs. */
  field: PeriodicJobOrderField;
};

/** Properties by which PeriodicJob connections can be ordered. */
export enum PeriodicJobOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PeriodicJobWhereInput is used for filtering PeriodicJob objects.
 * Input was generated by ent.
 */
export type PeriodicJobWhereInput = {
  and?: InputMaybe<Array<PeriodicJobWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_run_at field predicates */
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastRunAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastRunAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_task_response field predicates */
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseGT?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseGTE?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lastTaskResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTaskResponseLT?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseLTE?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseNEQ?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lastTaskResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_run_at field predicates */
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRunAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextRunAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRunAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PeriodicJobWhereInput>;
  or?: InputMaybe<Array<PeriodicJobWhereInput>>;
  /** params field predicates */
  params?: InputMaybe<Scalars['JSON']['input']>;
  paramsGT?: InputMaybe<Scalars['JSON']['input']>;
  paramsGTE?: InputMaybe<Scalars['JSON']['input']>;
  paramsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  paramsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paramsLT?: InputMaybe<Scalars['JSON']['input']>;
  paramsLTE?: InputMaybe<Scalars['JSON']['input']>;
  paramsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  paramsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  paramsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** queue_name field predicates */
  queueName?: InputMaybe<Scalars['String']['input']>;
  queueNameContains?: InputMaybe<Scalars['String']['input']>;
  queueNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  queueNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  queueNameGT?: InputMaybe<Scalars['String']['input']>;
  queueNameGTE?: InputMaybe<Scalars['String']['input']>;
  queueNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  queueNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  queueNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queueNameLT?: InputMaybe<Scalars['String']['input']>;
  queueNameLTE?: InputMaybe<Scalars['String']['input']>;
  queueNameNEQ?: InputMaybe<Scalars['String']['input']>;
  queueNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** schedule field predicates */
  schedule?: InputMaybe<Scalars['String']['input']>;
  scheduleContains?: InputMaybe<Scalars['String']['input']>;
  scheduleContainsFold?: InputMaybe<Scalars['String']['input']>;
  scheduleEqualFold?: InputMaybe<Scalars['String']['input']>;
  scheduleGT?: InputMaybe<Scalars['String']['input']>;
  scheduleGTE?: InputMaybe<Scalars['String']['input']>;
  scheduleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  scheduleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  scheduleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleLT?: InputMaybe<Scalars['String']['input']>;
  scheduleLTE?: InputMaybe<Scalars['String']['input']>;
  scheduleNEQ?: InputMaybe<Scalars['String']['input']>;
  scheduleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Permission = Node & {
  __typename?: 'Permission';
  createLabel: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deleteLabel: Scalars['String']['output'];
  description: Scalars['String']['output'];
  editLabel: Scalars['String']['output'];
  group: PermissionGroup;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: PermissionName;
  readLabel: Scalars['String']['output'];
  showCreate: Scalars['Boolean']['output'];
  showDelete: Scalars['Boolean']['output'];
  showEdit: Scalars['Boolean']['output'];
  showRead: Scalars['Boolean']['output'];
  sorter: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type PermissionConnection = {
  __typename?: 'PermissionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PermissionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PermissionEdge = {
  __typename?: 'PermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Permission>;
};

export enum PermissionField {
  CreateLabel = 'createLabel',
  CreatedAt = 'createdAt',
  DeleteLabel = 'deleteLabel',
  Description = 'description',
  EditLabel = 'editLabel',
  Group = 'group',
  Label = 'label',
  Name = 'name',
  ReadLabel = 'readLabel',
  ShowCreate = 'showCreate',
  ShowDelete = 'showDelete',
  ShowEdit = 'showEdit',
  ShowRead = 'showRead',
  Sorter = 'sorter',
  UpdatedAt = 'updatedAt'
}

/** PermissionGroup is enum for the field group */
export enum PermissionGroup {
  Device = 'device',
  License = 'license',
  Organisation = 'organisation',
  User = 'user',
  Yard = 'yard'
}

/** PermissionName is enum for the field name */
export enum PermissionName {
  Admin = 'Admin',
  BaseAddon = 'BaseAddon',
  BaseLicensePlan = 'BaseLicensePlan',
  BaseLicensePlanAddon = 'BaseLicensePlanAddon',
  Chatbot = 'Chatbot',
  Device = 'Device',
  DeviceAcl = 'DeviceAcl',
  DeviceActionLog = 'DeviceActionLog',
  DeviceAddonModel = 'DeviceAddonModel',
  DeviceAdvancedConfig = 'DeviceAdvancedConfig',
  DeviceCategory = 'DeviceCategory',
  DeviceChannelConfig = 'DeviceChannelConfig',
  DeviceCommand = 'DeviceCommand',
  DeviceDocument = 'DeviceDocument',
  DeviceDocumentType = 'DeviceDocumentType',
  DeviceGroup = 'DeviceGroup',
  DeviceGroupAll = 'DeviceGroupAll',
  DeviceGroupDocument = 'DeviceGroupDocument',
  DeviceGroupDocumentType = 'DeviceGroupDocumentType',
  DeviceModel = 'DeviceModel',
  DeviceModelChannel = 'DeviceModelChannel',
  DeviceShare = 'DeviceShare',
  DeviceShareRequest = 'DeviceShareRequest',
  DeviceSharing = 'DeviceSharing',
  DeviceVehicle = 'DeviceVehicle',
  Domain = 'Domain',
  Geofence = 'Geofence',
  Kml = 'Kml',
  License = 'License',
  LicenseOrder = 'LicenseOrder',
  MapConfig = 'MapConfig',
  Notification = 'Notification',
  Organisation = 'Organisation',
  OrganisationRole = 'OrganisationRole',
  OrganisationUser = 'OrganisationUser',
  OrganisationUserDocument = 'OrganisationUserDocument',
  OrganisationUserDocumentType = 'OrganisationUserDocumentType',
  Poi = 'Poi',
  Profile = 'Profile',
  Report = 'Report',
  Sim = 'Sim',
  Upgrade = 'Upgrade',
  User = 'User',
  UserImpersonate = 'UserImpersonate',
  Vehicle = 'Vehicle',
  Wallet = 'Wallet',
  WalletPaymentTransaction = 'WalletPaymentTransaction',
  WalletTransaction = 'WalletTransaction',
  Whitelabel = 'Whitelabel',
  WhitelabelConfig = 'WhitelabelConfig',
  WhitelabelCoreSettingOverride = 'WhitelabelCoreSettingOverride',
  YardAssignDriver = 'YardAssignDriver',
  YardAssignMaterial = 'YardAssignMaterial',
  YardAssignParking = 'YardAssignParking',
  YardAssignRoute = 'YardAssignRoute',
  YardAssignTracker = 'YardAssignTracker',
  YardAssignVehicle = 'YardAssignVehicle',
  YardAssignVehicleTracker = 'YardAssignVehicleTracker',
  YardAssignVendor = 'YardAssignVendor',
  YardCheckin = 'YardCheckin',
  YardCheckout = 'YardCheckout',
  YardDriverProfile = 'YardDriverProfile',
  YardGuardApp = 'YardGuardApp',
  YardManage = 'YardManage',
  YardMaterial = 'YardMaterial',
  YardMaterialType = 'YardMaterialType',
  YardParkingCheckin = 'YardParkingCheckin',
  YardParkingCheckout = 'YardParkingCheckout',
  YardRecharge = 'YardRecharge',
  YardSetDockActivity = 'YardSetDockActivity',
  YardTransfer = 'YardTransfer',
  YardTrip = 'YardTrip',
  YardVehicle = 'YardVehicle',
  YardVendor = 'YardVendor',
  YardWarehouse = 'YardWarehouse',
  YardWarehouseActivityType = 'YardWarehouseActivityType',
  YardWarehouseApprovalMatrix = 'YardWarehouseApprovalMatrix',
  YardWarehouseCheckin = 'YardWarehouseCheckin',
  YardWarehouseCheckout = 'YardWarehouseCheckout',
  YardWarehouseDock = 'YardWarehouseDock',
  YardWarehouseParking = 'YardWarehouseParking',
  YardWarehouseRoute = 'YardWarehouseRoute',
  YardWarehouseRoutePath = 'YardWarehouseRoutePath'
}

/** Ordering options for Permission connections */
export type PermissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Permissions. */
  field: PermissionOrderField;
};

/** Properties by which Permission connections can be ordered. */
export enum PermissionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PermissionWhereInput is used for filtering Permission objects.
 * Input was generated by ent.
 */
export type PermissionWhereInput = {
  and?: InputMaybe<Array<PermissionWhereInput>>;
  /** create_label field predicates */
  createLabel?: InputMaybe<Scalars['String']['input']>;
  createLabelContains?: InputMaybe<Scalars['String']['input']>;
  createLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  createLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  createLabelGT?: InputMaybe<Scalars['String']['input']>;
  createLabelGTE?: InputMaybe<Scalars['String']['input']>;
  createLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createLabelLT?: InputMaybe<Scalars['String']['input']>;
  createLabelLTE?: InputMaybe<Scalars['String']['input']>;
  createLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  createLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** delete_label field predicates */
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  deleteLabelContains?: InputMaybe<Scalars['String']['input']>;
  deleteLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  deleteLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  deleteLabelGT?: InputMaybe<Scalars['String']['input']>;
  deleteLabelGTE?: InputMaybe<Scalars['String']['input']>;
  deleteLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deleteLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deleteLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deleteLabelLT?: InputMaybe<Scalars['String']['input']>;
  deleteLabelLTE?: InputMaybe<Scalars['String']['input']>;
  deleteLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  deleteLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** edit_label field predicates */
  editLabel?: InputMaybe<Scalars['String']['input']>;
  editLabelContains?: InputMaybe<Scalars['String']['input']>;
  editLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  editLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  editLabelGT?: InputMaybe<Scalars['String']['input']>;
  editLabelGTE?: InputMaybe<Scalars['String']['input']>;
  editLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  editLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  editLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  editLabelLT?: InputMaybe<Scalars['String']['input']>;
  editLabelLTE?: InputMaybe<Scalars['String']['input']>;
  editLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  editLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** group field predicates */
  group?: InputMaybe<PermissionGroup>;
  groupIn?: InputMaybe<Array<PermissionGroup>>;
  groupNEQ?: InputMaybe<PermissionGroup>;
  groupNotIn?: InputMaybe<Array<PermissionGroup>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<PermissionName>;
  nameIn?: InputMaybe<Array<PermissionName>>;
  nameNEQ?: InputMaybe<PermissionName>;
  nameNotIn?: InputMaybe<Array<PermissionName>>;
  not?: InputMaybe<PermissionWhereInput>;
  or?: InputMaybe<Array<PermissionWhereInput>>;
  /** read_label field predicates */
  readLabel?: InputMaybe<Scalars['String']['input']>;
  readLabelContains?: InputMaybe<Scalars['String']['input']>;
  readLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  readLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  readLabelGT?: InputMaybe<Scalars['String']['input']>;
  readLabelGTE?: InputMaybe<Scalars['String']['input']>;
  readLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  readLabelLT?: InputMaybe<Scalars['String']['input']>;
  readLabelLTE?: InputMaybe<Scalars['String']['input']>;
  readLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  readLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** show_create field predicates */
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showCreateNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_delete field predicates */
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleteNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_edit field predicates */
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showEditNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_read field predicates */
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  showReadNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** sorter field predicates */
  sorter?: InputMaybe<Scalars['Int']['input']>;
  sorterGT?: InputMaybe<Scalars['Int']['input']>;
  sorterGTE?: InputMaybe<Scalars['Int']['input']>;
  sorterIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sorterLT?: InputMaybe<Scalars['Int']['input']>;
  sorterLTE?: InputMaybe<Scalars['Int']['input']>;
  sorterNEQ?: InputMaybe<Scalars['Int']['input']>;
  sorterNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type PinnedDevices = Node & {
  __typename?: 'PinnedDevices';
  createdAt: Scalars['Time']['output'];
  device: Device;
  /** ID of the pinned device */
  deviceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: OrganisationUser;
  /** ID of the user who pinned the device */
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type PinnedDevicesConnection = {
  __typename?: 'PinnedDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnedDevicesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnedDevicesEdge = {
  __typename?: 'PinnedDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnedDevices>;
};

export enum PinnedDevicesField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for PinnedDevices connections */
export type PinnedDevicesOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PinnedDevicesSlice. */
  field: PinnedDevicesOrderField;
};

/** Properties by which PinnedDevices connections can be ordered. */
export enum PinnedDevicesOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PinnedDevicesWhereInput is used for filtering PinnedDevices objects.
 * Input was generated by ent.
 */
export type PinnedDevicesWhereInput = {
  and?: InputMaybe<Array<PinnedDevicesWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PinnedDevicesWhereInput>;
  or?: InputMaybe<Array<PinnedDevicesWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Poi = Node & {
  __typename?: 'Poi';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['String']['output'];
  long: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type PoiConnection = {
  __typename?: 'PoiConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PoiEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PoiEdge = {
  __typename?: 'PoiEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Poi>;
};

export enum PoiField {
  CreatedAt = 'createdAt',
  Description = 'description',
  IconColor = 'iconColor',
  IconName = 'iconName',
  Lat = 'lat',
  Long = 'long',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for Poi connections */
export type PoiOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Pois. */
  field: PoiOrderField;
};

/** Properties by which Poi connections can be ordered. */
export enum PoiOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PoiWhereInput is used for filtering Poi objects.
 * Input was generated by ent.
 */
export type PoiWhereInput = {
  and?: InputMaybe<Array<PoiWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** icon_color field predicates */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  iconColorContains?: InputMaybe<Scalars['String']['input']>;
  iconColorContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconColorEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconColorGT?: InputMaybe<Scalars['String']['input']>;
  iconColorGTE?: InputMaybe<Scalars['String']['input']>;
  iconColorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconColorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconColorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconColorLT?: InputMaybe<Scalars['String']['input']>;
  iconColorLTE?: InputMaybe<Scalars['String']['input']>;
  iconColorNEQ?: InputMaybe<Scalars['String']['input']>;
  iconColorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** icon_name field predicates */
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconNameContains?: InputMaybe<Scalars['String']['input']>;
  iconNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconNameGT?: InputMaybe<Scalars['String']['input']>;
  iconNameGTE?: InputMaybe<Scalars['String']['input']>;
  iconNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconNameLT?: InputMaybe<Scalars['String']['input']>;
  iconNameLTE?: InputMaybe<Scalars['String']['input']>;
  iconNameNEQ?: InputMaybe<Scalars['String']['input']>;
  iconNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lat field predicates */
  lat?: InputMaybe<Scalars['String']['input']>;
  latContains?: InputMaybe<Scalars['String']['input']>;
  latContainsFold?: InputMaybe<Scalars['String']['input']>;
  latEqualFold?: InputMaybe<Scalars['String']['input']>;
  latGT?: InputMaybe<Scalars['String']['input']>;
  latGTE?: InputMaybe<Scalars['String']['input']>;
  latHasPrefix?: InputMaybe<Scalars['String']['input']>;
  latHasSuffix?: InputMaybe<Scalars['String']['input']>;
  latIn?: InputMaybe<Array<Scalars['String']['input']>>;
  latLT?: InputMaybe<Scalars['String']['input']>;
  latLTE?: InputMaybe<Scalars['String']['input']>;
  latNEQ?: InputMaybe<Scalars['String']['input']>;
  latNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** long field predicates */
  long?: InputMaybe<Scalars['String']['input']>;
  longContains?: InputMaybe<Scalars['String']['input']>;
  longContainsFold?: InputMaybe<Scalars['String']['input']>;
  longEqualFold?: InputMaybe<Scalars['String']['input']>;
  longGT?: InputMaybe<Scalars['String']['input']>;
  longGTE?: InputMaybe<Scalars['String']['input']>;
  longHasPrefix?: InputMaybe<Scalars['String']['input']>;
  longHasSuffix?: InputMaybe<Scalars['String']['input']>;
  longIn?: InputMaybe<Array<Scalars['String']['input']>>;
  longLT?: InputMaybe<Scalars['String']['input']>;
  longLTE?: InputMaybe<Scalars['String']['input']>;
  longNEQ?: InputMaybe<Scalars['String']['input']>;
  longNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PoiWhereInput>;
  or?: InputMaybe<Array<PoiWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PositionAttributesParsed = {
  __typename?: 'PositionAttributesParsed';
  ac?: Maybe<Scalars['Boolean']['output']>;
  adc1?: Maybe<Scalars['Float']['output']>;
  airConditionerOpen?: Maybe<Scalars['Boolean']['output']>;
  alarm?: Maybe<Scalars['String']['output']>;
  approximate?: Maybe<Scalars['Boolean']['output']>;
  armed?: Maybe<Scalars['Boolean']['output']>;
  battery?: Maybe<Scalars['Float']['output']>;
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  charge?: Maybe<Scalars['Boolean']['output']>;
  course?: Maybe<Scalars['Float']['output']>;
  deviceStatus?: Maybe<Scalars['Boolean']['output']>;
  di1?: Maybe<Scalars['Int']['output']>;
  di2?: Maybe<Scalars['Int']['output']>;
  di3?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  door?: Maybe<Scalars['Boolean']['output']>;
  driverUniqueId?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['Int']['output']>;
  extBatt?: Maybe<Scalars['Float']['output']>;
  fuel?: Maybe<Scalars['Float']['output']>;
  fuelCompartment1?: Maybe<Scalars['Float']['output']>;
  geofence?: Maybe<Scalars['Boolean']['output']>;
  gpsStatus?: Maybe<Scalars['Boolean']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  humidity?: Maybe<Scalars['Float']['output']>;
  ignition?: Maybe<Scalars['Boolean']['output']>;
  immobilizer?: Maybe<Scalars['Boolean']['output']>;
  io6?: Maybe<Scalars['Int']['output']>;
  io24?: Maybe<Scalars['Int']['output']>;
  io68?: Maybe<Scalars['Int']['output']>;
  io113?: Maybe<Scalars['Int']['output']>;
  io200?: Maybe<Scalars['Int']['output']>;
  io263?: Maybe<Scalars['Int']['output']>;
  io270?: Maybe<Scalars['Int']['output']>;
  io306?: Maybe<Scalars['Int']['output']>;
  io335?: Maybe<Scalars['Int']['output']>;
  load?: Maybe<Scalars['Float']['output']>;
  loadCell?: Maybe<Scalars['Float']['output']>;
  lock?: Maybe<Scalars['Boolean']['output']>;
  maxSpeed?: Maybe<Scalars['Float']['output']>;
  motion?: Maybe<Scalars['Boolean']['output']>;
  odometer?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Scalars['Int']['output']>;
  parking?: Maybe<Scalars['Boolean']['output']>;
  pdop?: Maybe<Scalars['Float']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  previousDistance?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  rssi?: Maybe<Scalars['Int']['output']>;
  sat?: Maybe<Scalars['Int']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  temp1?: Maybe<Scalars['Float']['output']>;
  todayDistance?: Maybe<Scalars['Float']['output']>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
  workMode?: Maybe<Scalars['Int']['output']>;
};

export type PositionPollingResponse = {
  __typename?: 'PositionPollingResponse';
  LastUpdate?: Maybe<Scalars['Time']['output']>;
  LatestPosition?: Maybe<ParsedPositionSubPacket>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  deviceStatus?: Maybe<DeviceStatus>;
  lastIgnitionOffFixTime?: Maybe<Scalars['Time']['output']>;
  lastIgnitionOnFixTime?: Maybe<Scalars['Time']['output']>;
};

export type Profile = Node & {
  __typename?: 'Profile';
  baseLocation: Scalars['String']['output'];
  bloodGroup: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  department: Scalars['String']['output'];
  employeeNo: Scalars['String']['output'];
  groups?: Maybe<Array<DeviceGroup>>;
  id: Scalars['ID']['output'];
  organisationuserID: Scalars['ID']['output'];
  organisationusers: OrganisationUser;
  supervisorName: Scalars['String']['output'];
  supervisorPhonenumber: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Profile>;
};

export enum ProfileField {
  BaseLocation = 'baseLocation',
  BloodGroup = 'bloodGroup',
  ContractNumber = 'contractNumber',
  CreatedAt = 'createdAt',
  Department = 'department',
  EmployeeNo = 'employeeNo',
  OrganisationuserId = 'organisationuserID',
  SupervisorName = 'supervisorName',
  SupervisorPhonenumber = 'supervisorPhonenumber',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Profile connections */
export type ProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Profiles. */
  field: ProfileOrderField;
};

/** Properties by which Profile connections can be ordered. */
export enum ProfileOrderField {
  EmployeeNo = 'EMPLOYEE_NO',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ProfileWhereInput is used for filtering Profile objects.
 * Input was generated by ent.
 */
export type ProfileWhereInput = {
  and?: InputMaybe<Array<ProfileWhereInput>>;
  /** base_location field predicates */
  baseLocation?: InputMaybe<Scalars['String']['input']>;
  baseLocationContains?: InputMaybe<Scalars['String']['input']>;
  baseLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  baseLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  baseLocationGT?: InputMaybe<Scalars['String']['input']>;
  baseLocationGTE?: InputMaybe<Scalars['String']['input']>;
  baseLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  baseLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  baseLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  baseLocationLT?: InputMaybe<Scalars['String']['input']>;
  baseLocationLTE?: InputMaybe<Scalars['String']['input']>;
  baseLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  baseLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** blood_group field predicates */
  bloodGroup?: InputMaybe<Scalars['String']['input']>;
  bloodGroupContains?: InputMaybe<Scalars['String']['input']>;
  bloodGroupContainsFold?: InputMaybe<Scalars['String']['input']>;
  bloodGroupEqualFold?: InputMaybe<Scalars['String']['input']>;
  bloodGroupGT?: InputMaybe<Scalars['String']['input']>;
  bloodGroupGTE?: InputMaybe<Scalars['String']['input']>;
  bloodGroupHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bloodGroupHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bloodGroupIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bloodGroupLT?: InputMaybe<Scalars['String']['input']>;
  bloodGroupLTE?: InputMaybe<Scalars['String']['input']>;
  bloodGroupNEQ?: InputMaybe<Scalars['String']['input']>;
  bloodGroupNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** contract_number field predicates */
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  contractNumberContains?: InputMaybe<Scalars['String']['input']>;
  contractNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  contractNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  contractNumberGT?: InputMaybe<Scalars['String']['input']>;
  contractNumberGTE?: InputMaybe<Scalars['String']['input']>;
  contractNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contractNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contractNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contractNumberLT?: InputMaybe<Scalars['String']['input']>;
  contractNumberLTE?: InputMaybe<Scalars['String']['input']>;
  contractNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  contractNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** department field predicates */
  department?: InputMaybe<Scalars['String']['input']>;
  departmentContains?: InputMaybe<Scalars['String']['input']>;
  departmentContainsFold?: InputMaybe<Scalars['String']['input']>;
  departmentEqualFold?: InputMaybe<Scalars['String']['input']>;
  departmentGT?: InputMaybe<Scalars['String']['input']>;
  departmentGTE?: InputMaybe<Scalars['String']['input']>;
  departmentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  departmentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentLT?: InputMaybe<Scalars['String']['input']>;
  departmentLTE?: InputMaybe<Scalars['String']['input']>;
  departmentNEQ?: InputMaybe<Scalars['String']['input']>;
  departmentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** employee_no field predicates */
  employeeNo?: InputMaybe<Scalars['String']['input']>;
  employeeNoContains?: InputMaybe<Scalars['String']['input']>;
  employeeNoContainsFold?: InputMaybe<Scalars['String']['input']>;
  employeeNoEqualFold?: InputMaybe<Scalars['String']['input']>;
  employeeNoGT?: InputMaybe<Scalars['String']['input']>;
  employeeNoGTE?: InputMaybe<Scalars['String']['input']>;
  employeeNoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  employeeNoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  employeeNoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeNoLT?: InputMaybe<Scalars['String']['input']>;
  employeeNoLTE?: InputMaybe<Scalars['String']['input']>;
  employeeNoNEQ?: InputMaybe<Scalars['String']['input']>;
  employeeNoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** groups edge predicates */
  hasGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProfileWhereInput>;
  or?: InputMaybe<Array<ProfileWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** supervisor_name field predicates */
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  supervisorNameContains?: InputMaybe<Scalars['String']['input']>;
  supervisorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  supervisorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  supervisorNameGT?: InputMaybe<Scalars['String']['input']>;
  supervisorNameGTE?: InputMaybe<Scalars['String']['input']>;
  supervisorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supervisorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supervisorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorNameLT?: InputMaybe<Scalars['String']['input']>;
  supervisorNameLTE?: InputMaybe<Scalars['String']['input']>;
  supervisorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  supervisorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** supervisor_phonenumber field predicates */
  supervisorPhonenumber?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberContains?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberGT?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberGTE?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorPhonenumberLT?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberLTE?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberNEQ?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type PusherConfig = Node & {
  __typename?: 'PusherConfig';
  active: Scalars['Boolean']['output'];
  adminID?: Maybe<Scalars['Int']['output']>;
  allData: Scalars['Boolean']['output'];
  allDevices: Scalars['Boolean']['output'];
  apiExtra?: Maybe<Scalars['String']['output']>;
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  apiSkipSsl: Scalars['Boolean']['output'];
  apiTimeoutSeconds: Scalars['Int']['output'];
  apiURL?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  deviceIds: Array<Scalars['Int']['output']>;
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastResponse?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  nextAttemptAt?: Maybe<Scalars['Time']['output']>;
  pauseOnFailureSeconds: Scalars['Int']['output'];
  periodicBatchSeconds: Scalars['Int']['output'];
  periodicMaxBatchSize: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  type: PusherConfigType;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
  withAddress: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type PusherConfigConnection = {
  __typename?: 'PusherConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PusherConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PusherConfigEdge = {
  __typename?: 'PusherConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PusherConfig>;
};

export enum PusherConfigField {
  Active = 'active',
  AdminId = 'adminID',
  AllData = 'allData',
  AllDevices = 'allDevices',
  ApiExtra = 'apiExtra',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  ApiSkipSsl = 'apiSkipSsl',
  ApiTimeoutSeconds = 'apiTimeoutSeconds',
  ApiUrl = 'apiURL',
  Config = 'config',
  CreatedAt = 'createdAt',
  DeviceIds = 'deviceIds',
  Headers = 'headers',
  LastFailedAt = 'lastFailedAt',
  LastResponse = 'lastResponse',
  LastSuccessAt = 'lastSuccessAt',
  NextAttemptAt = 'nextAttemptAt',
  PauseOnFailureSeconds = 'pauseOnFailureSeconds',
  PeriodicBatchSeconds = 'periodicBatchSeconds',
  PeriodicMaxBatchSize = 'periodicMaxBatchSize',
  TaskName = 'taskName',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  WithAddress = 'withAddress'
}

/** Ordering options for PusherConfig connections */
export type PusherConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PusherConfigs. */
  field: PusherConfigOrderField;
};

/** Properties by which PusherConfig connections can be ordered. */
export enum PusherConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** PusherConfigType is enum for the field type */
export enum PusherConfigType {
  Events = 'EVENTS',
  Positions = 'POSITIONS',
  VideoEvents = 'VIDEO_EVENTS'
}

/**
 * PusherConfigWhereInput is used for filtering PusherConfig objects.
 * Input was generated by ent.
 */
export type PusherConfigWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** admin_id field predicates */
  adminID?: InputMaybe<Scalars['Int']['input']>;
  adminIDGT?: InputMaybe<Scalars['Int']['input']>;
  adminIDGTE?: InputMaybe<Scalars['Int']['input']>;
  adminIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  adminIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  adminIDLT?: InputMaybe<Scalars['Int']['input']>;
  adminIDLTE?: InputMaybe<Scalars['Int']['input']>;
  adminIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  adminIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  adminIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** all_data field predicates */
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDataNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** all_devices field predicates */
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  allDevicesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<PusherConfigWhereInput>>;
  /** api_extra field predicates */
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiExtraContains?: InputMaybe<Scalars['String']['input']>;
  apiExtraContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiExtraEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiExtraGT?: InputMaybe<Scalars['String']['input']>;
  apiExtraGTE?: InputMaybe<Scalars['String']['input']>;
  apiExtraHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiExtraHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiExtraIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiExtraIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtraLT?: InputMaybe<Scalars['String']['input']>;
  apiExtraLTE?: InputMaybe<Scalars['String']['input']>;
  apiExtraNEQ?: InputMaybe<Scalars['String']['input']>;
  apiExtraNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiExtraNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_skip_ssl field predicates */
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiSkipSslNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_timeout_seconds field predicates */
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  apiTimeoutSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** api_url field predicates */
  apiURL?: InputMaybe<Scalars['String']['input']>;
  apiURLContains?: InputMaybe<Scalars['String']['input']>;
  apiURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiURLGT?: InputMaybe<Scalars['String']['input']>;
  apiURLGTE?: InputMaybe<Scalars['String']['input']>;
  apiURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiURLLT?: InputMaybe<Scalars['String']['input']>;
  apiURLLTE?: InputMaybe<Scalars['String']['input']>;
  apiURLNEQ?: InputMaybe<Scalars['String']['input']>;
  apiURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** config field predicates */
  config?: InputMaybe<Scalars['JSON']['input']>;
  configGT?: InputMaybe<Scalars['JSON']['input']>;
  configGTE?: InputMaybe<Scalars['JSON']['input']>;
  configIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  configLT?: InputMaybe<Scalars['JSON']['input']>;
  configLTE?: InputMaybe<Scalars['JSON']['input']>;
  configNEQ?: InputMaybe<Scalars['JSON']['input']>;
  configNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** headers field predicates */
  headers?: InputMaybe<Scalars['JSON']['input']>;
  headersGT?: InputMaybe<Scalars['JSON']['input']>;
  headersGTE?: InputMaybe<Scalars['JSON']['input']>;
  headersIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  headersLT?: InputMaybe<Scalars['JSON']['input']>;
  headersLTE?: InputMaybe<Scalars['JSON']['input']>;
  headersNEQ?: InputMaybe<Scalars['JSON']['input']>;
  headersNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_response field predicates */
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastResponseContains?: InputMaybe<Scalars['String']['input']>;
  lastResponseContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseGT?: InputMaybe<Scalars['String']['input']>;
  lastResponseGTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastResponseIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastResponseLT?: InputMaybe<Scalars['String']['input']>;
  lastResponseLTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseNEQ?: InputMaybe<Scalars['String']['input']>;
  lastResponseNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_attempt_at field predicates */
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PusherConfigWhereInput>;
  or?: InputMaybe<Array<PusherConfigWhereInput>>;
  /** pause_on_failure_seconds field predicates */
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  pauseOnFailureSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** periodic_batch_seconds field predicates */
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicBatchSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** periodic_max_batch_size field predicates */
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeGT?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicMaxBatchSizeLT?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<PusherConfigType>;
  typeIn?: InputMaybe<Array<PusherConfigType>>;
  typeNEQ?: InputMaybe<PusherConfigType>;
  typeNotIn?: InputMaybe<Array<PusherConfigType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** with_address field predicates */
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
  withAddressNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PusherLog = Node & {
  __typename?: 'PusherLog';
  createdAt: Scalars['Time']['output'];
  deviceID?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  responseData?: Maybe<Scalars['String']['output']>;
  responseSeconds?: Maybe<Scalars['Int']['output']>;
  sentData?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type PusherLogConnection = {
  __typename?: 'PusherLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PusherLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PusherLogEdge = {
  __typename?: 'PusherLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PusherLog>;
};

export enum PusherLogField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Imei = 'imei',
  Notes = 'notes',
  ResponseCode = 'responseCode',
  ResponseData = 'responseData',
  ResponseSeconds = 'responseSeconds',
  SentData = 'sentData',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for PusherLog connections */
export type PusherLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PusherLogs. */
  field: PusherLogOrderField;
};

/** Properties by which PusherLog connections can be ordered. */
export enum PusherLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PusherLogWhereInput is used for filtering PusherLog objects.
 * Input was generated by ent.
 */
export type PusherLogWhereInput = {
  and?: InputMaybe<Array<PusherLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  deviceIDGT?: InputMaybe<Scalars['Int']['input']>;
  deviceIDGTE?: InputMaybe<Scalars['Int']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceIDLT?: InputMaybe<Scalars['Int']['input']>;
  deviceIDLTE?: InputMaybe<Scalars['Int']['input']>;
  deviceIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imei field predicates */
  imei?: InputMaybe<Scalars['String']['input']>;
  imeiContains?: InputMaybe<Scalars['String']['input']>;
  imeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imeiGT?: InputMaybe<Scalars['String']['input']>;
  imeiGTE?: InputMaybe<Scalars['String']['input']>;
  imeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  imeiLT?: InputMaybe<Scalars['String']['input']>;
  imeiLTE?: InputMaybe<Scalars['String']['input']>;
  imeiNEQ?: InputMaybe<Scalars['String']['input']>;
  imeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PusherLogWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<PusherLogWhereInput>>;
  /** response_code field predicates */
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseCodeGT?: InputMaybe<Scalars['Int']['input']>;
  responseCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  responseCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeLT?: InputMaybe<Scalars['Int']['input']>;
  responseCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  responseCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_data field predicates */
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseDataContains?: InputMaybe<Scalars['String']['input']>;
  responseDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseDataGT?: InputMaybe<Scalars['String']['input']>;
  responseDataGTE?: InputMaybe<Scalars['String']['input']>;
  responseDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseDataLT?: InputMaybe<Scalars['String']['input']>;
  responseDataLTE?: InputMaybe<Scalars['String']['input']>;
  responseDataNEQ?: InputMaybe<Scalars['String']['input']>;
  responseDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_seconds field predicates */
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseSecondsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseSecondsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sent_data field predicates */
  sentData?: InputMaybe<Scalars['String']['input']>;
  sentDataContains?: InputMaybe<Scalars['String']['input']>;
  sentDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  sentDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  sentDataGT?: InputMaybe<Scalars['String']['input']>;
  sentDataGTE?: InputMaybe<Scalars['String']['input']>;
  sentDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sentDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sentDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sentDataLT?: InputMaybe<Scalars['String']['input']>;
  sentDataLTE?: InputMaybe<Scalars['String']['input']>;
  sentDataNEQ?: InputMaybe<Scalars['String']['input']>;
  sentDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  APIUserExport?: Maybe<Scalars['String']['output']>;
  APIUserQuery: ApiUserConnection;
  BaseAddonExport?: Maybe<Scalars['String']['output']>;
  BaseAddonQuery: BaseAddonConnection;
  BaseLicensePlanAddonExport?: Maybe<Scalars['String']['output']>;
  BaseLicensePlanAddonQuery: BaseLicensePlanAddonConnection;
  BaseLicensePlanExport?: Maybe<Scalars['String']['output']>;
  BaseLicensePlanQuery: BaseLicensePlanConnection;
  BaseReportExport?: Maybe<Scalars['String']['output']>;
  BaseReportQuery: BaseReportConnection;
  ChangeLogExport?: Maybe<Scalars['String']['output']>;
  ChangeLogQuery: ChangeLogConnection;
  Chatbot: Scalars['JSON']['output'];
  ConsumerConfigExport?: Maybe<Scalars['String']['output']>;
  ConsumerConfigQuery: ConsumerConfigConnection;
  ConsumerServerExport?: Maybe<Scalars['String']['output']>;
  ConsumerServerQuery: ConsumerServerConnection;
  CurrentUser?: Maybe<CurrentUserResponse>;
  DerivedReportExport?: Maybe<Scalars['String']['output']>;
  DerivedReportQuery: DerivedReportConnection;
  DeviceACLExport?: Maybe<Scalars['String']['output']>;
  DeviceACLQuery: DeviceAclConnection;
  DeviceActionLogExport?: Maybe<Scalars['String']['output']>;
  DeviceActionLogQuery: DeviceActionLogConnection;
  DeviceAddonModelExport?: Maybe<Scalars['String']['output']>;
  DeviceAddonModelQuery: DeviceAddonModelConnection;
  DeviceAdvancedConfigExport?: Maybe<Scalars['String']['output']>;
  DeviceAdvancedConfigQuery: DeviceAdvancedConfigConnection;
  DeviceCategoryExport?: Maybe<Scalars['String']['output']>;
  DeviceCategoryQuery: DeviceCategoryConnection;
  DeviceChannelConfigExport?: Maybe<Scalars['String']['output']>;
  DeviceChannelConfigQuery: DeviceChannelConfigConnection;
  DeviceCommandExport?: Maybe<Scalars['String']['output']>;
  DeviceCommandQuery: DeviceCommandConnection;
  DeviceDocumentExport?: Maybe<Scalars['String']['output']>;
  DeviceDocumentQuery: DeviceDocumentConnection;
  DeviceDocumentTypeExport?: Maybe<Scalars['String']['output']>;
  DeviceDocumentTypeQuery: DeviceDocumentTypeConnection;
  DeviceExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupDocumentExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupDocumentQuery: DeviceGroupDocumentConnection;
  DeviceGroupDocumentTypeExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupDocumentTypeQuery: DeviceGroupDocumentTypeConnection;
  DeviceGroupExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupQuery: DeviceGroupConnection;
  DeviceModelChannelExport?: Maybe<Scalars['String']['output']>;
  DeviceModelChannelQuery: DeviceModelChannelConnection;
  DeviceModelExport?: Maybe<Scalars['String']['output']>;
  DeviceModelQuery: DeviceModelConnection;
  DeviceParkingModeConfigExport?: Maybe<Scalars['String']['output']>;
  DeviceParkingModeConfigQuery: DeviceParkingModeConfigConnection;
  DeviceQuery: DeviceConnection;
  DeviceSharingExport?: Maybe<Scalars['String']['output']>;
  DeviceSharingQuery: DeviceSharingConnection;
  DeviceVehicleExport?: Maybe<Scalars['String']['output']>;
  DeviceVehicleQuery: DeviceVehicleConnection;
  DomainExport?: Maybe<Scalars['String']['output']>;
  DomainQuery: DomainConnection;
  EmailOrMobileBasedOrganisations: Array<Organisation>;
  ExportExport?: Maybe<Scalars['String']['output']>;
  ExportQuery: ExportConnection;
  FirebasePrivateKeyExport?: Maybe<Scalars['String']['output']>;
  FirebasePrivateKeyQuery: FirebasePrivateKeyConnection;
  GeofenceDeviceGroupExport?: Maybe<Scalars['String']['output']>;
  GeofenceDeviceGroupQuery: GeofenceDeviceGroupConnection;
  GeofenceExport?: Maybe<Scalars['String']['output']>;
  GeofenceQuery: GeofenceConnection;
  Impersonate: LoginResponse;
  KmlExport?: Maybe<Scalars['String']['output']>;
  KmlQuery: KmlConnection;
  LastFewEvents: Array<Maybe<LastFewEventsResponse>>;
  LegacySyncExport?: Maybe<Scalars['String']['output']>;
  LegacySyncQuery: LegacySyncConnection;
  LicenseExport?: Maybe<Scalars['String']['output']>;
  LicenseOrderAddonExport?: Maybe<Scalars['String']['output']>;
  LicenseOrderAddonQuery: LicenseOrderAddonConnection;
  LicenseQuery: LicenseConnection;
  LoginLogExport?: Maybe<Scalars['String']['output']>;
  LoginLogQuery: LoginLogConnection;
  MapConfigExport?: Maybe<Scalars['String']['output']>;
  MapConfigQuery: MapConfigConnection;
  MediaFileExport?: Maybe<Scalars['String']['output']>;
  MediaFileQuery: MediaFileConnection;
  NotifyChannelExport?: Maybe<Scalars['String']['output']>;
  NotifyChannelQuery: NotifyChannelConnection;
  NotifyConfigChannelExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigChannelQuery: NotifyConfigChannelConnection;
  NotifyConfigDeviceGroupExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigDeviceGroupQuery: NotifyConfigDeviceGroupConnection;
  NotifyConfigEventExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigEventQuery: NotifyConfigEventConnection;
  NotifyConfigExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigGeofenceExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigGeofenceQuery: NotifyConfigGeofenceConnection;
  NotifyConfigQuery: NotifyConfigConnection;
  NotifyEventOptionExport?: Maybe<Scalars['String']['output']>;
  NotifyEventOptionQuery: NotifyEventOptionConnection;
  OrganisationExport?: Maybe<Scalars['String']['output']>;
  OrganisationQuery: OrganisationConnection;
  OrganisationReportAccessExport?: Maybe<Scalars['String']['output']>;
  OrganisationReportAccessQuery: OrganisationReportAccessConnection;
  OrganisationRoleExport?: Maybe<Scalars['String']['output']>;
  OrganisationRolePermissionExport?: Maybe<Scalars['String']['output']>;
  OrganisationRolePermissionQuery: OrganisationRolePermissionConnection;
  OrganisationRoleQuery: OrganisationRoleConnection;
  OrganisationUpgradeExport?: Maybe<Scalars['String']['output']>;
  OrganisationUpgradeQuery: OrganisationUpgradeConnection;
  OrganisationUserDocumentExport?: Maybe<Scalars['String']['output']>;
  OrganisationUserDocumentQuery: OrganisationUserDocumentConnection;
  OrganisationUserDocumentTypeExport?: Maybe<Scalars['String']['output']>;
  OrganisationUserDocumentTypeQuery: OrganisationUserDocumentTypeConnection;
  OrganisationUserExport?: Maybe<Scalars['String']['output']>;
  OrganisationUserQuery: OrganisationUserConnection;
  OtpLogin: LoginResponse;
  PasswordLogin: LoginResponse;
  PeriodicJobExport?: Maybe<Scalars['String']['output']>;
  PeriodicJobQuery: PeriodicJobConnection;
  PermissionExport?: Maybe<Scalars['String']['output']>;
  PermissionQuery: PermissionConnection;
  PinnedDevicesExport?: Maybe<Scalars['String']['output']>;
  PinnedDevicesQuery: PinnedDevicesConnection;
  PoiExport?: Maybe<Scalars['String']['output']>;
  PoiQuery: PoiConnection;
  PositionPolling: Array<Maybe<PositionPollingResponse>>;
  ProfileExport?: Maybe<Scalars['String']['output']>;
  ProfileQuery: ProfileConnection;
  PusherConfigExport?: Maybe<Scalars['String']['output']>;
  PusherConfigQuery: PusherConfigConnection;
  PusherLogExport?: Maybe<Scalars['String']['output']>;
  PusherLogQuery: PusherLogConnection;
  RefreshToken: LoginResponse;
  ReportEvent?: Maybe<ReportEventResponse>;
  ReportOnEmail?: Maybe<Scalars['String']['output']>;
  ReportPosition?: Maybe<ReportPositionResponse>;
  ReportStopIdle?: Maybe<ReportReportStopIdleResponse>;
  ReportSummary?: Maybe<ReportSummaryResponse>;
  ReportTrip?: Maybe<ReportTripResponse>;
  SendFcmTestNotification: Scalars['Boolean']['output'];
  SendOtp: Scalars['Boolean']['output'];
  SettingExport?: Maybe<Scalars['String']['output']>;
  SettingQuery: SettingConnection;
  SimExport?: Maybe<Scalars['String']['output']>;
  SimQuery: SimConnection;
  StaffRoleExport?: Maybe<Scalars['String']['output']>;
  StaffRoleQuery: StaffRoleConnection;
  SubscriptionLicenseOrderExport?: Maybe<Scalars['String']['output']>;
  SubscriptionLicenseOrderQuery: SubscriptionLicenseOrderConnection;
  SupportDocumentExport?: Maybe<Scalars['String']['output']>;
  SupportDocumentQuery: SupportDocumentConnection;
  TaskStatus: TaskState;
  UpgradeExport?: Maybe<Scalars['String']['output']>;
  UpgradeOrganisationPriceExport?: Maybe<Scalars['String']['output']>;
  UpgradeOrganisationPriceQuery: UpgradeOrganisationPriceConnection;
  UpgradeQuery: UpgradeConnection;
  UserConfigExport?: Maybe<Scalars['String']['output']>;
  UserConfigQuery: UserConfigConnection;
  UserExport?: Maybe<Scalars['String']['output']>;
  UserFcmTokenExport?: Maybe<Scalars['String']['output']>;
  UserFcmTokenQuery: UserFcmTokenConnection;
  UserQuery: UserConnection;
  UserReportBookmarkExport?: Maybe<Scalars['String']['output']>;
  UserReportBookmarkQuery: UserReportBookmarkConnection;
  WalletExport?: Maybe<Scalars['String']['output']>;
  WalletPaymentTransactionExport?: Maybe<Scalars['String']['output']>;
  WalletPaymentTransactionQuery: WalletPaymentTransactionConnection;
  WalletQuery: WalletConnection;
  WalletTransactionExport?: Maybe<Scalars['String']['output']>;
  WalletTransactionQuery: WalletTransactionConnection;
  WhatsAppConfigExport?: Maybe<Scalars['String']['output']>;
  WhatsAppConfigQuery: WhatsAppConfigConnection;
  WhitelabelConfigExport?: Maybe<Scalars['String']['output']>;
  WhitelabelConfigQuery: WhitelabelConfigConnection;
  WhitelabelCoreSettingOverrideExport?: Maybe<Scalars['String']['output']>;
  WhitelabelCoreSettingOverrideQuery: WhitelabelCoreSettingOverrideConnection;
  WhitelabelExport?: Maybe<Scalars['String']['output']>;
  WhitelabelQuery: WhitelabelConnection;
  YardDriverProfileExport?: Maybe<Scalars['String']['output']>;
  YardDriverProfileQuery: YardDriverProfileConnection;
  YardMaterialExport?: Maybe<Scalars['String']['output']>;
  YardMaterialQuery: YardMaterialConnection;
  YardMaterialTypeExport?: Maybe<Scalars['String']['output']>;
  YardMaterialTypeQuery: YardMaterialTypeConnection;
  YardTripApprovalExport?: Maybe<Scalars['String']['output']>;
  YardTripApprovalQuery: YardTripApprovalConnection;
  YardTripExport?: Maybe<Scalars['String']['output']>;
  YardTripQuery: YardTripConnection;
  YardTripStatusExport?: Maybe<Scalars['String']['output']>;
  YardTripStatusQuery: YardTripStatusConnection;
  YardVehicleExport?: Maybe<Scalars['String']['output']>;
  YardVehicleQuery: YardVehicleConnection;
  YardVendorExport?: Maybe<Scalars['String']['output']>;
  YardVendorQuery: YardVendorConnection;
  YardWarehouseActivityTypeExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseActivityTypeQuery: YardWarehouseActivityTypeConnection;
  YardWarehouseApprovalMatrixExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseApprovalMatrixQuery: YardWarehouseApprovalMatrixConnection;
  YardWarehouseDockExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseDockQuery: YardWarehouseDockConnection;
  YardWarehouseExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseParkingExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseParkingQuery: YardWarehouseParkingConnection;
  YardWarehouseQuery: YardWarehouseConnection;
  YardWarehouseRouteExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseRoutePathExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseRoutePathQuery: YardWarehouseRoutePathConnection;
  YardWarehouseRouteQuery: YardWarehouseRouteConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type QueryApiUserExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiUserOrder>>;
  where?: InputMaybe<ApiUserWhereInput>;
};


export type QueryApiUserQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiUserOrder>>;
  where?: InputMaybe<ApiUserWhereInput>;
};


export type QueryBaseAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseAddonOrder>>;
  where?: InputMaybe<BaseAddonWhereInput>;
};


export type QueryBaseAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseAddonOrder>>;
  where?: InputMaybe<BaseAddonWhereInput>;
};


export type QueryBaseLicensePlanAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanAddonOrder>>;
  where?: InputMaybe<BaseLicensePlanAddonWhereInput>;
};


export type QueryBaseLicensePlanAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanAddonOrder>>;
  where?: InputMaybe<BaseLicensePlanAddonWhereInput>;
};


export type QueryBaseLicensePlanExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanOrder>>;
  where?: InputMaybe<BaseLicensePlanWhereInput>;
};


export type QueryBaseLicensePlanQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanOrder>>;
  where?: InputMaybe<BaseLicensePlanWhereInput>;
};


export type QueryBaseReportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseReportOrder>>;
  where?: InputMaybe<BaseReportWhereInput>;
};


export type QueryBaseReportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseReportOrder>>;
  where?: InputMaybe<BaseReportWhereInput>;
};


export type QueryChangeLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeLogOrder>>;
  where?: InputMaybe<ChangeLogWhereInput>;
};


export type QueryChangeLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeLogOrder>>;
  where?: InputMaybe<ChangeLogWhereInput>;
};


export type QueryChatbotArgs = {
  conversationId: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type QueryConsumerConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerConfigOrder>>;
  where?: InputMaybe<ConsumerConfigWhereInput>;
};


export type QueryConsumerConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerConfigOrder>>;
  where?: InputMaybe<ConsumerConfigWhereInput>;
};


export type QueryConsumerServerExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerServerOrder>>;
  where?: InputMaybe<ConsumerServerWhereInput>;
};


export type QueryConsumerServerQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerServerOrder>>;
  where?: InputMaybe<ConsumerServerWhereInput>;
};


export type QueryDerivedReportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DerivedReportOrder>>;
  where?: InputMaybe<DerivedReportWhereInput>;
};


export type QueryDerivedReportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DerivedReportOrder>>;
  where?: InputMaybe<DerivedReportWhereInput>;
};


export type QueryDeviceAclExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAclOrder>>;
  where?: InputMaybe<DeviceAclWhereInput>;
};


export type QueryDeviceAclQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAclOrder>>;
  where?: InputMaybe<DeviceAclWhereInput>;
};


export type QueryDeviceActionLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceActionLogOrder>>;
  where?: InputMaybe<DeviceActionLogWhereInput>;
};


export type QueryDeviceActionLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceActionLogOrder>>;
  where?: InputMaybe<DeviceActionLogWhereInput>;
};


export type QueryDeviceAddonModelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAddonModelOrder>>;
  where?: InputMaybe<DeviceAddonModelWhereInput>;
};


export type QueryDeviceAddonModelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAddonModelOrder>>;
  where?: InputMaybe<DeviceAddonModelWhereInput>;
};


export type QueryDeviceAdvancedConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAdvancedConfigOrder>>;
  where?: InputMaybe<DeviceAdvancedConfigWhereInput>;
};


export type QueryDeviceAdvancedConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceAdvancedConfigOrder>>;
  where?: InputMaybe<DeviceAdvancedConfigWhereInput>;
};


export type QueryDeviceCategoryExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCategoryOrder>>;
  where?: InputMaybe<DeviceCategoryWhereInput>;
};


export type QueryDeviceCategoryQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCategoryOrder>>;
  where?: InputMaybe<DeviceCategoryWhereInput>;
};


export type QueryDeviceChannelConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceChannelConfigOrder>>;
  where?: InputMaybe<DeviceChannelConfigWhereInput>;
};


export type QueryDeviceChannelConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceChannelConfigOrder>>;
  where?: InputMaybe<DeviceChannelConfigWhereInput>;
};


export type QueryDeviceCommandExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCommandOrder>>;
  where?: InputMaybe<DeviceCommandWhereInput>;
};


export type QueryDeviceCommandQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCommandOrder>>;
  where?: InputMaybe<DeviceCommandWhereInput>;
};


export type QueryDeviceDocumentExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceDocumentOrder>>;
  where?: InputMaybe<DeviceDocumentWhereInput>;
};


export type QueryDeviceDocumentQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceDocumentOrder>>;
  where?: InputMaybe<DeviceDocumentWhereInput>;
};


export type QueryDeviceDocumentTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceDocumentTypeOrder>>;
  where?: InputMaybe<DeviceDocumentTypeWhereInput>;
};


export type QueryDeviceDocumentTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceDocumentTypeOrder>>;
  where?: InputMaybe<DeviceDocumentTypeWhereInput>;
};


export type QueryDeviceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrder>>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type QueryDeviceGroupDocumentExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupDocumentOrder>>;
  where?: InputMaybe<DeviceGroupDocumentWhereInput>;
};


export type QueryDeviceGroupDocumentQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupDocumentOrder>>;
  where?: InputMaybe<DeviceGroupDocumentWhereInput>;
};


export type QueryDeviceGroupDocumentTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupDocumentTypeOrder>>;
  where?: InputMaybe<DeviceGroupDocumentTypeWhereInput>;
};


export type QueryDeviceGroupDocumentTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupDocumentTypeOrder>>;
  where?: InputMaybe<DeviceGroupDocumentTypeWhereInput>;
};


export type QueryDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupOrder>>;
  where?: InputMaybe<DeviceGroupWhereInput>;
};


export type QueryDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupOrder>>;
  where?: InputMaybe<DeviceGroupWhereInput>;
};


export type QueryDeviceModelChannelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelChannelOrder>>;
  where?: InputMaybe<DeviceModelChannelWhereInput>;
};


export type QueryDeviceModelChannelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelChannelOrder>>;
  where?: InputMaybe<DeviceModelChannelWhereInput>;
};


export type QueryDeviceModelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelOrder>>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type QueryDeviceModelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelOrder>>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type QueryDeviceParkingModeConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceParkingModeConfigOrder>>;
  where?: InputMaybe<DeviceParkingModeConfigWhereInput>;
};


export type QueryDeviceParkingModeConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceParkingModeConfigOrder>>;
  where?: InputMaybe<DeviceParkingModeConfigWhereInput>;
};


export type QueryDeviceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrder>>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type QueryDeviceSharingExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceSharingOrder>>;
  where?: InputMaybe<DeviceSharingWhereInput>;
};


export type QueryDeviceSharingQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceSharingOrder>>;
  where?: InputMaybe<DeviceSharingWhereInput>;
};


export type QueryDeviceVehicleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceVehicleOrder>>;
  where?: InputMaybe<DeviceVehicleWhereInput>;
};


export type QueryDeviceVehicleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceVehicleOrder>>;
  where?: InputMaybe<DeviceVehicleWhereInput>;
};


export type QueryDomainExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DomainOrder>>;
  where?: InputMaybe<DomainWhereInput>;
};


export type QueryDomainQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DomainOrder>>;
  where?: InputMaybe<DomainWhereInput>;
};


export type QueryEmailOrMobileBasedOrganisationsArgs = {
  androidAppPackageName?: InputMaybe<Scalars['String']['input']>;
  emailOrMobile: Scalars['String']['input'];
  iosAppPackageName?: InputMaybe<Scalars['String']['input']>;
  webDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExportOrder>>;
  where?: InputMaybe<ExportWhereInput>;
};


export type QueryExportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExportOrder>>;
  where?: InputMaybe<ExportWhereInput>;
};


export type QueryFirebasePrivateKeyExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FirebasePrivateKeyOrder>>;
  where?: InputMaybe<FirebasePrivateKeyWhereInput>;
};


export type QueryFirebasePrivateKeyQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FirebasePrivateKeyOrder>>;
  where?: InputMaybe<FirebasePrivateKeyWhereInput>;
};


export type QueryGeofenceDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceDeviceGroupOrder>>;
  where?: InputMaybe<GeofenceDeviceGroupWhereInput>;
};


export type QueryGeofenceDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceDeviceGroupOrder>>;
  where?: InputMaybe<GeofenceDeviceGroupWhereInput>;
};


export type QueryGeofenceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceOrder>>;
  where?: InputMaybe<GeofenceWhereInput>;
};


export type QueryGeofenceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceOrder>>;
  where?: InputMaybe<GeofenceWhereInput>;
};


export type QueryImpersonateArgs = {
  organisationUserId: Scalars['ID']['input'];
};


export type QueryKmlExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KmlOrder>>;
  where?: InputMaybe<KmlWhereInput>;
};


export type QueryKmlQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KmlOrder>>;
  where?: InputMaybe<KmlWhereInput>;
};


export type QueryLastFewEventsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLegacySyncExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegacySyncOrder>>;
  where?: InputMaybe<LegacySyncWhereInput>;
};


export type QueryLegacySyncQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LegacySyncOrder>>;
  where?: InputMaybe<LegacySyncWhereInput>;
};


export type QueryLicenseExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrder>>;
  where?: InputMaybe<LicenseWhereInput>;
};


export type QueryLicenseOrderAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrderAddonOrder>>;
  where?: InputMaybe<LicenseOrderAddonWhereInput>;
};


export type QueryLicenseOrderAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrderAddonOrder>>;
  where?: InputMaybe<LicenseOrderAddonWhereInput>;
};


export type QueryLicenseQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrder>>;
  where?: InputMaybe<LicenseWhereInput>;
};


export type QueryLoginLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoginLogOrder>>;
  where?: InputMaybe<LoginLogWhereInput>;
};


export type QueryLoginLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoginLogOrder>>;
  where?: InputMaybe<LoginLogWhereInput>;
};


export type QueryMapConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MapConfigOrder>>;
  where?: InputMaybe<MapConfigWhereInput>;
};


export type QueryMapConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MapConfigOrder>>;
  where?: InputMaybe<MapConfigWhereInput>;
};


export type QueryMediaFileExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaFileOrder>>;
  where?: InputMaybe<MediaFileWhereInput>;
};


export type QueryMediaFileQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaFileOrder>>;
  where?: InputMaybe<MediaFileWhereInput>;
};


export type QueryNotifyChannelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyChannelOrder>>;
  where?: InputMaybe<NotifyChannelWhereInput>;
};


export type QueryNotifyChannelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyChannelOrder>>;
  where?: InputMaybe<NotifyChannelWhereInput>;
};


export type QueryNotifyConfigChannelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigChannelOrder>>;
  where?: InputMaybe<NotifyConfigChannelWhereInput>;
};


export type QueryNotifyConfigChannelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigChannelOrder>>;
  where?: InputMaybe<NotifyConfigChannelWhereInput>;
};


export type QueryNotifyConfigDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigDeviceGroupOrder>>;
  where?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
};


export type QueryNotifyConfigDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigDeviceGroupOrder>>;
  where?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
};


export type QueryNotifyConfigEventExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigEventOrder>>;
  where?: InputMaybe<NotifyConfigEventWhereInput>;
};


export type QueryNotifyConfigEventQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigEventOrder>>;
  where?: InputMaybe<NotifyConfigEventWhereInput>;
};


export type QueryNotifyConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigOrder>>;
  where?: InputMaybe<NotifyConfigWhereInput>;
};


export type QueryNotifyConfigGeofenceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigGeofenceOrder>>;
  where?: InputMaybe<NotifyConfigGeofenceWhereInput>;
};


export type QueryNotifyConfigGeofenceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigGeofenceOrder>>;
  where?: InputMaybe<NotifyConfigGeofenceWhereInput>;
};


export type QueryNotifyConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigOrder>>;
  where?: InputMaybe<NotifyConfigWhereInput>;
};


export type QueryNotifyEventOptionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyEventOptionOrder>>;
  where?: InputMaybe<NotifyEventOptionWhereInput>;
};


export type QueryNotifyEventOptionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyEventOptionOrder>>;
  where?: InputMaybe<NotifyEventOptionWhereInput>;
};


export type QueryOrganisationExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationOrder>>;
  where?: InputMaybe<OrganisationWhereInput>;
};


export type QueryOrganisationQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationOrder>>;
  where?: InputMaybe<OrganisationWhereInput>;
};


export type QueryOrganisationReportAccessExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationReportAccessOrder>>;
  where?: InputMaybe<OrganisationReportAccessWhereInput>;
};


export type QueryOrganisationReportAccessQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationReportAccessOrder>>;
  where?: InputMaybe<OrganisationReportAccessWhereInput>;
};


export type QueryOrganisationRoleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRoleOrder>>;
  where?: InputMaybe<OrganisationRoleWhereInput>;
};


export type QueryOrganisationRolePermissionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRolePermissionOrder>>;
  where?: InputMaybe<OrganisationRolePermissionWhereInput>;
};


export type QueryOrganisationRolePermissionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRolePermissionOrder>>;
  where?: InputMaybe<OrganisationRolePermissionWhereInput>;
};


export type QueryOrganisationRoleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRoleOrder>>;
  where?: InputMaybe<OrganisationRoleWhereInput>;
};


export type QueryOrganisationUpgradeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUpgradeOrder>>;
  where?: InputMaybe<OrganisationUpgradeWhereInput>;
};


export type QueryOrganisationUpgradeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUpgradeOrder>>;
  where?: InputMaybe<OrganisationUpgradeWhereInput>;
};


export type QueryOrganisationUserDocumentExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserDocumentOrder>>;
  where?: InputMaybe<OrganisationUserDocumentWhereInput>;
};


export type QueryOrganisationUserDocumentQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserDocumentOrder>>;
  where?: InputMaybe<OrganisationUserDocumentWhereInput>;
};


export type QueryOrganisationUserDocumentTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserDocumentTypeOrder>>;
  where?: InputMaybe<OrganisationUserDocumentTypeWhereInput>;
};


export type QueryOrganisationUserDocumentTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserDocumentTypeOrder>>;
  where?: InputMaybe<OrganisationUserDocumentTypeWhereInput>;
};


export type QueryOrganisationUserExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserOrder>>;
  where?: InputMaybe<OrganisationUserWhereInput>;
};


export type QueryOrganisationUserQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserOrder>>;
  where?: InputMaybe<OrganisationUserWhereInput>;
};


export type QueryOtpLoginArgs = {
  mobileNumber: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  otp: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformUniqueId: Scalars['String']['input'];
};


export type QueryPasswordLoginArgs = {
  email: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformUniqueId: Scalars['String']['input'];
};


export type QueryPeriodicJobExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PeriodicJobOrder>>;
  where?: InputMaybe<PeriodicJobWhereInput>;
};


export type QueryPeriodicJobQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PeriodicJobOrder>>;
  where?: InputMaybe<PeriodicJobWhereInput>;
};


export type QueryPermissionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PermissionOrder>>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPermissionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PermissionOrder>>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPinnedDevicesExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PinnedDevicesOrder>>;
  where?: InputMaybe<PinnedDevicesWhereInput>;
};


export type QueryPinnedDevicesQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PinnedDevicesOrder>>;
  where?: InputMaybe<PinnedDevicesWhereInput>;
};


export type QueryPoiExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoiOrder>>;
  where?: InputMaybe<PoiWhereInput>;
};


export type QueryPoiQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoiOrder>>;
  where?: InputMaybe<PoiWhereInput>;
};


export type QueryPositionPollingArgs = {
  onlyDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onlyDeviceStatus?: InputMaybe<Array<InputMaybe<DeviceStatus>>>;
  onlyLastUpdateGTE?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryProfileExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrder>>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryProfileQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrder>>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryPusherConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherConfigOrder>>;
  where?: InputMaybe<PusherConfigWhereInput>;
};


export type QueryPusherConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherConfigOrder>>;
  where?: InputMaybe<PusherConfigWhereInput>;
};


export type QueryPusherLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherLogOrder>>;
  where?: InputMaybe<PusherLogWhereInput>;
};


export type QueryPusherLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherLogOrder>>;
  where?: InputMaybe<PusherLogWhereInput>;
};


export type QueryReportEventArgs = {
  input: ReportQueryInput;
};


export type QueryReportOnEmailArgs = {
  emailInput: ReportEmailInput;
  queryInput: ReportQueryInput;
};


export type QueryReportPositionArgs = {
  input: ReportQueryInput;
};


export type QueryReportStopIdleArgs = {
  input: ReportQueryInput;
};


export type QueryReportSummaryArgs = {
  input: ReportQueryInput;
};


export type QueryReportTripArgs = {
  input: ReportQueryInput;
};


export type QuerySendFcmTestNotificationArgs = {
  platformUniqueId: Scalars['String']['input'];
};


export type QuerySendOtpArgs = {
  mobileNumber: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QuerySettingExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SettingOrder>>;
  where?: InputMaybe<SettingWhereInput>;
};


export type QuerySettingQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SettingOrder>>;
  where?: InputMaybe<SettingWhereInput>;
};


export type QuerySimExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SimOrder>>;
  where?: InputMaybe<SimWhereInput>;
};


export type QuerySimQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SimOrder>>;
  where?: InputMaybe<SimWhereInput>;
};


export type QueryStaffRoleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StaffRoleOrder>>;
  where?: InputMaybe<StaffRoleWhereInput>;
};


export type QueryStaffRoleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StaffRoleOrder>>;
  where?: InputMaybe<StaffRoleWhereInput>;
};


export type QuerySubscriptionLicenseOrderExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionLicenseOrderOrder>>;
  where?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
};


export type QuerySubscriptionLicenseOrderQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionLicenseOrderOrder>>;
  where?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
};


export type QuerySupportDocumentExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportDocumentOrder>>;
  where?: InputMaybe<SupportDocumentWhereInput>;
};


export type QuerySupportDocumentQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportDocumentOrder>>;
  where?: InputMaybe<SupportDocumentWhereInput>;
};


export type QueryTaskStatusArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryUpgradeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrder>>;
  where?: InputMaybe<UpgradeWhereInput>;
};


export type QueryUpgradeOrganisationPriceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrganisationPriceOrder>>;
  where?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
};


export type QueryUpgradeOrganisationPriceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrganisationPriceOrder>>;
  where?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
};


export type QueryUpgradeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrder>>;
  where?: InputMaybe<UpgradeWhereInput>;
};


export type QueryUserConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserConfigOrder>>;
  where?: InputMaybe<UserConfigWhereInput>;
};


export type QueryUserConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserConfigOrder>>;
  where?: InputMaybe<UserConfigWhereInput>;
};


export type QueryUserExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrder>>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUserFcmTokenExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserFcmTokenOrder>>;
  where?: InputMaybe<UserFcmTokenWhereInput>;
};


export type QueryUserFcmTokenQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserFcmTokenOrder>>;
  where?: InputMaybe<UserFcmTokenWhereInput>;
};


export type QueryUserQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrder>>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUserReportBookmarkExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserReportBookmarkOrder>>;
  where?: InputMaybe<UserReportBookmarkWhereInput>;
};


export type QueryUserReportBookmarkQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserReportBookmarkOrder>>;
  where?: InputMaybe<UserReportBookmarkWhereInput>;
};


export type QueryWalletExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletOrder>>;
  where?: InputMaybe<WalletWhereInput>;
};


export type QueryWalletPaymentTransactionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletPaymentTransactionOrder>>;
  where?: InputMaybe<WalletPaymentTransactionWhereInput>;
};


export type QueryWalletPaymentTransactionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletPaymentTransactionOrder>>;
  where?: InputMaybe<WalletPaymentTransactionWhereInput>;
};


export type QueryWalletQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletOrder>>;
  where?: InputMaybe<WalletWhereInput>;
};


export type QueryWalletTransactionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletTransactionOrder>>;
  where?: InputMaybe<WalletTransactionWhereInput>;
};


export type QueryWalletTransactionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletTransactionOrder>>;
  where?: InputMaybe<WalletTransactionWhereInput>;
};


export type QueryWhatsAppConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhatsAppConfigOrder>>;
  where?: InputMaybe<WhatsAppConfigWhereInput>;
};


export type QueryWhatsAppConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhatsAppConfigOrder>>;
  where?: InputMaybe<WhatsAppConfigWhereInput>;
};


export type QueryWhitelabelConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelConfigOrder>>;
  where?: InputMaybe<WhitelabelConfigWhereInput>;
};


export type QueryWhitelabelConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelConfigOrder>>;
  where?: InputMaybe<WhitelabelConfigWhereInput>;
};


export type QueryWhitelabelCoreSettingOverrideExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelCoreSettingOverrideOrder>>;
  where?: InputMaybe<WhitelabelCoreSettingOverrideWhereInput>;
};


export type QueryWhitelabelCoreSettingOverrideQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelCoreSettingOverrideOrder>>;
  where?: InputMaybe<WhitelabelCoreSettingOverrideWhereInput>;
};


export type QueryWhitelabelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelOrder>>;
  where?: InputMaybe<WhitelabelWhereInput>;
};


export type QueryWhitelabelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelOrder>>;
  where?: InputMaybe<WhitelabelWhereInput>;
};


export type QueryYardDriverProfileExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardDriverProfileOrder>>;
  where?: InputMaybe<YardDriverProfileWhereInput>;
};


export type QueryYardDriverProfileQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardDriverProfileOrder>>;
  where?: InputMaybe<YardDriverProfileWhereInput>;
};


export type QueryYardMaterialExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardMaterialOrder>>;
  where?: InputMaybe<YardMaterialWhereInput>;
};


export type QueryYardMaterialQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardMaterialOrder>>;
  where?: InputMaybe<YardMaterialWhereInput>;
};


export type QueryYardMaterialTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardMaterialTypeOrder>>;
  where?: InputMaybe<YardMaterialTypeWhereInput>;
};


export type QueryYardMaterialTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardMaterialTypeOrder>>;
  where?: InputMaybe<YardMaterialTypeWhereInput>;
};


export type QueryYardTripApprovalExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripApprovalOrder>>;
  where?: InputMaybe<YardTripApprovalWhereInput>;
};


export type QueryYardTripApprovalQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripApprovalOrder>>;
  where?: InputMaybe<YardTripApprovalWhereInput>;
};


export type QueryYardTripExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripOrder>>;
  where?: InputMaybe<YardTripWhereInput>;
};


export type QueryYardTripQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripOrder>>;
  where?: InputMaybe<YardTripWhereInput>;
};


export type QueryYardTripStatusExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripStatusOrder>>;
  where?: InputMaybe<YardTripStatusWhereInput>;
};


export type QueryYardTripStatusQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripStatusOrder>>;
  where?: InputMaybe<YardTripStatusWhereInput>;
};


export type QueryYardVehicleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardVehicleOrder>>;
  where?: InputMaybe<YardVehicleWhereInput>;
};


export type QueryYardVehicleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardVehicleOrder>>;
  where?: InputMaybe<YardVehicleWhereInput>;
};


export type QueryYardVendorExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardVendorOrder>>;
  where?: InputMaybe<YardVendorWhereInput>;
};


export type QueryYardVendorQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardVendorOrder>>;
  where?: InputMaybe<YardVendorWhereInput>;
};


export type QueryYardWarehouseActivityTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseActivityTypeOrder>>;
  where?: InputMaybe<YardWarehouseActivityTypeWhereInput>;
};


export type QueryYardWarehouseActivityTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseActivityTypeOrder>>;
  where?: InputMaybe<YardWarehouseActivityTypeWhereInput>;
};


export type QueryYardWarehouseApprovalMatrixExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseApprovalMatrixOrder>>;
  where?: InputMaybe<YardWarehouseApprovalMatrixWhereInput>;
};


export type QueryYardWarehouseApprovalMatrixQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseApprovalMatrixOrder>>;
  where?: InputMaybe<YardWarehouseApprovalMatrixWhereInput>;
};


export type QueryYardWarehouseDockExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockOrder>>;
  where?: InputMaybe<YardWarehouseDockWhereInput>;
};


export type QueryYardWarehouseDockQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockOrder>>;
  where?: InputMaybe<YardWarehouseDockWhereInput>;
};


export type QueryYardWarehouseExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseOrder>>;
  where?: InputMaybe<YardWarehouseWhereInput>;
};


export type QueryYardWarehouseParkingExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseParkingOrder>>;
  where?: InputMaybe<YardWarehouseParkingWhereInput>;
};


export type QueryYardWarehouseParkingQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseParkingOrder>>;
  where?: InputMaybe<YardWarehouseParkingWhereInput>;
};


export type QueryYardWarehouseQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseOrder>>;
  where?: InputMaybe<YardWarehouseWhereInput>;
};


export type QueryYardWarehouseRouteExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRouteOrder>>;
  where?: InputMaybe<YardWarehouseRouteWhereInput>;
};


export type QueryYardWarehouseRoutePathExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRoutePathOrder>>;
  where?: InputMaybe<YardWarehouseRoutePathWhereInput>;
};


export type QueryYardWarehouseRoutePathQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRoutePathOrder>>;
  where?: InputMaybe<YardWarehouseRoutePathWhereInput>;
};


export type QueryYardWarehouseRouteQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRouteOrder>>;
  where?: InputMaybe<YardWarehouseRouteWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type ReportEmailInput = {
  derivedReportIds: Array<Scalars['ID']['input']>;
  emailIds: Array<Scalars['String']['input']>;
  emailSubject: Scalars['String']['input'];
};

export type ReportEventResponse = {
  __typename?: 'ReportEventResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportEventRow>>>;
};

export type ReportEventRow = {
  __typename?: 'ReportEventRow';
  deviceId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  geofenceName?: Maybe<Scalars['String']['output']>;
  gpsFixTimestamp: Scalars['Time']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  serverTimestamp: Scalars['Time']['output'];
};

export type ReportPositionResponse = {
  __typename?: 'ReportPositionResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportPositionRow>>>;
};

export type ReportPositionRow = {
  __typename?: 'ReportPositionRow';
  deviceId: Scalars['ID']['output'];
  deviceTimestamp: Scalars['Time']['output'];
  distance: Scalars['Float']['output'];
  gpsFixTimestamp: Scalars['Time']['output'];
  ignition: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  motion: Scalars['Boolean']['output'];
  serverTimestamp: Scalars['Time']['output'];
  speed: Scalars['Float']['output'];
  temperature: Scalars['Float']['output'];
};

export type ReportQueryInput = {
  deviceIds: Array<Scalars['ID']['input']>;
  fetchByDeviceTime: Scalars['Boolean']['input'];
  fromTimestamp: Scalars['Time']['input'];
  positionFilterBySeconds: Scalars['Int']['input'];
  positionFilterSpeedGreaterThan: Scalars['Float']['input'];
  positionFilterSpeedLesserThan: Scalars['Float']['input'];
  positionIgnoreFilterOutline: Scalars['Boolean']['input'];
  splitIntoDailyIntervals: Scalars['Boolean']['input'];
  toTimestamp: Scalars['Time']['input'];
  withAddress: Scalars['Boolean']['input'];
};

export type ReportReportStopIdleResponse = {
  __typename?: 'ReportReportStopIdleResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportReportStopIdleRow>>>;
};

export type ReportReportStopIdleRow = {
  __typename?: 'ReportReportStopIdleRow';
  deviceId: Scalars['ID']['output'];
  endTimestamp: Scalars['Time']['output'];
  engineDuration: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
  stopIdleDuration: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ReportSummaryResponse = {
  __typename?: 'ReportSummaryResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportSummaryRow>>>;
};

export type ReportSummaryRow = {
  __typename?: 'ReportSummaryRow';
  averageSpeed: Scalars['Float']['output'];
  deviceId: Scalars['ID']['output'];
  distance: Scalars['Float']['output'];
  endLatitude: Scalars['Float']['output'];
  endLongitude: Scalars['Float']['output'];
  endTimestamp: Scalars['Time']['output'];
  engineDuration: Scalars['Int']['output'];
  geofenceInCount: Scalars['Int']['output'];
  geofenceOutCount: Scalars['Int']['output'];
  idleDuration: Scalars['Int']['output'];
  ignitionOffCount: Scalars['Int']['output'];
  ignitionOnCount: Scalars['Int']['output'];
  maxSpeed: Scalars['Float']['output'];
  maxSpeedTimestamp: Scalars['Time']['output'];
  startLatitude: Scalars['Float']['output'];
  startLongitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
};

export type ReportTripResponse = {
  __typename?: 'ReportTripResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportTripRow>>>;
};

export type ReportTripRow = {
  __typename?: 'ReportTripRow';
  averageSpeed: Scalars['Float']['output'];
  deviceId: Scalars['ID']['output'];
  distance: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
  endLatitude: Scalars['Float']['output'];
  endLongitude: Scalars['Float']['output'];
  endTimestamp: Scalars['Time']['output'];
  maxSpeed: Scalars['Float']['output'];
  maxSpeedTimestamp: Scalars['Time']['output'];
  startLatitude: Scalars['Float']['output'];
  startLongitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
};

export type Setting = Node & {
  __typename?: 'Setting';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SettingConnection = {
  __typename?: 'SettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SettingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SettingEdge = {
  __typename?: 'SettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Setting>;
};

export enum SettingField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

/** Ordering options for Setting connections */
export type SettingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Settings. */
  field: SettingOrderField;
};

/** Properties by which Setting connections can be ordered. */
export enum SettingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * SettingWhereInput is used for filtering Setting objects.
 * Input was generated by ent.
 */
export type SettingWhereInput = {
  and?: InputMaybe<Array<SettingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SettingWhereInput>;
  or?: InputMaybe<Array<SettingWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Sim = Node & {
  __typename?: 'Sim';
  activationDate?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  devices?: Maybe<Device>;
  id: Scalars['ID']['output'];
  imsi: Scalars['String']['output'];
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  purchaseDate?: Maybe<Scalars['Time']['output']>;
  simNumber: Scalars['String']['output'];
  simOperator: SimSimOperator;
  status: SimStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SimConnection = {
  __typename?: 'SimConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SimEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SimEdge = {
  __typename?: 'SimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Sim>;
};

export enum SimField {
  ActivationDate = 'activationDate',
  CreatedAt = 'createdAt',
  Imsi = 'imsi',
  OrganisationId = 'organisationID',
  PurchaseDate = 'purchaseDate',
  SimNumber = 'simNumber',
  SimOperator = 'simOperator',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Sim connections */
export type SimOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Sims. */
  field: SimOrderField;
};

/** Properties by which Sim connections can be ordered. */
export enum SimOrderField {
  ActivationDate = 'ACTIVATION_DATE',
  Imsi = 'IMSI',
  PurchaseDate = 'PURCHASE_DATE',
  SimNumber = 'SIM_NUMBER',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** SimSimOperator is enum for the field sim_operator */
export enum SimSimOperator {
  Airtel = 'Airtel',
  Bsnl = 'BSNL',
  Jio = 'Jio',
  Other = 'Other',
  Vodafone = 'Vodafone'
}

/** SimStatus is enum for the field status */
export enum SimStatus {
  Active = 'Active',
  Available = 'Available',
  Deactivated = 'Deactivated',
  Disposed = 'Disposed'
}

/**
 * SimWhereInput is used for filtering Sim objects.
 * Input was generated by ent.
 */
export type SimWhereInput = {
  /** activation_date field predicates */
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  activationDateGT?: InputMaybe<Scalars['Time']['input']>;
  activationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  activationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activationDateLT?: InputMaybe<Scalars['Time']['input']>;
  activationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  activationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  activationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<SimWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imsi field predicates */
  imsi?: InputMaybe<Scalars['String']['input']>;
  imsiContains?: InputMaybe<Scalars['String']['input']>;
  imsiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imsiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imsiGT?: InputMaybe<Scalars['String']['input']>;
  imsiGTE?: InputMaybe<Scalars['String']['input']>;
  imsiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imsiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imsiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imsiLT?: InputMaybe<Scalars['String']['input']>;
  imsiLTE?: InputMaybe<Scalars['String']['input']>;
  imsiNEQ?: InputMaybe<Scalars['String']['input']>;
  imsiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SimWhereInput>;
  or?: InputMaybe<Array<SimWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purchase_date field predicates */
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateGT?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateGTE?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  purchaseDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseDateLT?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateLTE?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  purchaseDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sim_number field predicates */
  simNumber?: InputMaybe<Scalars['String']['input']>;
  simNumberContains?: InputMaybe<Scalars['String']['input']>;
  simNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  simNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  simNumberGT?: InputMaybe<Scalars['String']['input']>;
  simNumberGTE?: InputMaybe<Scalars['String']['input']>;
  simNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  simNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  simNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  simNumberLT?: InputMaybe<Scalars['String']['input']>;
  simNumberLTE?: InputMaybe<Scalars['String']['input']>;
  simNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  simNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sim_operator field predicates */
  simOperator?: InputMaybe<SimSimOperator>;
  simOperatorIn?: InputMaybe<Array<SimSimOperator>>;
  simOperatorNEQ?: InputMaybe<SimSimOperator>;
  simOperatorNotIn?: InputMaybe<Array<SimSimOperator>>;
  /** status field predicates */
  status?: InputMaybe<SimStatus>;
  statusIn?: InputMaybe<Array<SimStatus>>;
  statusNEQ?: InputMaybe<SimStatus>;
  statusNotIn?: InputMaybe<Array<SimStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type StaffRole = Node & {
  __typename?: 'StaffRole';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Time']['output'];
  users?: Maybe<Array<User>>;
};

/** A connection to a list of items. */
export type StaffRoleConnection = {
  __typename?: 'StaffRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StaffRoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StaffRoleEdge = {
  __typename?: 'StaffRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StaffRole>;
};

export enum StaffRoleField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  Permissions = 'permissions',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for StaffRole connections */
export type StaffRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order StaffRoles. */
  field: StaffRoleOrderField;
};

/** Properties by which StaffRole connections can be ordered. */
export enum StaffRoleOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * StaffRoleWhereInput is used for filtering StaffRole objects.
 * Input was generated by ent.
 */
export type StaffRoleWhereInput = {
  and?: InputMaybe<Array<StaffRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<StaffRoleWhereInput>;
  or?: InputMaybe<Array<StaffRoleWhereInput>>;
  /** permissions field predicates */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  permissionsLT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsLTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SubscriptionLicenseOrder = Node & {
  __typename?: 'SubscriptionLicenseOrder';
  baseLicensePlanID: Scalars['ID']['output'];
  baselicenseplan: BaseLicensePlan;
  createdAt: Scalars['Time']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  licenseorderaddons?: Maybe<Array<LicenseOrderAddon>>;
  licenses?: Maybe<Array<License>>;
  notes?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  perUnitPrice: Scalars['Float']['output'];
  status: SubscriptionLicenseOrderStatus;
  tenure: Scalars['Int']['output'];
  tenureUnit: SubscriptionLicenseOrderTenureUnit;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SubscriptionLicenseOrderConnection = {
  __typename?: 'SubscriptionLicenseOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionLicenseOrderEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionLicenseOrderEdge = {
  __typename?: 'SubscriptionLicenseOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubscriptionLicenseOrder>;
};

export enum SubscriptionLicenseOrderField {
  BaseLicensePlanId = 'baseLicensePlanID',
  CreatedAt = 'createdAt',
  GracePeriodDays = 'gracePeriodDays',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  PerUnitPrice = 'perUnitPrice',
  Status = 'status',
  Tenure = 'tenure',
  TenureUnit = 'tenureUnit',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for SubscriptionLicenseOrder connections */
export type SubscriptionLicenseOrderOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SubscriptionLicenseOrders. */
  field: SubscriptionLicenseOrderOrderField;
};

/** Properties by which SubscriptionLicenseOrder connections can be ordered. */
export enum SubscriptionLicenseOrderOrderField {
  Notes = 'NOTES',
  PerUnitPrice = 'PER_UNIT_PRICE',
  Status = 'STATUS',
  Tenure = 'TENURE',
  TenureUnit = 'TENURE_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** SubscriptionLicenseOrderStatus is enum for the field status */
export enum SubscriptionLicenseOrderStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Pending = 'Pending'
}

/** SubscriptionLicenseOrderTenureUnit is enum for the field tenure_unit */
export enum SubscriptionLicenseOrderTenureUnit {
  Month = 'Month',
  Year = 'Year'
}

/**
 * SubscriptionLicenseOrderWhereInput is used for filtering SubscriptionLicenseOrder objects.
 * Input was generated by ent.
 */
export type SubscriptionLicenseOrderWhereInput = {
  and?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** base_license_plan_id field predicates */
  baseLicensePlanID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** grace_period_days field predicates */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  gracePeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** licenseorderaddons edge predicates */
  hasLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderaddonsWith?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** licenses edge predicates */
  hasLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicensesWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** per_unit_price field predicates */
  perUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceGT?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceGTE?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  perUnitPriceLT?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceLTE?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceNEQ?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** status field predicates */
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  statusIn?: InputMaybe<Array<SubscriptionLicenseOrderStatus>>;
  statusNEQ?: InputMaybe<SubscriptionLicenseOrderStatus>;
  statusNotIn?: InputMaybe<Array<SubscriptionLicenseOrderStatus>>;
  /** tenure field predicates */
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureGT?: InputMaybe<Scalars['Int']['input']>;
  tenureGTE?: InputMaybe<Scalars['Int']['input']>;
  tenureIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenureLT?: InputMaybe<Scalars['Int']['input']>;
  tenureLTE?: InputMaybe<Scalars['Int']['input']>;
  tenureNEQ?: InputMaybe<Scalars['Int']['input']>;
  tenureNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** tenure_unit field predicates */
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  tenureUnitIn?: InputMaybe<Array<SubscriptionLicenseOrderTenureUnit>>;
  tenureUnitNEQ?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  tenureUnitNotIn?: InputMaybe<Array<SubscriptionLicenseOrderTenureUnit>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SupportDocument = Node & {
  __typename?: 'SupportDocument';
  createdAt: Scalars['Time']['output'];
  data: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nchunk: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SupportDocumentConnection = {
  __typename?: 'SupportDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupportDocumentEdge = {
  __typename?: 'SupportDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportDocument>;
};

export enum SupportDocumentField {
  CreatedAt = 'createdAt',
  Data = 'data',
  Embedding = 'embedding',
  Filename = 'filename',
  Metadata = 'metadata',
  Nchunk = 'nchunk',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for SupportDocument connections */
export type SupportDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SupportDocuments. */
  field: SupportDocumentOrderField;
};

/** Properties by which SupportDocument connections can be ordered. */
export enum SupportDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * SupportDocumentWhereInput is used for filtering SupportDocument objects.
 * Input was generated by ent.
 */
export type SupportDocumentWhereInput = {
  and?: InputMaybe<Array<SupportDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** data field predicates */
  data?: InputMaybe<Scalars['String']['input']>;
  dataContains?: InputMaybe<Scalars['String']['input']>;
  dataContainsFold?: InputMaybe<Scalars['String']['input']>;
  dataEqualFold?: InputMaybe<Scalars['String']['input']>;
  dataGT?: InputMaybe<Scalars['String']['input']>;
  dataGTE?: InputMaybe<Scalars['String']['input']>;
  dataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dataLT?: InputMaybe<Scalars['String']['input']>;
  dataLTE?: InputMaybe<Scalars['String']['input']>;
  dataNEQ?: InputMaybe<Scalars['String']['input']>;
  dataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filename field predicates */
  filename?: InputMaybe<Scalars['String']['input']>;
  filenameContains?: InputMaybe<Scalars['String']['input']>;
  filenameContainsFold?: InputMaybe<Scalars['String']['input']>;
  filenameEqualFold?: InputMaybe<Scalars['String']['input']>;
  filenameGT?: InputMaybe<Scalars['String']['input']>;
  filenameGTE?: InputMaybe<Scalars['String']['input']>;
  filenameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  filenameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  filenameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filenameLT?: InputMaybe<Scalars['String']['input']>;
  filenameLTE?: InputMaybe<Scalars['String']['input']>;
  filenameNEQ?: InputMaybe<Scalars['String']['input']>;
  filenameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** metadata field predicates */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  metadataGT?: InputMaybe<Scalars['JSON']['input']>;
  metadataGTE?: InputMaybe<Scalars['JSON']['input']>;
  metadataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  metadataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  metadataLT?: InputMaybe<Scalars['JSON']['input']>;
  metadataLTE?: InputMaybe<Scalars['JSON']['input']>;
  metadataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  metadataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  metadataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** nchunk field predicates */
  nchunk?: InputMaybe<Scalars['Int']['input']>;
  nchunkGT?: InputMaybe<Scalars['Int']['input']>;
  nchunkGTE?: InputMaybe<Scalars['Int']['input']>;
  nchunkIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  nchunkLT?: InputMaybe<Scalars['Int']['input']>;
  nchunkLTE?: InputMaybe<Scalars['Int']['input']>;
  nchunkNEQ?: InputMaybe<Scalars['Int']['input']>;
  nchunkNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  not?: InputMaybe<SupportDocumentWhereInput>;
  or?: InputMaybe<Array<SupportDocumentWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TaskState = {
  __typename?: 'TaskState';
  created_at?: Maybe<Scalars['Time']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  task_id: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
};

/**
 * UpdateAPIUserInput is used for update APIUser object.
 * Input was generated by ent.
 */
export type UpdateApiUserInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateBaseAddonInput is used for update BaseAddon object.
 * Input was generated by ent.
 */
export type UpdateBaseAddonInput = {
  addBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseLicensePlanAddonInput is used for update BaseLicensePlanAddon object.
 * Input was generated by ent.
 */
export type UpdateBaseLicensePlanAddonInput = {
  addLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseaddonID?: InputMaybe<Scalars['ID']['input']>;
  baselicenseplanID?: InputMaybe<Scalars['ID']['input']>;
  clearLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  removeLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseLicensePlanInput is used for update BaseLicensePlan object.
 * Input was generated by ent.
 */
export type UpdateBaseLicensePlanInput = {
  addBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  module?: InputMaybe<BaseLicensePlanModule>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  removeBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseReportInput is used for update BaseReport object.
 * Input was generated by ent.
 */
export type UpdateBaseReportInput = {
  addDerivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  clearDerivedReports?: InputMaybe<Scalars['Boolean']['input']>;
  currentDateReport?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inputConfig?: InputMaybe<Scalars['JSON']['input']>;
  mapConfig?: InputMaybe<Scalars['JSON']['input']>;
  multiDateMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDevice?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  removeDerivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  resolver?: InputMaybe<Scalars['String']['input']>;
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateChangeLogInput is used for update ChangeLog object.
 * Input was generated by ent.
 */
export type UpdateChangeLogInput = {
  action?: InputMaybe<ChangeLogAction>;
  clearImpersonatedUserID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreviousData?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemoteIP?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpdatedData?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateConsumerConfigInput is used for update ConsumerConfig object.
 * Input was generated by ent.
 */
export type UpdateConsumerConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextAttemptAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateConsumerServerInput is used for update ConsumerServer object.
 * Input was generated by ent.
 */
export type UpdateConsumerServerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedImei?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  appendAllowedImei?: InputMaybe<Array<Scalars['String']['input']>>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateDerivedReportInput is used for update DerivedReport object.
 * Input was generated by ent.
 */
export type UpdateDerivedReportInput = {
  addOrganisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseReportID?: InputMaybe<Scalars['ID']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationReportAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserReportBookmarks?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeOrganisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceACLInput is used for update DeviceACL object.
 * Input was generated by ent.
 */
export type UpdateDeviceAclInput = {
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  devicegroupsID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceActionLogInput is used for update DeviceActionLog object.
 * Input was generated by ent.
 */
export type UpdateDeviceActionLogInput = {
  actionDescription?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<DeviceActionLogActionType>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DeviceActionLogStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceAddonModelInput is used for update DeviceAddonModel object.
 * Input was generated by ent.
 */
export type UpdateDeviceAddonModelInput = {
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonType?: InputMaybe<DeviceAddonModelAddonType>;
  channelType?: InputMaybe<DeviceAddonModelChannelType>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceAdvancedConfigInput is used for update DeviceAdvancedConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceAdvancedConfigInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDeviceCategoryInput is used for update DeviceCategory object.
 * Input was generated by ent.
 */
export type UpdateDeviceCategoryInput = {
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<DeviceCategoryType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceChannelConfigInput is used for update DeviceChannelConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceChannelConfigInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceaddonmodelID?: InputMaybe<Scalars['ID']['input']>;
  devicemodelchannelID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceCommandInput is used for update DeviceCommand object.
 * Input was generated by ent.
 */
export type UpdateDeviceCommandInput = {
  addDeviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  command?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceDocumentInput is used for update DeviceDocument object.
 * Input was generated by ent.
 */
export type UpdateDeviceDocumentInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  deviceDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceDocumentTypeInput is used for update DeviceDocumentType object.
 * Input was generated by ent.
 */
export type UpdateDeviceDocumentTypeInput = {
  addDeviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupDocumentInput is used for update DeviceGroupDocument object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupDocumentInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupDocumentTypeInput is used for update DeviceGroupDocumentType object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupDocumentTypeInput = {
  addDeviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  applicableGroupType?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  clearDeviceGroupDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupInput is used for update DeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupInput = {
  addDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDriverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDevice?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceParkingModeConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerContactNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerFullName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerInstallationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceVehicleID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupRootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<DeviceGroupGroupType>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  removeDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDriverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceInput is used for update Device object.
 * Input was generated by ent.
 */
export type UpdateDeviceInput = {
  addDeviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceActionLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceadvancedconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastPing?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicense?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  devicecategoryID?: InputMaybe<Scalars['ID']['input']>;
  devicemodelID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  ingestServer?: InputMaybe<DeviceIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  licenseID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  simID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceModelChannelInput is used for update DeviceModelChannel object.
 * Input was generated by ent.
 */
export type UpdateDeviceModelChannelInput = {
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<DeviceModelChannelChannelType>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelID?: InputMaybe<Scalars['ID']['input']>;
  isBuiltin?: InputMaybe<Scalars['Boolean']['input']>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceModelInput is used for update DeviceModel object.
 * Input was generated by ent.
 */
export type UpdateDeviceModelInput = {
  addCommandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCommands?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicemodelchannels?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediaFiles?: InputMaybe<Scalars['Boolean']['input']>;
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeCommandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceParkingModeConfigInput is used for update DeviceParkingModeConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceParkingModeConfigInput = {
  appendParkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  clearParkingScheduleDays?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingScheduleEndUtc?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingScheduleStartUtc?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceSharingInput is used for update DeviceSharing object.
 * Input was generated by ent.
 */
export type UpdateDeviceSharingInput = {
  addDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearExpiresOn?: InputMaybe<Scalars['Boolean']['input']>;
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  shareType?: InputMaybe<DeviceSharingShareType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceVehicleInput is used for update DeviceVehicle object.
 * Input was generated by ent.
 */
export type UpdateDeviceVehicleInput = {
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  clearChassisNo?: InputMaybe<Scalars['Boolean']['input']>;
  clearCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearDealer?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceCompany?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsurancePremium?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearOem?: InputMaybe<Scalars['Boolean']['input']>;
  clearRegisteredRto?: InputMaybe<Scalars['Boolean']['input']>;
  clearState?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dealer?: InputMaybe<Scalars['String']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  oem?: InputMaybe<Scalars['String']['input']>;
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<DeviceVehicleVehicleType>;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDomainInput is used for update Domain object.
 * Input was generated by ent.
 */
export type UpdateDomainInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  clearAlias?: InputMaybe<Scalars['Boolean']['input']>;
  clearVerificationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearVerificationLastChecked?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateExportInput is used for update Export object.
 * Input was generated by ent.
 */
export type UpdateExportInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusMsg?: InputMaybe<Scalars['Boolean']['input']>;
  exportData?: InputMaybe<Scalars['String']['input']>;
  exportKey?: InputMaybe<Scalars['String']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ExportStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateFirebasePrivateKeyInput is used for update FirebasePrivateKey object.
 * Input was generated by ent.
 */
export type UpdateFirebasePrivateKeyInput = {
  authProviderX509CertURL?: InputMaybe<Scalars['String']['input']>;
  authURI?: InputMaybe<Scalars['String']['input']>;
  clearSenderID?: InputMaybe<Scalars['Boolean']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURL?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyID?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['String']['input']>;
  senderID?: InputMaybe<Scalars['String']['input']>;
  tokenURI?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  universeDomain?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateGeofenceDeviceGroupInput is used for update GeofenceDeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateGeofenceDeviceGroupInput = {
  clearLastUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateGeofenceInput is used for update Geofence object.
 * Input was generated by ent.
 */
export type UpdateGeofenceInput = {
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearGeoJSON?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateKmlInput is used for update Kml object.
 * Input was generated by ent.
 */
export type UpdateKmlInput = {
  fileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLegacySyncInput is used for update LegacySync object.
 * Input was generated by ent.
 */
export type UpdateLegacySyncInput = {
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusMsg?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LegacySyncStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  syncData?: InputMaybe<Scalars['String']['input']>;
  syncKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLicenseInput is used for update License object.
 * Input was generated by ent.
 */
export type UpdateLicenseInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevice?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  moduleType?: InputMaybe<LicenseModuleType>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<LicenseStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLicenseOrderAddonInput is used for update LicenseOrderAddon object.
 * Input was generated by ent.
 */
export type UpdateLicenseOrderAddonInput = {
  baselicenseaddonID?: InputMaybe<Scalars['ID']['input']>;
  licenseorderID?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLoginLogInput is used for update LoginLog object.
 * Input was generated by ent.
 */
export type UpdateLoginLogInput = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateMapConfigInput is used for update MapConfig object.
 * Input was generated by ent.
 */
export type UpdateMapConfigInput = {
  key?: InputMaybe<MapConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateMediaFileInput is used for update MediaFile object.
 * Input was generated by ent.
 */
export type UpdateMediaFileInput = {
  addDeviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroupDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceModelsMedias?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearFileName?: InputMaybe<Scalars['Boolean']['input']>;
  clearKmls?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverDetailsAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverDetailsDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicleRcImage?: InputMaybe<Scalars['Boolean']['input']>;
  exportID?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  removeDeviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<MediaFileStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateNotifyChannelInput is used for update NotifyChannel object.
 * Input was generated by ent.
 */
export type UpdateNotifyChannelInput = {
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<NotifyChannelKind>;
  linkedData?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigChannelInput is used for update NotifyConfigChannel object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigChannelInput = {
  notifyChannelID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigDeviceGroupInput is used for update NotifyConfigDeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigDeviceGroupInput = {
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigEventInput is used for update NotifyConfigEvent object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigEventInput = {
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  notifyEventOptionID?: InputMaybe<Scalars['ID']['input']>;
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * UpdateNotifyConfigGeofenceInput is used for update NotifyConfigGeofence object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigGeofenceInput = {
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigInput is used for update NotifyConfig object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigInput = {
  addChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  alertWindow?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  autoAddNewDevices?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlertWindowEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlertWindowStart?: InputMaybe<Scalars['Boolean']['input']>;
  clearChannels?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearEvents?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDuplicateForSeconds?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<NotifyConfigPriority>;
  removeChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyEventOptionInput is used for update NotifyEventOption object.
 * Input was generated by ent.
 */
export type UpdateNotifyEventOptionInput = {
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMaxLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMinLabel?: InputMaybe<Scalars['String']['input']>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceToleranceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** Source of event for backend processing */
  kind?: InputMaybe<NotifyEventOptionKind>;
  /** label to display in UI */
  label?: InputMaybe<Scalars['String']['input']>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  speedToleranceKnotsLabel?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  timeToleranceSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  waitTimeSecondsLabel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateOrganisationInput is used for update Organisation object.
 * Input was generated by ent.
 */
export type UpdateOrganisationInput = {
  addBaselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addChildOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLegacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSimIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSubOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  clearBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressCity?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressLine1?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressLine2?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressState?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingGstin?: InputMaybe<Scalars['Boolean']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearChildOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroupsRoot?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicesRoot?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearKmls?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegacysync?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicense?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  clearMapGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganistionroles?: InputMaybe<Scalars['Boolean']['input']>;
  clearParentOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearSim?: InputMaybe<Scalars['Boolean']['input']>;
  clearSubOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  clearWallet?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVendors?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouses?: InputMaybe<Scalars['Boolean']['input']>;
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  removeBaselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeChildOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLegacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSimIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSubOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateOrganisationReportAccessInput is used for update OrganisationReportAccess object.
 * Input was generated by ent.
 */
export type UpdateOrganisationReportAccessInput = {
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationRoleInput is used for update OrganisationRole object.
 * Input was generated by ent.
 */
export type UpdateOrganisationRoleInput = {
  addOrganisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearOrganisationRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  removeOrganisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationRolePermissionInput is used for update OrganisationRolePermission object.
 * Input was generated by ent.
 */
export type UpdateOrganisationRolePermissionInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  organisationRoleID?: InputMaybe<Scalars['ID']['input']>;
  permissionID?: InputMaybe<Scalars['ID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationUpgradeInput is used for update OrganisationUpgrade object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUpgradeInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<OrganisationUpgradeStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateOrganisationUserDocumentInput is used for update OrganisationUserDocument object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserDocumentInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateOrganisationUserDocumentTypeInput is used for update OrganisationUserDocumentType object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserDocumentTypeInput = {
  addOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationUserInput is used for update OrganisationUser object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserInput = {
  addDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  driverprofilesID?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  userType?: InputMaybe<OrganisationUserUserType>;
};

/**
 * UpdatePeriodicJobInput is used for update PeriodicJob object.
 * Input was generated by ent.
 */
export type UpdatePeriodicJobInput = {
  clearLastRunAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastTaskResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextRunAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearParams?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  queueName?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePermissionInput is used for update Permission object.
 * Input was generated by ent.
 */
export type UpdatePermissionInput = {
  createLabel?: InputMaybe<Scalars['String']['input']>;
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editLabel?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<PermissionGroup>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<PermissionName>;
  readLabel?: InputMaybe<Scalars['String']['input']>;
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  sorter?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePinnedDevicesInput is used for update PinnedDevices object.
 * Input was generated by ent.
 */
export type UpdatePinnedDevicesInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePoiInput is used for update Poi object.
 * Input was generated by ent.
 */
export type UpdatePoiInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateProfileInput is used for update Profile object.
 * Input was generated by ent.
 */
export type UpdateProfileInput = {
  addGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLocation?: InputMaybe<Scalars['String']['input']>;
  bloodGroup?: InputMaybe<Scalars['String']['input']>;
  clearGroups?: InputMaybe<Scalars['Boolean']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeNo?: InputMaybe<Scalars['String']['input']>;
  organisationusersID?: InputMaybe<Scalars['ID']['input']>;
  removeGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePusherConfigInput is used for update PusherConfig object.
 * Input was generated by ent.
 */
export type UpdatePusherConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adminID?: InputMaybe<Scalars['Int']['input']>;
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  appendDeviceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clearAPIExtra?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearAdminID?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextAttemptAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PusherConfigType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdatePusherLogInput is used for update PusherLog object.
 * Input was generated by ent.
 */
export type UpdatePusherLogInput = {
  clearDeviceID?: InputMaybe<Scalars['Boolean']['input']>;
  clearImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseData?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  clearSentData?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  sentData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateSettingInput is used for update Setting object.
 * Input was generated by ent.
 */
export type UpdateSettingInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateSimInput is used for update Sim object.
 * Input was generated by ent.
 */
export type UpdateSimInput = {
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  clearActivationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearPurchaseDate?: InputMaybe<Scalars['Boolean']['input']>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  imsi?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  simNumber?: InputMaybe<Scalars['String']['input']>;
  simOperator?: InputMaybe<SimSimOperator>;
  status?: InputMaybe<SimStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateStaffRoleInput is used for update StaffRole object.
 * Input was generated by ent.
 */
export type UpdateStaffRoleInput = {
  addUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  removeUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSubscriptionLicenseOrderInput is used for update SubscriptionLicenseOrder object.
 * Input was generated by ent.
 */
export type UpdateSubscriptionLicenseOrderInput = {
  addLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baselicenseplanID?: InputMaybe<Scalars['ID']['input']>;
  clearLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  perUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  removeLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSupportDocumentInput is used for update SupportDocument object.
 * Input was generated by ent.
 */
export type UpdateSupportDocumentInput = {
  clearMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nchunk?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUpgradeInput is used for update Upgrade object.
 * Input was generated by ent.
 */
export type UpdateUpgradeInput = {
  addOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  removeOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUpgradeOrganisationPriceInput is used for update UpgradeOrganisationPrice object.
 * Input was generated by ent.
 */
export type UpdateUpgradeOrganisationPriceInput = {
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateUserConfigInput is used for update UserConfig object.
 * Input was generated by ent.
 */
export type UpdateUserConfigInput = {
  key?: InputMaybe<UserConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateUserFcmTokenInput is used for update UserFcmToken object.
 * Input was generated by ent.
 */
export type UpdateUserFcmTokenInput = {
  clearFcmSenderID?: InputMaybe<Scalars['Boolean']['input']>;
  clearInvalidReason?: InputMaybe<Scalars['Boolean']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type UpdateUserInput = {
  addAPIUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPoiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Address of the user */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the user */
  city?: InputMaybe<Scalars['String']['input']>;
  clearAPIUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlternateMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearCity?: InputMaybe<Scalars['Boolean']['input']>;
  clearCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  clearGender?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastName?: InputMaybe<Scalars['Boolean']['input']>;
  clearMapConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearPoi?: InputMaybe<Scalars['Boolean']['input']>;
  clearPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoleID?: InputMaybe<Scalars['Boolean']['input']>;
  clearState?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatusIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatusOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsWarehouseIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsWarehouseOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** Country of the user */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  /** Mobile number of the user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  mobileNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Postal code of the user */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  removeAPIUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePoiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<UserRole>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  /** State of the user */
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUserReportBookmarkInput is used for update UserReportBookmark object.
 * Input was generated by ent.
 */
export type UpdateUserReportBookmarkInput = {
  clearLastGeneratedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWalletInput is used for update Wallet object.
 * Input was generated by ent.
 */
export type UpdateWalletInput = {
  addWalletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  clearWalletpaymenttransaction?: InputMaybe<Scalars['Boolean']['input']>;
  clearWallettransaction?: InputMaybe<Scalars['Boolean']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeWalletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateWalletPaymentTransactionInput is used for update WalletPaymentTransaction object.
 * Input was generated by ent.
 */
export type UpdateWalletPaymentTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clearProcessorPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  clearProcessorTransactionID?: InputMaybe<Scalars['Boolean']['input']>;
  clearProcessorTransactionStatus?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWalletTransactionInput is used for update WalletTransaction object.
 * Input was generated by ent.
 */
export type UpdateWalletTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsageID?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsageType?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<WalletTransactionTransactionType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageType?: InputMaybe<WalletTransactionUsageType>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhatsAppConfigInput is used for update WhatsAppConfig object.
 * Input was generated by ent.
 */
export type UpdateWhatsAppConfigInput = {
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPhoneNumberID?: InputMaybe<Scalars['Boolean']['input']>;
  clearToken?: InputMaybe<Scalars['Boolean']['input']>;
  companyID?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['Int']['input']>;
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateWhitelabelConfigInput is used for update WhitelabelConfig object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelConfigInput = {
  key?: InputMaybe<WhitelabelConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhitelabelCoreSettingOverrideInput is used for update WhitelabelCoreSettingOverride object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelCoreSettingOverrideInput = {
  key?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhitelabelInput is used for update Whitelabel object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelInput = {
  addDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendEnabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  clearDomains?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnabledLoginMethods?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelcoresettingoverrides?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileWhitelabelLoginLogoID?: InputMaybe<Scalars['ID']['input']>;
  mediafileWhitelabelLogoID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardDriverProfileInput is used for update YardDriverProfile object.
 * Input was generated by ent.
 */
export type UpdateYardDriverProfileInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDateOfBirth?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dlExpiry?: InputMaybe<Scalars['Time']['input']>;
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  mediafileAvatarID?: InputMaybe<Scalars['ID']['input']>;
  mediafileDlImageID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardMaterialInput is used for update YardMaterial object.
 * Input was generated by ent.
 */
export type UpdateYardMaterialInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardMaterialTypeInput is used for update YardMaterialType object.
 * Input was generated by ent.
 */
export type UpdateYardMaterialTypeInput = {
  addYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardTripApprovalInput is used for update YardTripApproval object.
 * Input was generated by ent.
 */
export type UpdateYardTripApprovalInput = {
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  clearReviewReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearReviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<YardTripApprovalStatus>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardTripInput is used for update YardTrip object.
 * Input was generated by ent.
 */
export type UpdateYardTripInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  clearAssignedDriverTracker?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTracker?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTrackerBatteryLevel?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckinTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeclaredMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriver?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearParking?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingInTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingOutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripStatusCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripStatusLast?: InputMaybe<Scalars['Boolean']['input']>;
  clearVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  clearVendor?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseInTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseOutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<YardTripPurpose>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusCurrentID?: InputMaybe<Scalars['ID']['input']>;
  tripStatusLastID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardTripStatusInput is used for update YardTripStatus object.
 * Input was generated by ent.
 */
export type UpdateYardTripStatusInput = {
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  addYardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  clearActivityStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearActivityType?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckinTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsLast?: InputMaybe<Scalars['Boolean']['input']>;
  dockID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  materialID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routePathID?: InputMaybe<Scalars['ID']['input']>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardVehicleInput is used for update YardVehicle object.
 * Input was generated by ent.
 */
export type UpdateYardVehicleInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearInsuranceExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehicleRc?: InputMaybe<Scalars['Boolean']['input']>;
  clearPollutionExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  mediafileVehicleInsuranceImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehiclePollutionImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehicleRcID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleRcExpiry?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateYardVendorInput is used for update YardVendor object.
 * Input was generated by ent.
 */
export type UpdateYardVendorInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateYardWarehouseActivityTypeInput is used for update YardWarehouseActivityType object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseActivityTypeInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseApprovalMatrixInput is used for update YardWarehouseApprovalMatrix object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseApprovalMatrixInput = {
  addPreApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  clearApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removePreApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseDockInput is used for update YardWarehouseDock object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseDockInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseInput is used for update YardWarehouse object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardWarehouseParkingInput is used for update YardWarehouseParking object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseParkingInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  slotName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseRouteInput is used for update YardWarehouseRoute object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseRouteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addPreferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreferredYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removePreferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeType?: InputMaybe<YardWarehouseRouteRouteType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseRoutePathInput is used for update YardWarehouseRoutePath object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseRoutePathInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  dockID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  maxWaitTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Upgrade = Node & {
  __typename?: 'Upgrade';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  integrationCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisationupgrade?: Maybe<Array<OrganisationUpgrade>>;
  percentPerUnit: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  upgradeorganisationprice?: Maybe<Array<UpgradeOrganisationPrice>>;
};

/** A connection to a list of items. */
export type UpgradeConnection = {
  __typename?: 'UpgradeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpgradeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UpgradeEdge = {
  __typename?: 'UpgradeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Upgrade>;
};

export enum UpgradeField {
  CreatedAt = 'createdAt',
  Description = 'description',
  IconId = 'iconID',
  IntegrationCode = 'integrationCode',
  IsActive = 'isActive',
  Name = 'name',
  PercentPerUnit = 'percentPerUnit',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Upgrade connections */
export type UpgradeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Upgrades. */
  field: UpgradeOrderField;
};

/** Properties by which Upgrade connections can be ordered. */
export enum UpgradeOrderField {
  Description = 'DESCRIPTION',
  IntegrationCode = 'INTEGRATION_CODE',
  Name = 'NAME',
  PercentPerUnit = 'PERCENT_PER_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type UpgradeOrganisationPrice = Node & {
  __typename?: 'UpgradeOrganisationPrice';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  percentPerUnit: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  upgrade: Upgrade;
  upgradeID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type UpgradeOrganisationPriceConnection = {
  __typename?: 'UpgradeOrganisationPriceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpgradeOrganisationPriceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UpgradeOrganisationPriceEdge = {
  __typename?: 'UpgradeOrganisationPriceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UpgradeOrganisationPrice>;
};

export enum UpgradeOrganisationPriceField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  PercentPerUnit = 'percentPerUnit',
  UpdatedAt = 'updatedAt',
  UpgradeId = 'upgradeID'
}

/** Ordering options for UpgradeOrganisationPrice connections */
export type UpgradeOrganisationPriceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UpgradeOrganisationPrices. */
  field: UpgradeOrganisationPriceOrderField;
};

/** Properties by which UpgradeOrganisationPrice connections can be ordered. */
export enum UpgradeOrganisationPriceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UpgradeOrganisationPriceWhereInput is used for filtering UpgradeOrganisationPrice objects.
 * Input was generated by ent.
 */
export type UpgradeOrganisationPriceWhereInput = {
  and?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
  or?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** percent_per_unit field predicates */
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  percentPerUnitLT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitLTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNEQ?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** upgrade_id field predicates */
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  upgradeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpgradeWhereInput is used for filtering Upgrade objects.
 * Input was generated by ent.
 */
export type UpgradeWhereInput = {
  and?: InputMaybe<Array<UpgradeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisationupgrade edge predicates */
  hasOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationupgradeWith?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** upgradeorganisationprice edge predicates */
  hasUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeorganisationpriceWith?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** icon_id field predicates */
  iconID?: InputMaybe<Scalars['ID']['input']>;
  iconIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  iconIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  iconIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  iconIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  iconIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_code field predicates */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContains?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCodeLT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeLTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UpgradeWhereInput>;
  or?: InputMaybe<Array<UpgradeWhereInput>>;
  /** percent_per_unit field predicates */
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  percentPerUnitLT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitLTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNEQ?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type User = Node & {
  __typename?: 'User';
  /** Address of the user */
  address?: Maybe<Scalars['String']['output']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: Maybe<Scalars['String']['output']>;
  apiUser?: Maybe<Array<ApiUser>>;
  avatarID?: Maybe<Scalars['ID']['output']>;
  /** City of the user */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the user */
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  dateJoined: Scalars['Time']['output'];
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  /** Email address of the user */
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  export?: Maybe<Array<Export>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['Time']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mapConfig?: Maybe<Array<MapConfig>>;
  mediafile?: Maybe<MediaFile>;
  mediafiles?: Maybe<Array<MediaFile>>;
  /** Mobile number of the user */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  mobileNumberConfirmed: Scalars['Boolean']['output'];
  organisationusers?: Maybe<Array<OrganisationUser>>;
  poi?: Maybe<Array<Poi>>;
  /** Postal code of the user */
  postalCode?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  roleID?: Maybe<Scalars['ID']['output']>;
  staffRoleID?: Maybe<Scalars['ID']['output']>;
  /** State of the user */
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userConfig?: Maybe<Array<UserConfig>>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatusIn?: Maybe<Array<YardTripStatus>>;
  yardTripStatusOut?: Maybe<Array<YardTripStatus>>;
  yardTripsIn?: Maybe<Array<YardTrip>>;
  yardTripsOut?: Maybe<Array<YardTrip>>;
  yardTripsWarehouseIn?: Maybe<Array<YardTrip>>;
  yardTripsWarehouseOut?: Maybe<Array<YardTrip>>;
};

export type UserConfig = Node & {
  __typename?: 'UserConfig';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: UserConfigKey;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type UserConfigConnection = {
  __typename?: 'UserConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserConfigEdge = {
  __typename?: 'UserConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserConfig>;
};

export enum UserConfigField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Value = 'value'
}

/** UserConfigKey is enum for the field key */
export enum UserConfigKey {
  DatetimeFormat = 'datetime_format',
  DistanceUnit = 'distance_unit',
  Language = 'language',
  TemperatureUnit = 'temperature_unit',
  Timezone = 'timezone'
}

/** Ordering options for UserConfig connections */
export type UserConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserConfigs. */
  field: UserConfigOrderField;
};

/** Properties by which UserConfig connections can be ordered. */
export enum UserConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserConfigWhereInput is used for filtering UserConfig objects.
 * Input was generated by ent.
 */
export type UserConfigWhereInput = {
  and?: InputMaybe<Array<UserConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<UserConfigKey>;
  keyIn?: InputMaybe<Array<UserConfigKey>>;
  keyNEQ?: InputMaybe<UserConfigKey>;
  keyNotIn?: InputMaybe<Array<UserConfigKey>>;
  not?: InputMaybe<UserConfigWhereInput>;
  or?: InputMaybe<Array<UserConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFcmToken = Node & {
  __typename?: 'UserFcmToken';
  createdAt: Scalars['Time']['output'];
  deviceType: Scalars['String']['output'];
  fcmSenderID?: Maybe<Scalars['String']['output']>;
  fcmToken: Scalars['String']['output'];
  fcmValid: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invalidReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type UserFcmTokenConnection = {
  __typename?: 'UserFcmTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserFcmTokenEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserFcmTokenEdge = {
  __typename?: 'UserFcmTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserFcmToken>;
};

export enum UserFcmTokenField {
  CreatedAt = 'createdAt',
  DeviceType = 'deviceType',
  FcmSenderId = 'fcmSenderID',
  FcmToken = 'fcmToken',
  FcmValid = 'fcmValid',
  InvalidReason = 'invalidReason',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for UserFcmToken connections */
export type UserFcmTokenOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserFcmTokens. */
  field: UserFcmTokenOrderField;
};

/** Properties by which UserFcmToken connections can be ordered. */
export enum UserFcmTokenOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserFcmTokenWhereInput is used for filtering UserFcmToken objects.
 * Input was generated by ent.
 */
export type UserFcmTokenWhereInput = {
  and?: InputMaybe<Array<UserFcmTokenWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_type field predicates */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContains?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypeLT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeLTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_sender_id field predicates */
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContains?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fcmSenderIDLT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDLTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fcm_token field predicates */
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContains?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmTokenLT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenLTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_valid field predicates */
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  fcmValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invalid_reason field predicates */
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  invalidReasonContains?: InputMaybe<Scalars['String']['input']>;
  invalidReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  invalidReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  invalidReasonGT?: InputMaybe<Scalars['String']['input']>;
  invalidReasonGTE?: InputMaybe<Scalars['String']['input']>;
  invalidReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  invalidReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  invalidReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  invalidReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReasonLT?: InputMaybe<Scalars['String']['input']>;
  invalidReasonLTE?: InputMaybe<Scalars['String']['input']>;
  invalidReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  invalidReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  invalidReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserFcmTokenWhereInput>;
  or?: InputMaybe<Array<UserFcmTokenWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum UserField {
  Address = 'address',
  AlternateMobileNumber = 'alternateMobileNumber',
  AvatarId = 'avatarID',
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  DateJoined = 'dateJoined',
  Email = 'email',
  EmailConfirmed = 'emailConfirmed',
  FirstName = 'firstName',
  Gender = 'gender',
  IsActive = 'isActive',
  LastLogin = 'lastLogin',
  LastName = 'lastName',
  MobileNumber = 'mobileNumber',
  MobileNumberConfirmed = 'mobileNumberConfirmed',
  Password = 'password',
  PostalCode = 'postalCode',
  Role = 'role',
  RoleId = 'roleID',
  StaffRoleId = 'staffRoleID',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

/** UserGender is enum for the field gender */
export enum UserGender {
  Female = 'Female',
  Male = 'Male',
  Others = 'Others'
}

/** Ordering options for User connections */
export type UserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: UserOrderField;
};

/** Properties by which User connections can be ordered. */
export enum UserOrderField {
  DateJoined = 'DATE_JOINED',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type UserReportBookmark = Node & {
  __typename?: 'UserReportBookmark';
  createdAt: Scalars['Time']['output'];
  derivedReport: DerivedReport;
  derivedReportID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isBookmarked: Scalars['Boolean']['output'];
  lastGeneratedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type UserReportBookmarkConnection = {
  __typename?: 'UserReportBookmarkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserReportBookmarkEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserReportBookmarkEdge = {
  __typename?: 'UserReportBookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserReportBookmark>;
};

export enum UserReportBookmarkField {
  CreatedAt = 'createdAt',
  DerivedReportId = 'derivedReportID',
  IsBookmarked = 'isBookmarked',
  LastGeneratedAt = 'lastGeneratedAt',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for UserReportBookmark connections */
export type UserReportBookmarkOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserReportBookmarks. */
  field: UserReportBookmarkOrderField;
};

/** Properties by which UserReportBookmark connections can be ordered. */
export enum UserReportBookmarkOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserReportBookmarkWhereInput is used for filtering UserReportBookmark objects.
 * Input was generated by ent.
 */
export type UserReportBookmarkWhereInput = {
  and?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** derived_report_id field predicates */
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  derivedReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** derived_report edge predicates */
  hasDerivedReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_bookmarked field predicates */
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  isBookmarkedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_generated_at field predicates */
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastGeneratedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastGeneratedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserReportBookmarkWhereInput>;
  or?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UserRole is enum for the field role */
export enum UserRole {
  Admin = 'Admin',
  Staff = 'Staff',
  Subscriber = 'Subscriber'
}

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  /** address field predicates */
  address?: InputMaybe<Scalars['String']['input']>;
  addressContains?: InputMaybe<Scalars['String']['input']>;
  addressContainsFold?: InputMaybe<Scalars['String']['input']>;
  addressEqualFold?: InputMaybe<Scalars['String']['input']>;
  addressGT?: InputMaybe<Scalars['String']['input']>;
  addressGTE?: InputMaybe<Scalars['String']['input']>;
  addressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  addressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  addressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addressLT?: InputMaybe<Scalars['String']['input']>;
  addressLTE?: InputMaybe<Scalars['String']['input']>;
  addressNEQ?: InputMaybe<Scalars['String']['input']>;
  addressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** alternate_mobile_number field predicates */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberContains?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberGT?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberGTE?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alternateMobileNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alternateMobileNumberLT?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberLTE?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alternateMobileNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<UserWhereInput>>;
  /** avatar_id field predicates */
  avatarID?: InputMaybe<Scalars['ID']['input']>;
  avatarIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  avatarIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  avatarIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** city field predicates */
  city?: InputMaybe<Scalars['String']['input']>;
  cityContains?: InputMaybe<Scalars['String']['input']>;
  cityContainsFold?: InputMaybe<Scalars['String']['input']>;
  cityEqualFold?: InputMaybe<Scalars['String']['input']>;
  cityGT?: InputMaybe<Scalars['String']['input']>;
  cityGTE?: InputMaybe<Scalars['String']['input']>;
  cityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cityLT?: InputMaybe<Scalars['String']['input']>;
  cityLTE?: InputMaybe<Scalars['String']['input']>;
  cityNEQ?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** date_joined field predicates */
  dateJoined?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedGT?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedGTE?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateJoinedLT?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedLTE?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  /** email_confirmed field predicates */
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  emailConfirmedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gender field predicates */
  gender?: InputMaybe<UserGender>;
  genderIn?: InputMaybe<Array<UserGender>>;
  genderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  genderNEQ?: InputMaybe<UserGender>;
  genderNotIn?: InputMaybe<Array<UserGender>>;
  genderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_user edge predicates */
  hasAPIUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIUserWith?: InputMaybe<Array<ApiUserWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** map_config edge predicates */
  hasMapConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasMapConfigWith?: InputMaybe<Array<MapConfigWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafiles edge predicates */
  hasMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** poi edge predicates */
  hasPoi?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoiWith?: InputMaybe<Array<PoiWhereInput>>;
  /** user_config edge predicates */
  hasUserConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserConfigWith?: InputMaybe<Array<UserConfigWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status_in edge predicates */
  hasYardTripStatusIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusInWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trip_status_out edge predicates */
  hasYardTripStatusOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusOutWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips_in edge predicates */
  hasYardTripsIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsInWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_out edge predicates */
  hasYardTripsOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsOutWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_warehouse_in edge predicates */
  hasYardTripsWarehouseIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWarehouseInWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_warehouse_out edge predicates */
  hasYardTripsWarehouseOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWarehouseOutWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mobile_number field predicates */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** mobile_number_confirmed field predicates */
  mobileNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberConfirmedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberContains?: InputMaybe<Scalars['String']['input']>;
  mobileNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  mobileNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  mobileNumberGT?: InputMaybe<Scalars['String']['input']>;
  mobileNumberGTE?: InputMaybe<Scalars['String']['input']>;
  mobileNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mobileNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mobileNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberLT?: InputMaybe<Scalars['String']['input']>;
  mobileNumberLTE?: InputMaybe<Scalars['String']['input']>;
  mobileNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  mobileNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** postal_code field predicates */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeContains?: InputMaybe<Scalars['String']['input']>;
  postalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeGT?: InputMaybe<Scalars['String']['input']>;
  postalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  postalCodeLT?: InputMaybe<Scalars['String']['input']>;
  postalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  postalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** role field predicates */
  role?: InputMaybe<UserRole>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDGT?: InputMaybe<Scalars['ID']['input']>;
  roleIDGTE?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  roleIDLT?: InputMaybe<Scalars['ID']['input']>;
  roleIDLTE?: InputMaybe<Scalars['ID']['input']>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  roleIn?: InputMaybe<Array<UserRole>>;
  roleNEQ?: InputMaybe<UserRole>;
  roleNotIn?: InputMaybe<Array<UserRole>>;
  /** staff_role_id field predicates */
  staffRoleID?: InputMaybe<Scalars['ID']['input']>;
  staffRoleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  staffRoleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  staffRoleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  staffRoleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  staffRoleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Wallet = Node & {
  __typename?: 'Wallet';
  autoLoadLimit: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  currentBalance: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  negativeLimit: Scalars['Float']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  walletpaymenttransaction?: Maybe<Array<WalletPaymentTransaction>>;
  wallettransaction?: Maybe<Array<WalletTransaction>>;
};

/** A connection to a list of items. */
export type WalletConnection = {
  __typename?: 'WalletConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletEdge = {
  __typename?: 'WalletEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Wallet>;
};

export enum WalletField {
  AutoLoadLimit = 'autoLoadLimit',
  CreatedAt = 'createdAt',
  CurrentBalance = 'currentBalance',
  NegativeLimit = 'negativeLimit',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Wallet connections */
export type WalletOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Wallets. */
  field: WalletOrderField;
};

/** Properties by which Wallet connections can be ordered. */
export enum WalletOrderField {
  AutoLoadLimit = 'AUTO_LOAD_LIMIT',
  CurrentBalance = 'CURRENT_BALANCE',
  NegativeLimit = 'NEGATIVE_LIMIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type WalletPaymentTransaction = Node & {
  __typename?: 'WalletPaymentTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paidAmount: Scalars['Float']['output'];
  paymentProcessor: WalletPaymentTransactionPaymentProcessor;
  processorPaymentMethod?: Maybe<Scalars['String']['output']>;
  processorTransactionID?: Maybe<Scalars['String']['output']>;
  processorTransactionStatus?: Maybe<Scalars['String']['output']>;
  status: WalletPaymentTransactionStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  transactionDate: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  wallet: Wallet;
  walletID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WalletPaymentTransactionConnection = {
  __typename?: 'WalletPaymentTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletPaymentTransactionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletPaymentTransactionEdge = {
  __typename?: 'WalletPaymentTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WalletPaymentTransaction>;
};

export enum WalletPaymentTransactionField {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  PaidAmount = 'paidAmount',
  PaymentProcessor = 'paymentProcessor',
  ProcessorPaymentMethod = 'processorPaymentMethod',
  ProcessorTransactionId = 'processorTransactionID',
  ProcessorTransactionStatus = 'processorTransactionStatus',
  Status = 'status',
  Subtotal = 'subtotal',
  Tax = 'tax',
  TransactionDate = 'transactionDate',
  UpdatedAt = 'updatedAt',
  WalletId = 'walletID'
}

/** Ordering options for WalletPaymentTransaction connections */
export type WalletPaymentTransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WalletPaymentTransactions. */
  field: WalletPaymentTransactionOrderField;
};

/** Properties by which WalletPaymentTransaction connections can be ordered. */
export enum WalletPaymentTransactionOrderField {
  Amount = 'AMOUNT',
  Currency = 'CURRENCY',
  PaidAmount = 'PAID_AMOUNT',
  PaymentProcessor = 'PAYMENT_PROCESSOR',
  Status = 'STATUS',
  Subtotal = 'SUBTOTAL',
  Tax = 'TAX',
  TransactionDate = 'TRANSACTION_DATE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** WalletPaymentTransactionPaymentProcessor is enum for the field payment_processor */
export enum WalletPaymentTransactionPaymentProcessor {
  Razorpay = 'Razorpay'
}

/** WalletPaymentTransactionStatus is enum for the field status */
export enum WalletPaymentTransactionStatus {
  Failed = 'Failed',
  Initiated = 'Initiated',
  Pending = 'Pending',
  Success = 'Success'
}

/**
 * WalletPaymentTransactionWhereInput is used for filtering WalletPaymentTransaction objects.
 * Input was generated by ent.
 */
export type WalletPaymentTransactionWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WalletPaymentTransactionWhereInput>;
  or?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** paid_amount field predicates */
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paidAmountGT?: InputMaybe<Scalars['Float']['input']>;
  paidAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  paidAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  paidAmountLT?: InputMaybe<Scalars['Float']['input']>;
  paidAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  paidAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  paidAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** payment_processor field predicates */
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  paymentProcessorIn?: InputMaybe<Array<WalletPaymentTransactionPaymentProcessor>>;
  paymentProcessorNEQ?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  paymentProcessorNotIn?: InputMaybe<Array<WalletPaymentTransactionPaymentProcessor>>;
  /** processor_payment_method field predicates */
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodContains?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodGT?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodGTE?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorPaymentMethodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorPaymentMethodLT?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodLTE?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodNEQ?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorPaymentMethodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processor_transaction_id field predicates */
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDContains?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDGT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDGTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorTransactionIDLT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDLTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processor_transaction_status field predicates */
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusContains?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusGT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusGTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorTransactionStatusLT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusLTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  statusIn?: InputMaybe<Array<WalletPaymentTransactionStatus>>;
  statusNEQ?: InputMaybe<WalletPaymentTransactionStatus>;
  statusNotIn?: InputMaybe<Array<WalletPaymentTransactionStatus>>;
  /** subtotal field predicates */
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  subtotalGT?: InputMaybe<Scalars['Float']['input']>;
  subtotalGTE?: InputMaybe<Scalars['Float']['input']>;
  subtotalIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  subtotalLT?: InputMaybe<Scalars['Float']['input']>;
  subtotalLTE?: InputMaybe<Scalars['Float']['input']>;
  subtotalNEQ?: InputMaybe<Scalars['Float']['input']>;
  subtotalNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** tax field predicates */
  tax?: InputMaybe<Scalars['Float']['input']>;
  taxGT?: InputMaybe<Scalars['Float']['input']>;
  taxGTE?: InputMaybe<Scalars['Float']['input']>;
  taxIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  taxLT?: InputMaybe<Scalars['Float']['input']>;
  taxLTE?: InputMaybe<Scalars['Float']['input']>;
  taxNEQ?: InputMaybe<Scalars['Float']['input']>;
  taxNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** transaction_date field predicates */
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  transactionDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  transactionDateLT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  transactionDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  transactionDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wallet_id field predicates */
  walletID?: InputMaybe<Scalars['ID']['input']>;
  walletIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  walletIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WalletTransaction = Node & {
  __typename?: 'WalletTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  transactionType: WalletTransactionTransactionType;
  updatedAt: Scalars['Time']['output'];
  usageID?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<WalletTransactionUsageType>;
  wallet: Wallet;
  walletID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletTransactionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WalletTransaction>;
};

export enum WalletTransactionField {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Notes = 'notes',
  TransactionType = 'transactionType',
  UpdatedAt = 'updatedAt',
  UsageId = 'usageID',
  UsageType = 'usageType',
  WalletId = 'walletID'
}

/** Ordering options for WalletTransaction connections */
export type WalletTransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WalletTransactions. */
  field: WalletTransactionOrderField;
};

/** Properties by which WalletTransaction connections can be ordered. */
export enum WalletTransactionOrderField {
  Amount = 'AMOUNT',
  Notes = 'NOTES',
  TransactionType = 'TRANSACTION_TYPE',
  UsageType = 'USAGE_TYPE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** WalletTransactionTransactionType is enum for the field transaction_type */
export enum WalletTransactionTransactionType {
  Bonus = 'Bonus',
  Credit = 'Credit',
  Debit = 'Debit',
  Refund = 'Refund',
  Topup = 'Topup'
}

/** WalletTransactionUsageType is enum for the field usage_type */
export enum WalletTransactionUsageType {
  License = 'License',
  Transfer = 'Transfer',
  Trip = 'Trip',
  Upgrade = 'Upgrade'
}

/**
 * WalletTransactionWhereInput is used for filtering WalletTransaction objects.
 * Input was generated by ent.
 */
export type WalletTransactionWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WalletTransactionWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** transaction_type field predicates */
  transactionType?: InputMaybe<WalletTransactionTransactionType>;
  transactionTypeIn?: InputMaybe<Array<WalletTransactionTransactionType>>;
  transactionTypeNEQ?: InputMaybe<WalletTransactionTransactionType>;
  transactionTypeNotIn?: InputMaybe<Array<WalletTransactionTransactionType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** usage_id field predicates */
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageIDContains?: InputMaybe<Scalars['String']['input']>;
  usageIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  usageIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  usageIDGT?: InputMaybe<Scalars['String']['input']>;
  usageIDGTE?: InputMaybe<Scalars['String']['input']>;
  usageIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  usageIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  usageIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  usageIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  usageIDLT?: InputMaybe<Scalars['String']['input']>;
  usageIDLTE?: InputMaybe<Scalars['String']['input']>;
  usageIDNEQ?: InputMaybe<Scalars['String']['input']>;
  usageIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  usageIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** usage_type field predicates */
  usageType?: InputMaybe<WalletTransactionUsageType>;
  usageTypeIn?: InputMaybe<Array<WalletTransactionUsageType>>;
  usageTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  usageTypeNEQ?: InputMaybe<WalletTransactionUsageType>;
  usageTypeNotIn?: InputMaybe<Array<WalletTransactionUsageType>>;
  usageTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_id field predicates */
  walletID?: InputMaybe<Scalars['ID']['input']>;
  walletIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  walletIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * WalletWhereInput is used for filtering Wallet objects.
 * Input was generated by ent.
 */
export type WalletWhereInput = {
  and?: InputMaybe<Array<WalletWhereInput>>;
  /** auto_load_limit field predicates */
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitGT?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  autoLoadLimitLT?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_balance field predicates */
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceGT?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceGTE?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  currentBalanceLT?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceLTE?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** walletpaymenttransaction edge predicates */
  hasWalletpaymenttransaction?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletpaymenttransactionWith?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** wallettransaction edge predicates */
  hasWallettransaction?: InputMaybe<Scalars['Boolean']['input']>;
  hasWallettransactionWith?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** negative_limit field predicates */
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitGT?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitGTE?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  negativeLimitLT?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitLTE?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitNEQ?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<WalletWhereInput>;
  or?: InputMaybe<Array<WalletWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type WhatsAppConfig = Node & {
  __typename?: 'WhatsAppConfig';
  companyID: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['Int']['output']>;
  phoneNumberID?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type WhatsAppConfigConnection = {
  __typename?: 'WhatsAppConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhatsAppConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhatsAppConfigEdge = {
  __typename?: 'WhatsAppConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhatsAppConfig>;
};

export enum WhatsAppConfigField {
  CompanyId = 'companyID',
  CreatedAt = 'createdAt',
  Notes = 'notes',
  PhoneNumberId = 'phoneNumberID',
  Token = 'token',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for WhatsAppConfig connections */
export type WhatsAppConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhatsAppConfigs. */
  field: WhatsAppConfigOrderField;
};

/** Properties by which WhatsAppConfig connections can be ordered. */
export enum WhatsAppConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhatsAppConfigWhereInput is used for filtering WhatsAppConfig objects.
 * Input was generated by ent.
 */
export type WhatsAppConfigWhereInput = {
  and?: InputMaybe<Array<WhatsAppConfigWhereInput>>;
  /** company_id field predicates */
  companyID?: InputMaybe<Scalars['Int']['input']>;
  companyIDGT?: InputMaybe<Scalars['Int']['input']>;
  companyIDGTE?: InputMaybe<Scalars['Int']['input']>;
  companyIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyIDLT?: InputMaybe<Scalars['Int']['input']>;
  companyIDLTE?: InputMaybe<Scalars['Int']['input']>;
  companyIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  companyIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WhatsAppConfigWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['Int']['input']>;
  notesGT?: InputMaybe<Scalars['Int']['input']>;
  notesGTE?: InputMaybe<Scalars['Int']['input']>;
  notesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['Int']['input']>;
  notesLTE?: InputMaybe<Scalars['Int']['input']>;
  notesNEQ?: InputMaybe<Scalars['Int']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<WhatsAppConfigWhereInput>>;
  /** phone_number_id field predicates */
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberIDLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** token field predicates */
  token?: InputMaybe<Scalars['String']['input']>;
  tokenContains?: InputMaybe<Scalars['String']['input']>;
  tokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  tokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  tokenGT?: InputMaybe<Scalars['String']['input']>;
  tokenGTE?: InputMaybe<Scalars['String']['input']>;
  tokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  tokenLT?: InputMaybe<Scalars['String']['input']>;
  tokenLTE?: InputMaybe<Scalars['String']['input']>;
  tokenNEQ?: InputMaybe<Scalars['String']['input']>;
  tokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Whitelabel = Node & {
  __typename?: 'Whitelabel';
  brandName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  domains?: Maybe<Array<Domain>>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loginLogo?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<Scalars['ID']['output']>;
  mediafileWhitelabelLoginLogo?: Maybe<MediaFile>;
  mediafileWhitelabelLogo?: Maybe<MediaFile>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  whitelabelconfigs?: Maybe<Array<WhitelabelConfig>>;
  whitelabelcoresettingoverrides?: Maybe<Array<WhitelabelCoreSettingOverride>>;
};

export type WhitelabelConfig = Node & {
  __typename?: 'WhitelabelConfig';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: WhitelabelConfigKey;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WhitelabelConfigConnection = {
  __typename?: 'WhitelabelConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhitelabelConfigEdge = {
  __typename?: 'WhitelabelConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhitelabelConfig>;
};

export enum WhitelabelConfigField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  WhitelabelId = 'whitelabelID'
}

/** WhitelabelConfigKey is enum for the field key */
export enum WhitelabelConfigKey {
  AboutUrl = 'about_url',
  AndroidAppUrl = 'android_app_url',
  DefaultLoginMethod = 'default_login_method',
  DefaultTimezone = 'default_timezone',
  FaqUrl = 'faq_url',
  FaviconMediaId = 'favicon_media_id',
  IosAppUrl = 'ios_app_url',
  LoginCarousel = 'login_carousel',
  LogoMediaId = 'logo_media_id',
  PrivacyPolicyUrl = 'privacy_policy_url',
  TermsConditionUrl = 'terms_condition_url',
  Theme = 'theme'
}

/** Ordering options for WhitelabelConfig connections */
export type WhitelabelConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhitelabelConfigs. */
  field: WhitelabelConfigOrderField;
};

/** Properties by which WhitelabelConfig connections can be ordered. */
export enum WhitelabelConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelConfigWhereInput is used for filtering WhitelabelConfig objects.
 * Input was generated by ent.
 */
export type WhitelabelConfigWhereInput = {
  and?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<WhitelabelConfigKey>;
  keyIn?: InputMaybe<Array<WhitelabelConfigKey>>;
  keyNEQ?: InputMaybe<WhitelabelConfigKey>;
  keyNotIn?: InputMaybe<Array<WhitelabelConfigKey>>;
  not?: InputMaybe<WhitelabelConfigWhereInput>;
  or?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type WhitelabelConnection = {
  __typename?: 'WhitelabelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type WhitelabelCoreSettingOverride = Node & {
  __typename?: 'WhitelabelCoreSettingOverride';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: WhitelabelCoreSettingOverrideKey;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WhitelabelCoreSettingOverrideConnection = {
  __typename?: 'WhitelabelCoreSettingOverrideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelCoreSettingOverrideEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhitelabelCoreSettingOverrideEdge = {
  __typename?: 'WhitelabelCoreSettingOverrideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhitelabelCoreSettingOverride>;
};

export enum WhitelabelCoreSettingOverrideField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  WhitelabelId = 'whitelabelID'
}

/** WhitelabelCoreSettingOverrideKey is enum for the field key */
export enum WhitelabelCoreSettingOverrideKey {
  DefaultJwtSeconds = 'default_jwt_seconds',
  DefaultPaymentGateway = 'default_payment_gateway',
  FcmSenderId = 'fcm_sender_id',
  FcmServerKey = 'fcm_server_key',
  GoogleMapsKey = 'google_maps_key',
  HereMapsKey = 'here_maps_key',
  RazorpayApiKey = 'razorpay_api_key',
  RazorpayApiSecret = 'razorpay_api_secret',
  SmtpHost = 'smtp_host',
  SmtpPass = 'smtp_pass',
  SmtpPort = 'smtp_port',
  SmtpSendEmailAs = 'smtp_send_email_as',
  SmtpSsl = 'smtp_ssl',
  SmtpTls = 'smtp_tls',
  SmtpUser = 'smtp_user',
  TwilioApiKey = 'twilio_api_key',
  TwilioApiSecret = 'twilio_api_secret',
  TwilioAppSid = 'twilio_app_sid',
  TwilioCaller = 'twilio_caller',
  TwilioSid = 'twilio_sid',
  WellenPassword = 'wellen_password',
  WellenSender = 'wellen_sender',
  WellenUsername = 'wellen_username'
}

/** Ordering options for WhitelabelCoreSettingOverride connections */
export type WhitelabelCoreSettingOverrideOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhitelabelCoreSettingOverrides. */
  field: WhitelabelCoreSettingOverrideOrderField;
};

/** Properties by which WhitelabelCoreSettingOverride connections can be ordered. */
export enum WhitelabelCoreSettingOverrideOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelCoreSettingOverrideWhereInput is used for filtering WhitelabelCoreSettingOverride objects.
 * Input was generated by ent.
 */
export type WhitelabelCoreSettingOverrideWhereInput = {
  and?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  keyIn?: InputMaybe<Array<WhitelabelCoreSettingOverrideKey>>;
  keyNEQ?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  keyNotIn?: InputMaybe<Array<WhitelabelCoreSettingOverrideKey>>;
  not?: InputMaybe<WhitelabelCoreSettingOverrideWhereInput>;
  or?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An edge in a connection. */
export type WhitelabelEdge = {
  __typename?: 'WhitelabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Whitelabel>;
};

export enum WhitelabelField {
  BrandName = 'brandName',
  CreatedAt = 'createdAt',
  EnabledLoginMethods = 'enabledLoginMethods',
  IsActive = 'isActive',
  LoginLogo = 'loginLogo',
  Logo = 'logo',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Whitelabel connections */
export type WhitelabelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Whitelabels. */
  field: WhitelabelOrderField;
};

/** Properties by which Whitelabel connections can be ordered. */
export enum WhitelabelOrderField {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelWhereInput is used for filtering Whitelabel objects.
 * Input was generated by ent.
 */
export type WhitelabelWhereInput = {
  and?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** brand_name field predicates */
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNameContains?: InputMaybe<Scalars['String']['input']>;
  brandNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  brandNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  brandNameGT?: InputMaybe<Scalars['String']['input']>;
  brandNameGTE?: InputMaybe<Scalars['String']['input']>;
  brandNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  brandNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  brandNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNameLT?: InputMaybe<Scalars['String']['input']>;
  brandNameLTE?: InputMaybe<Scalars['String']['input']>;
  brandNameNEQ?: InputMaybe<Scalars['String']['input']>;
  brandNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** domains edge predicates */
  hasDomains?: InputMaybe<Scalars['Boolean']['input']>;
  hasDomainsWith?: InputMaybe<Array<DomainWhereInput>>;
  /** mediafile_whitelabel_login_logo edge predicates */
  hasMediafileWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWhitelabelLoginLogoWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_whitelabel_logo edge predicates */
  hasMediafileWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWhitelabelLogoWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** whitelabelconfigs edge predicates */
  hasWhitelabelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelconfigsWith?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** whitelabelcoresettingoverrides edge predicates */
  hasWhitelabelcoresettingoverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelcoresettingoverridesWith?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** login_logo field predicates */
  loginLogo?: InputMaybe<Scalars['ID']['input']>;
  loginLogoIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  loginLogoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  loginLogoNEQ?: InputMaybe<Scalars['ID']['input']>;
  loginLogoNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  loginLogoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** logo field predicates */
  logo?: InputMaybe<Scalars['ID']['input']>;
  logoIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  logoNEQ?: InputMaybe<Scalars['ID']['input']>;
  logoNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WhitelabelWhereInput>;
  or?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type YardDriverProfile = Node & {
  __typename?: 'YardDriverProfile';
  avatar?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  dlExpiry: Scalars['Time']['output'];
  dlImage?: Maybe<Scalars['ID']['output']>;
  dlNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['Time']['output'];
  mediafileAvatar?: Maybe<MediaFile>;
  mediafileDlImage?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardDriverProfileConnection = {
  __typename?: 'YardDriverProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardDriverProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardDriverProfileEdge = {
  __typename?: 'YardDriverProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardDriverProfile>;
};

export enum YardDriverProfileField {
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DlExpiry = 'dlExpiry',
  DlImage = 'dlImage',
  DlNumber = 'dlNumber',
  LastUpdated = 'lastUpdated',
  Name = 'name',
  OrganisationId = 'organisationID',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardDriverProfile connections */
export type YardDriverProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardDriverProfiles. */
  field: YardDriverProfileOrderField;
};

/** Properties by which YardDriverProfile connections can be ordered. */
export enum YardDriverProfileOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardDriverProfileWhereInput is used for filtering YardDriverProfile objects.
 * Input was generated by ent.
 */
export type YardDriverProfileWhereInput = {
  and?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** avatar field predicates */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  avatarIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  avatarNEQ?: InputMaybe<Scalars['ID']['input']>;
  avatarNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** date_of_birth field predicates */
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthGT?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthGTE?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateOfBirthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirthLT?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthLTE?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateOfBirthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dl_expiry field predicates */
  dlExpiry?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dlExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dl_image field predicates */
  dlImage?: InputMaybe<Scalars['ID']['input']>;
  dlImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dlImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dlImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  dlImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dlImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dl_number field predicates */
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  dlNumberContains?: InputMaybe<Scalars['String']['input']>;
  dlNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  dlNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  dlNumberGT?: InputMaybe<Scalars['String']['input']>;
  dlNumberGTE?: InputMaybe<Scalars['String']['input']>;
  dlNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dlNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dlNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dlNumberLT?: InputMaybe<Scalars['String']['input']>;
  dlNumberLTE?: InputMaybe<Scalars['String']['input']>;
  dlNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  dlNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** mediafile_avatar edge predicates */
  hasMediafileAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileAvatarWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_dl_image edge predicates */
  hasMediafileDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileDlImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_updated field predicates */
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdatedLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardDriverProfileWhereInput>;
  or?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** phone_number field predicates */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type YardMaterial = Node & {
  __typename?: 'YardMaterial';
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardMaterialType?: Maybe<YardMaterialType>;
  yardMaterialTypeID?: Maybe<Scalars['ID']['output']>;
  yardTripApprovals?: Maybe<Array<YardTripStatus>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
};

/** A connection to a list of items. */
export type YardMaterialConnection = {
  __typename?: 'YardMaterialConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardMaterialEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardMaterialEdge = {
  __typename?: 'YardMaterialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardMaterial>;
};

export enum YardMaterialField {
  Code = 'code',
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  YardMaterialTypeId = 'yardMaterialTypeID'
}

/** Ordering options for YardMaterial connections */
export type YardMaterialOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardMaterials. */
  field: YardMaterialOrderField;
};

/** Properties by which YardMaterial connections can be ordered. */
export enum YardMaterialOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardMaterialType = Node & {
  __typename?: 'YardMaterialType';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardMaterials?: Maybe<Array<YardMaterial>>;
};

/** A connection to a list of items. */
export type YardMaterialTypeConnection = {
  __typename?: 'YardMaterialTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardMaterialTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardMaterialTypeEdge = {
  __typename?: 'YardMaterialTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardMaterialType>;
};

export enum YardMaterialTypeField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardMaterialType connections */
export type YardMaterialTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardMaterialTypes. */
  field: YardMaterialTypeOrderField;
};

/** Properties by which YardMaterialType connections can be ordered. */
export enum YardMaterialTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardMaterialTypeWhereInput is used for filtering YardMaterialType objects.
 * Input was generated by ent.
 */
export type YardMaterialTypeWhereInput = {
  and?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_materials edge predicates */
  hasYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardMaterialTypeWhereInput>;
  or?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * YardMaterialWhereInput is used for filtering YardMaterial objects.
 * Input was generated by ent.
 */
export type YardMaterialWhereInput = {
  and?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_material_type edge predicates */
  hasYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialTypeWith?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardMaterialWhereInput>;
  or?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** yard_material_type_id field predicates */
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
  yardMaterialTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  yardMaterialTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  yardMaterialTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YardTrip = Node & {
  __typename?: 'YardTrip';
  assignedDriverTracker?: Maybe<DeviceGroup>;
  assignedDriverTrackerID?: Maybe<Scalars['ID']['output']>;
  assignedRoute?: Maybe<YardWarehouseRoute>;
  assignedRouteID?: Maybe<Scalars['ID']['output']>;
  assignedTracker?: Maybe<DeviceGroup>;
  assignedTrackerBatteryLevel?: Maybe<Scalars['Int']['output']>;
  assignedTrackerID?: Maybe<Scalars['ID']['output']>;
  checkInBy?: Maybe<User>;
  checkInByID?: Maybe<Scalars['ID']['output']>;
  checkOutBy?: Maybe<User>;
  checkOutByID?: Maybe<Scalars['ID']['output']>;
  checkinTime?: Maybe<Scalars['Time']['output']>;
  checkoutTime?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  currentTripStatus?: Maybe<Scalars['ID']['output']>;
  declaredMaterial?: Maybe<YardMaterial>;
  declaredMaterialID?: Maybe<Scalars['ID']['output']>;
  driver?: Maybe<YardDriverProfile>;
  driverID?: Maybe<Scalars['ID']['output']>;
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastTripStatus?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  parking?: Maybe<YardWarehouseParking>;
  parkingID?: Maybe<Scalars['ID']['output']>;
  parkingInTime?: Maybe<Scalars['Time']['output']>;
  parkingOutTime?: Maybe<Scalars['Time']['output']>;
  purpose?: Maybe<YardTripPurpose>;
  tripStatus: YardTripTripStatus;
  tripStatusCurrent?: Maybe<YardTripStatus>;
  tripStatusLast?: Maybe<YardTripStatus>;
  updatedAt: Scalars['Time']['output'];
  vehicle?: Maybe<YardVehicle>;
  vehicleID?: Maybe<Scalars['ID']['output']>;
  vendor?: Maybe<YardVendor>;
  vendorID?: Maybe<Scalars['ID']['output']>;
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  warehouseInBy?: Maybe<User>;
  warehouseInByID?: Maybe<Scalars['ID']['output']>;
  warehouseInTime?: Maybe<Scalars['Time']['output']>;
  warehouseOutBy?: Maybe<User>;
  warehouseOutByID?: Maybe<Scalars['ID']['output']>;
  warehouseOutTime?: Maybe<Scalars['Time']['output']>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

export type YardTripApproval = Node & {
  __typename?: 'YardTripApproval';
  approvalMatrix: YardWarehouseApprovalMatrix;
  approvalMatrixID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  reviewReason?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<User>;
  reviewedByID?: Maybe<Scalars['ID']['output']>;
  status: YardTripApprovalStatus;
  trip: YardTrip;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type YardTripApprovalConnection = {
  __typename?: 'YardTripApprovalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripApprovalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripApprovalEdge = {
  __typename?: 'YardTripApprovalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTripApproval>;
};

export enum YardTripApprovalField {
  ApprovalMatrixId = 'approvalMatrixID',
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  ReviewReason = 'reviewReason',
  ReviewedById = 'reviewedByID',
  Status = 'status',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardTripApproval connections */
export type YardTripApprovalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTripApprovals. */
  field: YardTripApprovalOrderField;
};

/** Properties by which YardTripApproval connections can be ordered. */
export enum YardTripApprovalOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** YardTripApprovalStatus is enum for the field status */
export enum YardTripApprovalStatus {
  Approved = 'Approved',
  Hold = 'Hold',
  On = 'On',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

/**
 * YardTripApprovalWhereInput is used for filtering YardTripApproval objects.
 * Input was generated by ent.
 */
export type YardTripApprovalWhereInput = {
  and?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** approval_matrix_id field predicates */
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  approvalMatrixIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalMatrixIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approvalMatrixIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** approval_matrix edge predicates */
  hasApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** reviewed_by edge predicates */
  hasReviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasReviewedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<YardTripApprovalWhereInput>;
  or?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** review_reason field predicates */
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewReasonContains?: InputMaybe<Scalars['String']['input']>;
  reviewReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  reviewReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  reviewReasonGT?: InputMaybe<Scalars['String']['input']>;
  reviewReasonGTE?: InputMaybe<Scalars['String']['input']>;
  reviewReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  reviewReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  reviewReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewReasonLT?: InputMaybe<Scalars['String']['input']>;
  reviewReasonLTE?: InputMaybe<Scalars['String']['input']>;
  reviewReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  reviewReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reviewed_by_id field predicates */
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  reviewedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reviewedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<YardTripApprovalStatus>;
  statusIn?: InputMaybe<Array<YardTripApprovalStatus>>;
  statusNEQ?: InputMaybe<YardTripApprovalStatus>;
  statusNotIn?: InputMaybe<Array<YardTripApprovalStatus>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type YardTripConnection = {
  __typename?: 'YardTripConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripEdge = {
  __typename?: 'YardTripEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTrip>;
};

export enum YardTripField {
  AssignedDriverTrackerId = 'assignedDriverTrackerID',
  AssignedRouteId = 'assignedRouteID',
  AssignedTrackerBatteryLevel = 'assignedTrackerBatteryLevel',
  AssignedTrackerId = 'assignedTrackerID',
  CheckInById = 'checkInByID',
  CheckOutById = 'checkOutByID',
  CheckinTime = 'checkinTime',
  CheckoutTime = 'checkoutTime',
  CreatedAt = 'createdAt',
  CurrentTripStatus = 'currentTripStatus',
  DeclaredMaterialId = 'declaredMaterialID',
  DriverId = 'driverID',
  ExternalId = 'externalID',
  LastTripStatus = 'lastTripStatus',
  OrganisationId = 'organisationID',
  ParkingId = 'parkingID',
  ParkingInTime = 'parkingInTime',
  ParkingOutTime = 'parkingOutTime',
  Purpose = 'purpose',
  TripStatus = 'tripStatus',
  UpdatedAt = 'updatedAt',
  VehicleId = 'vehicleID',
  VendorId = 'vendorID',
  WarehouseId = 'warehouseID',
  WarehouseInById = 'warehouseInByID',
  WarehouseInTime = 'warehouseInTime',
  WarehouseOutById = 'warehouseOutByID',
  WarehouseOutTime = 'warehouseOutTime'
}

/** Ordering options for YardTrip connections */
export type YardTripOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTrips. */
  field: YardTripOrderField;
};

/** Properties by which YardTrip connections can be ordered. */
export enum YardTripOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** YardTripPurpose is enum for the field purpose */
export enum YardTripPurpose {
  Both = 'both',
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type YardTripStatus = Node & {
  __typename?: 'YardTripStatus';
  activityStartTime?: Maybe<Scalars['Time']['output']>;
  activityType?: Maybe<YardWarehouseActivityType>;
  activityTypeID?: Maybe<Scalars['ID']['output']>;
  checkInBy?: Maybe<User>;
  checkInByID?: Maybe<Scalars['ID']['output']>;
  checkOutBy?: Maybe<User>;
  checkOutByID?: Maybe<Scalars['ID']['output']>;
  checkinTime?: Maybe<Scalars['Time']['output']>;
  checkoutTime?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  dock: YardWarehouseDock;
  dockID: Scalars['ID']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  material?: Maybe<YardMaterial>;
  materialID?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  routePath: YardWarehouseRoutePath;
  routePathID: Scalars['ID']['output'];
  trip: YardTrip;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripsCurrent?: Maybe<Array<YardTrip>>;
  yardTripsLast?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardTripStatusConnection = {
  __typename?: 'YardTripStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripStatusEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripStatusEdge = {
  __typename?: 'YardTripStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTripStatus>;
};

export enum YardTripStatusField {
  ActivityStartTime = 'activityStartTime',
  ActivityTypeId = 'activityTypeID',
  CheckInById = 'checkInByID',
  CheckOutById = 'checkOutByID',
  CheckinTime = 'checkinTime',
  CheckoutTime = 'checkoutTime',
  CreatedAt = 'createdAt',
  DockId = 'dockID',
  ExternalId = 'externalID',
  MaterialId = 'materialID',
  OrganisationId = 'organisationID',
  RoutePathId = 'routePathID',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardTripStatus connections */
export type YardTripStatusOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTripStatusSlice. */
  field: YardTripStatusOrderField;
};

/** Properties by which YardTripStatus connections can be ordered. */
export enum YardTripStatusOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardTripStatusWhereInput is used for filtering YardTripStatus objects.
 * Input was generated by ent.
 */
export type YardTripStatusWhereInput = {
  /** activity_start_time field predicates */
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activityStartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activityStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activityStartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activity_type_id field predicates */
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  activityTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activityTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  activityTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** check_in_by_id field predicates */
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_by_id field predicates */
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkin_time field predicates */
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkinTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_time field predicates */
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_id field predicates */
  dockID?: InputMaybe<Scalars['ID']['input']>;
  dockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  dockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activity_type edge predicates */
  hasActivityType?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivityTypeWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** check_in_by edge predicates */
  hasCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** check_out_by edge predicates */
  hasCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckOutByWith?: InputMaybe<Array<UserWhereInput>>;
  /** dock edge predicates */
  hasDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** material edge predicates */
  hasMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  hasMaterialWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_path edge predicates */
  hasRoutePath?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoutePathWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips_current edge predicates */
  hasYardTripsCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsCurrentWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_last edge predicates */
  hasYardTripsLast?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsLastWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** material_id field predicates */
  materialID?: InputMaybe<Scalars['ID']['input']>;
  materialIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  materialIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  materialIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardTripStatusWhereInput>;
  or?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_path_id field predicates */
  routePathID?: InputMaybe<Scalars['ID']['input']>;
  routePathIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routePathIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routePathIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** YardTripTripStatus is enum for the field trip_status */
export enum YardTripTripStatus {
  Approved = 'approved',
  Closed = 'closed',
  InDock = 'in_dock',
  OnHold = 'on_hold',
  Pending = 'pending',
  PendingApproval = 'pending_approval',
  Rejected = 'rejected',
  TransitionDock = 'transition_dock',
  WaitCheckIn = 'wait_check_in',
  WaitParkingCheckIn = 'wait_parking_check_in',
  WaitingPath = 'waiting_path',
  WarehouseCheckOut = 'warehouse_check_out'
}

/**
 * YardTripWhereInput is used for filtering YardTrip objects.
 * Input was generated by ent.
 */
export type YardTripWhereInput = {
  and?: InputMaybe<Array<YardTripWhereInput>>;
  /** assigned_driver_tracker_id field predicates */
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedDriverTrackerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedDriverTrackerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedDriverTrackerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_route_id field predicates */
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedRouteIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedRouteIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedRouteIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_tracker_battery_level field predicates */
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelGT?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelGTE?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedTrackerBatteryLevelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTrackerBatteryLevelLT?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelLTE?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelNEQ?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedTrackerBatteryLevelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_tracker_id field predicates */
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedTrackerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTrackerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedTrackerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_by_id field predicates */
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_by_id field predicates */
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkin_time field predicates */
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkinTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_time field predicates */
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_trip_status field predicates */
  currentTripStatus?: InputMaybe<Scalars['ID']['input']>;
  currentTripStatusIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentTripStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  currentTripStatusNEQ?: InputMaybe<Scalars['ID']['input']>;
  currentTripStatusNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentTripStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** declared_material_id field predicates */
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  declaredMaterialIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declaredMaterialIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  declaredMaterialIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  declaredMaterialIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declaredMaterialIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_id field predicates */
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  driverIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_driver_tracker edge predicates */
  hasAssignedDriverTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedDriverTrackerWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** assigned_route edge predicates */
  hasAssignedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedRouteWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** assigned_tracker edge predicates */
  hasAssignedTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedTrackerWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** check_in_by edge predicates */
  hasCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** check_out_by edge predicates */
  hasCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckOutByWith?: InputMaybe<Array<UserWhereInput>>;
  /** declared_material edge predicates */
  hasDeclaredMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeclaredMaterialWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** driver edge predicates */
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** parking edge predicates */
  hasParking?: InputMaybe<Scalars['Boolean']['input']>;
  hasParkingWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** trip_status_current edge predicates */
  hasTripStatusCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripStatusCurrentWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** trip_status_last edge predicates */
  hasTripStatusLast?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripStatusLastWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** vehicle edge predicates */
  hasVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasVehicleWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** vendor edge predicates */
  hasVendor?: InputMaybe<Scalars['Boolean']['input']>;
  hasVendorWith?: InputMaybe<Array<YardVendorWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_in_by edge predicates */
  hasWarehouseInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** warehouse_out_by edge predicates */
  hasWarehouseOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseOutByWith?: InputMaybe<Array<UserWhereInput>>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_trip_status field predicates */
  lastTripStatus?: InputMaybe<Scalars['ID']['input']>;
  lastTripStatusIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTripStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTripStatusNEQ?: InputMaybe<Scalars['ID']['input']>;
  lastTripStatusNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTripStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardTripWhereInput>;
  or?: InputMaybe<Array<YardTripWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** parking_id field predicates */
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parkingIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parkingIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parkingIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_in_time field predicates */
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeGT?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingInTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingInTimeLT?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingInTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_out_time field predicates */
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingOutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingOutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingOutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purpose field predicates */
  purpose?: InputMaybe<YardTripPurpose>;
  purposeIn?: InputMaybe<Array<YardTripPurpose>>;
  purposeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  purposeNEQ?: InputMaybe<YardTripPurpose>;
  purposeNotIn?: InputMaybe<Array<YardTripPurpose>>;
  purposeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_status field predicates */
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusIn?: InputMaybe<Array<YardTripTripStatus>>;
  tripStatusNEQ?: InputMaybe<YardTripTripStatus>;
  tripStatusNotIn?: InputMaybe<Array<YardTripTripStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_id field predicates */
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vendor_id field predicates */
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  vendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** warehouse_in_by_id field predicates */
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_in_time field predicates */
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeGT?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseInTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseInTimeLT?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseInTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_out_by_id field predicates */
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_out_time field predicates */
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseOutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseOutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseOutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YardVehicle = Node & {
  __typename?: 'YardVehicle';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  insuranceCertificateImage?: Maybe<Scalars['ID']['output']>;
  insuranceExpiry?: Maybe<Scalars['Time']['output']>;
  lastUpdated: Scalars['Time']['output'];
  mediafileVehicleInsuranceImage?: Maybe<MediaFile>;
  mediafileVehiclePollutionImage?: Maybe<MediaFile>;
  mediafileVehicleRc?: Maybe<MediaFile>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  pollutionCertificateImage?: Maybe<Scalars['ID']['output']>;
  pollutionExpiry?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  vehicleNumber: Scalars['String']['output'];
  vehicleRcExpiry: Scalars['Time']['output'];
  vehicleRcImage?: Maybe<Scalars['ID']['output']>;
  vehicleRcNumber: Scalars['String']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardVehicleConnection = {
  __typename?: 'YardVehicleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardVehicleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardVehicleEdge = {
  __typename?: 'YardVehicleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardVehicle>;
};

export enum YardVehicleField {
  CreatedAt = 'createdAt',
  InsuranceCertificateImage = 'insuranceCertificateImage',
  InsuranceExpiry = 'insuranceExpiry',
  LastUpdated = 'lastUpdated',
  OrganisationId = 'organisationID',
  PollutionCertificateImage = 'pollutionCertificateImage',
  PollutionExpiry = 'pollutionExpiry',
  UpdatedAt = 'updatedAt',
  VehicleNumber = 'vehicleNumber',
  VehicleRcExpiry = 'vehicleRcExpiry',
  VehicleRcImage = 'vehicleRcImage',
  VehicleRcNumber = 'vehicleRcNumber'
}

/** Ordering options for YardVehicle connections */
export type YardVehicleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardVehicles. */
  field: YardVehicleOrderField;
};

/** Properties by which YardVehicle connections can be ordered. */
export enum YardVehicleOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardVehicleWhereInput is used for filtering YardVehicle objects.
 * Input was generated by ent.
 */
export type YardVehicleWhereInput = {
  and?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** mediafile_vehicle_insurance_image edge predicates */
  hasMediafileVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehicleInsuranceImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_vehicle_pollution_image edge predicates */
  hasMediafileVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehiclePollutionImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_vehicle_rc edge predicates */
  hasMediafileVehicleRc?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehicleRcWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** insurance_certificate_image field predicates */
  insuranceCertificateImage?: InputMaybe<Scalars['ID']['input']>;
  insuranceCertificateImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  insuranceCertificateImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceCertificateImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  insuranceCertificateImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  insuranceCertificateImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_expiry field predicates */
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_updated field predicates */
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdatedLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<YardVehicleWhereInput>;
  or?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** pollution_certificate_image field predicates */
  pollutionCertificateImage?: InputMaybe<Scalars['ID']['input']>;
  pollutionCertificateImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollutionCertificateImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pollutionCertificateImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  pollutionCertificateImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollutionCertificateImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pollution_expiry field predicates */
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  pollutionExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pollutionExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  pollutionExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_number field predicates */
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vehicle_rc_expiry field predicates */
  vehicleRcExpiry?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  vehicleRcExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_rc_image field predicates */
  vehicleRcImage?: InputMaybe<Scalars['ID']['input']>;
  vehicleRcImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleRcImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleRcImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleRcImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleRcImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vehicle_rc_number field predicates */
  vehicleRcNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleRcNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type YardVendor = Node & {
  __typename?: 'YardVendor';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  vendorCode: Scalars['String']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardVendorConnection = {
  __typename?: 'YardVendorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardVendorEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardVendorEdge = {
  __typename?: 'YardVendorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardVendor>;
};

export enum YardVendorField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  VendorCode = 'vendorCode'
}

/** Ordering options for YardVendor connections */
export type YardVendorOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardVendors. */
  field: YardVendorOrderField;
};

/** Properties by which YardVendor connections can be ordered. */
export enum YardVendorOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardVendorWhereInput is used for filtering YardVendor objects.
 * Input was generated by ent.
 */
export type YardVendorWhereInput = {
  and?: InputMaybe<Array<YardVendorWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardVendorWhereInput>;
  or?: InputMaybe<Array<YardVendorWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vendor_code field predicates */
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  vendorCodeContains?: InputMaybe<Scalars['String']['input']>;
  vendorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  vendorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  vendorCodeGT?: InputMaybe<Scalars['String']['input']>;
  vendorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  vendorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vendorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vendorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCodeLT?: InputMaybe<Scalars['String']['input']>;
  vendorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  vendorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  vendorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type YardWarehouse = Node & {
  __typename?: 'YardWarehouse';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseActivityTypes?: Maybe<Array<YardWarehouseActivityType>>;
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
  yardWarehouseParkings?: Maybe<Array<YardWarehouseParking>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
};

export type YardWarehouseActivityType = Node & {
  __typename?: 'YardWarehouseActivityType';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

/** A connection to a list of items. */
export type YardWarehouseActivityTypeConnection = {
  __typename?: 'YardWarehouseActivityTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseActivityTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseActivityTypeEdge = {
  __typename?: 'YardWarehouseActivityTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseActivityType>;
};

export enum YardWarehouseActivityTypeField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseActivityType connections */
export type YardWarehouseActivityTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseActivityTypes. */
  field: YardWarehouseActivityTypeOrderField;
};

/** Properties by which YardWarehouseActivityType connections can be ordered. */
export enum YardWarehouseActivityTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseActivityTypeWhereInput is used for filtering YardWarehouseActivityType objects.
 * Input was generated by ent.
 */
export type YardWarehouseActivityTypeWhereInput = {
  and?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseActivityTypeWhereInput>;
  or?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type YardWarehouseApprovalMatrix = Node & {
  __typename?: 'YardWarehouseApprovalMatrix';
  approvalMatrix?: Maybe<YardWarehouseApprovalMatrix>;
  approveAfterID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  preApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  role: OrganisationRole;
  roleID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
};

/** A connection to a list of items. */
export type YardWarehouseApprovalMatrixConnection = {
  __typename?: 'YardWarehouseApprovalMatrixConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseApprovalMatrixEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseApprovalMatrixEdge = {
  __typename?: 'YardWarehouseApprovalMatrixEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseApprovalMatrix>;
};

export enum YardWarehouseApprovalMatrixField {
  ApproveAfterId = 'approveAfterID',
  CreatedAt = 'createdAt',
  Label = 'label',
  OrganisationId = 'organisationID',
  RoleId = 'roleID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseApprovalMatrix connections */
export type YardWarehouseApprovalMatrixOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseApprovalMatrixes. */
  field: YardWarehouseApprovalMatrixOrderField;
};

/** Properties by which YardWarehouseApprovalMatrix connections can be ordered. */
export enum YardWarehouseApprovalMatrixOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseApprovalMatrixWhereInput is used for filtering YardWarehouseApprovalMatrix objects.
 * Input was generated by ent.
 */
export type YardWarehouseApprovalMatrixWhereInput = {
  and?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** approve_after_id field predicates */
  approveAfterID?: InputMaybe<Scalars['ID']['input']>;
  approveAfterIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approveAfterIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approveAfterIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approveAfterIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approveAfterIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** approval_matrix edge predicates */
  hasApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** pre_approval_matrix edge predicates */
  hasPreApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseApprovalMatrixWhereInput>;
  or?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type YardWarehouseConnection = {
  __typename?: 'YardWarehouseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type YardWarehouseDock = Node & {
  __typename?: 'YardWarehouseDock';
  createdAt: Scalars['Time']['output'];
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
};

/** A connection to a list of items. */
export type YardWarehouseDockConnection = {
  __typename?: 'YardWarehouseDockConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseDockEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseDockEdge = {
  __typename?: 'YardWarehouseDockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseDock>;
};

export enum YardWarehouseDockField {
  CreatedAt = 'createdAt',
  GeofenceId = 'geofenceID',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseDock connections */
export type YardWarehouseDockOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseDocks. */
  field: YardWarehouseDockOrderField;
};

/** Properties by which YardWarehouseDock connections can be ordered. */
export enum YardWarehouseDockOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseDockWhereInput is used for filtering YardWarehouseDock objects.
 * Input was generated by ent.
 */
export type YardWarehouseDockWhereInput = {
  and?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** geofence_id field predicates */
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** geofence edge predicates */
  hasGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseDockWhereInput>;
  or?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An edge in a connection. */
export type YardWarehouseEdge = {
  __typename?: 'YardWarehouseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouse>;
};

export enum YardWarehouseField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardWarehouse connections */
export type YardWarehouseOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouses. */
  field: YardWarehouseOrderField;
};

/** Properties by which YardWarehouse connections can be ordered. */
export enum YardWarehouseOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardWarehouseParking = Node & {
  __typename?: 'YardWarehouseParking';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  slotName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardWarehouseParkingConnection = {
  __typename?: 'YardWarehouseParkingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseParkingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseParkingEdge = {
  __typename?: 'YardWarehouseParkingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseParking>;
};

export enum YardWarehouseParkingField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  SlotName = 'slotName',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseParking connections */
export type YardWarehouseParkingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseParkings. */
  field: YardWarehouseParkingOrderField;
};

/** Properties by which YardWarehouseParking connections can be ordered. */
export enum YardWarehouseParkingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseParkingWhereInput is used for filtering YardWarehouseParking objects.
 * Input was generated by ent.
 */
export type YardWarehouseParkingWhereInput = {
  and?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardWarehouseParkingWhereInput>;
  or?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** slot_name field predicates */
  slotName?: InputMaybe<Scalars['String']['input']>;
  slotNameContains?: InputMaybe<Scalars['String']['input']>;
  slotNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  slotNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  slotNameGT?: InputMaybe<Scalars['String']['input']>;
  slotNameGTE?: InputMaybe<Scalars['String']['input']>;
  slotNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slotNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slotNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slotNameLT?: InputMaybe<Scalars['String']['input']>;
  slotNameLTE?: InputMaybe<Scalars['String']['input']>;
  slotNameNEQ?: InputMaybe<Scalars['String']['input']>;
  slotNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type YardWarehouseRoute = Node & {
  __typename?: 'YardWarehouseRoute';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  ensureOrder: Scalars['Boolean']['output'];
  /** @deprecated moved away from eta module */
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  preferredYardMaterials?: Maybe<Array<YardMaterial>>;
  routeType: YardWarehouseRouteRouteType;
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
};

/** A connection to a list of items. */
export type YardWarehouseRouteConnection = {
  __typename?: 'YardWarehouseRouteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseRouteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseRouteEdge = {
  __typename?: 'YardWarehouseRouteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseRoute>;
};

export enum YardWarehouseRouteField {
  Active = 'active',
  CreatedAt = 'createdAt',
  EnsureOrder = 'ensureOrder',
  ExternalId = 'externalID',
  Name = 'name',
  OrganisationId = 'organisationID',
  RouteType = 'routeType',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseRoute connections */
export type YardWarehouseRouteOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseRoutes. */
  field: YardWarehouseRouteOrderField;
};

/** Properties by which YardWarehouseRoute connections can be ordered. */
export enum YardWarehouseRouteOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardWarehouseRoutePath = Node & {
  __typename?: 'YardWarehouseRoutePath';
  createdAt: Scalars['Time']['output'];
  dock: YardWarehouseDock;
  dockID: Scalars['ID']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxWaitTime: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  route: YardWarehouseRoute;
  routeID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

/** A connection to a list of items. */
export type YardWarehouseRoutePathConnection = {
  __typename?: 'YardWarehouseRoutePathConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseRoutePathEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseRoutePathEdge = {
  __typename?: 'YardWarehouseRoutePathEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseRoutePath>;
};

export enum YardWarehouseRoutePathField {
  CreatedAt = 'createdAt',
  DockId = 'dockID',
  ExternalId = 'externalID',
  MaxWaitTime = 'maxWaitTime',
  Name = 'name',
  Order = 'order',
  OrganisationId = 'organisationID',
  RouteId = 'routeID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardWarehouseRoutePath connections */
export type YardWarehouseRoutePathOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseRoutePaths. */
  field: YardWarehouseRoutePathOrderField;
};

/** Properties by which YardWarehouseRoutePath connections can be ordered. */
export enum YardWarehouseRoutePathOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseRoutePathWhereInput is used for filtering YardWarehouseRoutePath objects.
 * Input was generated by ent.
 */
export type YardWarehouseRoutePathWhereInput = {
  and?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_id field predicates */
  dockID?: InputMaybe<Scalars['ID']['input']>;
  dockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  dockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dock edge predicates */
  hasDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route edge predicates */
  hasRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** max_wait_time field predicates */
  maxWaitTime?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeGT?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeGTE?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxWaitTimeLT?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeLTE?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseRoutePathWhereInput>;
  or?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  orderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** YardWarehouseRouteRouteType is enum for the field route_type */
export enum YardWarehouseRouteRouteType {
  Auto = 'Auto',
  Manual = 'Manual'
}

/**
 * YardWarehouseRouteWhereInput is used for filtering YardWarehouseRoute objects.
 * Input was generated by ent.
 */
export type YardWarehouseRouteWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** ensure_order field predicates */
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  ensureOrderNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** preferred_yard_materials edge predicates */
  hasPreferredYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreferredYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseRouteWhereInput>;
  or?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_type field predicates */
  routeType?: InputMaybe<YardWarehouseRouteRouteType>;
  routeTypeIn?: InputMaybe<Array<YardWarehouseRouteRouteType>>;
  routeTypeNEQ?: InputMaybe<YardWarehouseRouteRouteType>;
  routeTypeNotIn?: InputMaybe<Array<YardWarehouseRouteRouteType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * YardWarehouseWhereInput is used for filtering YardWarehouse objects.
 * Input was generated by ent.
 */
export type YardWarehouseWhereInput = {
  and?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_activity_types edge predicates */
  hasYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseActivityTypesWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** yard_warehouse_parkings edge predicates */
  hasYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseParkingsWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseWhereInput>;
  or?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};
